/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$2=window.ShadowRoot&&(void 0===window.ShadyCSS||window.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,e$4=Symbol(),n$3=new Map;class s$4{constructor(t,n){if(this._$cssResult$=!0,n!==e$4)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t;}get styleSheet(){let e=n$3.get(this.cssText);return t$2&&void 0===e&&(n$3.set(this.cssText,e=new CSSStyleSheet),e.replaceSync(this.cssText)),e}toString(){return this.cssText}}const o$4=t=>new s$4("string"==typeof t?t:t+"",e$4),r$3=(t,...n)=>{const o=1===t.length?t[0]:n.reduce(((e,n,s)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(n)+t[s+1]),t[0]);return new s$4(o,e$4)},i$2=(e,n)=>{t$2?e.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((t=>{const n=document.createElement("style"),s=window.litNonce;void 0!==s&&n.setAttribute("nonce",s),n.textContent=t.cssText,e.appendChild(n);}));},S$1=t$2?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const n of t.cssRules)e+=n.cssText;return o$4(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var s$3;const e$3=window.trustedTypes,r$2=e$3?e$3.emptyScript:"",h$1=window.reactiveElementPolyfillSupport,o$3={toAttribute(t,i){switch(i){case Boolean:t=t?r$2:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t);}catch(t){s=null;}}return s}},n$2=(t,i)=>i!==t&&(i==i||t==t),l$4={attribute:!0,type:String,converter:o$3,reflect:!1,hasChanged:n$2};class a$1 extends HTMLElement{constructor(){super(),this._$Et=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Ei=null,this.o();}static addInitializer(t){var i;null!==(i=this.l)&&void 0!==i||(this.l=[]),this.l.push(t);}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Eh(s,i);void 0!==e&&(this._$Eu.set(e,s),t.push(e));})),t}static createProperty(t,i=l$4){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e);}}static getPropertyDescriptor(t,i,s){return {get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s);},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$4}static finalize(){if(this.hasOwnProperty("finalized"))return !1;this.finalized=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),this.elementProperties=new Map(t.elementProperties),this._$Eu=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s]);}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(S$1(i));}else void 0!==i&&s.push(S$1(i));return s}static _$Eh(t,i){const s=i.attribute;return !1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}o(){var t;this._$Ep=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Em(),this.requestUpdate(),null===(t=this.constructor.l)||void 0===t||t.forEach((t=>t(this)));}addController(t){var i,s;(null!==(i=this._$Eg)&&void 0!==i?i:this._$Eg=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t));}removeController(t){var i;null===(i=this._$Eg)||void 0===i||i.splice(this._$Eg.indexOf(t)>>>0,1);}_$Em(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Et.set(i,this[i]),delete this[i]);}));}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return i$2(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}));}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}));}attributeChangedCallback(t,i,s){this._$AK(t,s);}_$ES(t,i,s=l$4){var e,r;const h=this.constructor._$Eh(t,s);if(void 0!==h&&!0===s.reflect){const n=(null!==(r=null===(e=s.converter)||void 0===e?void 0:e.toAttribute)&&void 0!==r?r:o$3.toAttribute)(i,s.type);this._$Ei=t,null==n?this.removeAttribute(h):this.setAttribute(h,n),this._$Ei=null;}}_$AK(t,i){var s,e,r;const h=this.constructor,n=h._$Eu.get(t);if(void 0!==n&&this._$Ei!==n){const t=h.getPropertyOptions(n),l=t.converter,a=null!==(r=null!==(e=null===(s=l)||void 0===s?void 0:s.fromAttribute)&&void 0!==e?e:"function"==typeof l?l:null)&&void 0!==r?r:o$3.fromAttribute;this._$Ei=n,this[n]=a(i,t.type),this._$Ei=null;}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||n$2)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$Ei!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$Ep=this._$E_());}async _$E_(){this.isUpdatePending=!0;try{await this._$Ep;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Et&&(this._$Et.forEach(((t,i)=>this[i]=t)),this._$Et=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$Eg)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$EU();}catch(t){throw i=!1,this._$EU(),t}i&&this._$AE(s);}willUpdate(t){}_$AE(t){var i;null===(i=this._$Eg)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t);}_$EU(){this._$AL=new Map,this.isUpdatePending=!1;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$Ep}shouldUpdate(t){return !0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$ES(i,this[i],t))),this._$EC=void 0),this._$EU();}updated(t){}firstUpdated(t){}}a$1.finalized=!0,a$1.elementProperties=new Map,a$1.elementStyles=[],a$1.shadowRootOptions={mode:"open"},null==h$1||h$1({ReactiveElement:a$1}),(null!==(s$3=globalThis.reactiveElementVersions)&&void 0!==s$3?s$3:globalThis.reactiveElementVersions=[]).push("1.3.2");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t$1;const i$1=globalThis.trustedTypes,s$2=i$1?i$1.createPolicy("lit-html",{createHTML:t=>t}):void 0,e$2=`lit$${(Math.random()+"").slice(9)}$`,o$2="?"+e$2,n$1=`<${o$2}>`,l$3=document,h=(t="")=>l$3.createComment(t),r$1=t=>null===t||"object"!=typeof t&&"function"!=typeof t,d=Array.isArray,u=t=>{var i;return d(t)||"function"==typeof(null===(i=t)||void 0===i?void 0:i[Symbol.iterator])},c=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,v=/-->/g,a=/>/g,f$1=/>|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g,_=/'/g,m=/"/g,g=/^(?:script|style|textarea|title)$/i,p=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),$=p(1),b=Symbol.for("lit-noChange"),w=Symbol.for("lit-nothing"),T=new WeakMap,x=(t,i,s)=>{var e,o;const n=null!==(e=null==s?void 0:s.renderBefore)&&void 0!==e?e:i;let l=n._$litPart$;if(void 0===l){const t=null!==(o=null==s?void 0:s.renderBefore)&&void 0!==o?o:null;n._$litPart$=l=new N(i.insertBefore(h(),t),t,void 0,null!=s?s:{});}return l._$AI(t),l},A=l$3.createTreeWalker(l$3,129,null,!1),C=(t,i)=>{const o=t.length-1,l=[];let h,r=2===i?"<svg>":"",d=c;for(let i=0;i<o;i++){const s=t[i];let o,u,p=-1,$=0;for(;$<s.length&&(d.lastIndex=$,u=d.exec(s),null!==u);)$=d.lastIndex,d===c?"!--"===u[1]?d=v:void 0!==u[1]?d=a:void 0!==u[2]?(g.test(u[2])&&(h=RegExp("</"+u[2],"g")),d=f$1):void 0!==u[3]&&(d=f$1):d===f$1?">"===u[0]?(d=null!=h?h:c,p=-1):void 0===u[1]?p=-2:(p=d.lastIndex-u[2].length,o=u[1],d=void 0===u[3]?f$1:'"'===u[3]?m:_):d===m||d===_?d=f$1:d===v||d===a?d=c:(d=f$1,h=void 0);const y=d===f$1&&t[i+1].startsWith("/>")?" ":"";r+=d===c?s+n$1:p>=0?(l.push(o),s.slice(0,p)+"$lit$"+s.slice(p)+e$2+y):s+e$2+(-2===p?(l.push(void 0),i):y);}const u=r+(t[o]||"<?>")+(2===i?"</svg>":"");if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return [void 0!==s$2?s$2.createHTML(u):u,l]};class E{constructor({strings:t,_$litType$:s},n){let l;this.parts=[];let r=0,d=0;const u=t.length-1,c=this.parts,[v,a]=C(t,s);if(this.el=E.createElement(v,n),A.currentNode=this.el.content,2===s){const t=this.el.content,i=t.firstChild;i.remove(),t.append(...i.childNodes);}for(;null!==(l=A.nextNode())&&c.length<u;){if(1===l.nodeType){if(l.hasAttributes()){const t=[];for(const i of l.getAttributeNames())if(i.endsWith("$lit$")||i.startsWith(e$2)){const s=a[d++];if(t.push(i),void 0!==s){const t=l.getAttribute(s.toLowerCase()+"$lit$").split(e$2),i=/([.?@])?(.*)/.exec(s);c.push({type:1,index:r,name:i[2],strings:t,ctor:"."===i[1]?M:"?"===i[1]?H:"@"===i[1]?I:S});}else c.push({type:6,index:r});}for(const i of t)l.removeAttribute(i);}if(g.test(l.tagName)){const t=l.textContent.split(e$2),s=t.length-1;if(s>0){l.textContent=i$1?i$1.emptyScript:"";for(let i=0;i<s;i++)l.append(t[i],h()),A.nextNode(),c.push({type:2,index:++r});l.append(t[s],h());}}}else if(8===l.nodeType)if(l.data===o$2)c.push({type:2,index:r});else {let t=-1;for(;-1!==(t=l.data.indexOf(e$2,t+1));)c.push({type:7,index:r}),t+=e$2.length-1;}r++;}}static createElement(t,i){const s=l$3.createElement("template");return s.innerHTML=t,s}}function P(t,i,s=t,e){var o,n,l,h;if(i===b)return i;let d=void 0!==e?null===(o=s._$Cl)||void 0===o?void 0:o[e]:s._$Cu;const u=r$1(i)?void 0:i._$litDirective$;return (null==d?void 0:d.constructor)!==u&&(null===(n=null==d?void 0:d._$AO)||void 0===n||n.call(d,!1),void 0===u?d=void 0:(d=new u(t),d._$AT(t,s,e)),void 0!==e?(null!==(l=(h=s)._$Cl)&&void 0!==l?l:h._$Cl=[])[e]=d:s._$Cu=d),void 0!==d&&(i=P(t,d._$AS(t,i.values),d,e)),i}class V{constructor(t,i){this.v=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}p(t){var i;const{el:{content:s},parts:e}=this._$AD,o=(null!==(i=null==t?void 0:t.creationScope)&&void 0!==i?i:l$3).importNode(s,!0);A.currentNode=o;let n=A.nextNode(),h=0,r=0,d=e[0];for(;void 0!==d;){if(h===d.index){let i;2===d.type?i=new N(n,n.nextSibling,this,t):1===d.type?i=new d.ctor(n,d.name,d.strings,this,t):6===d.type&&(i=new L(n,this,t)),this.v.push(i),d=e[++r];}h!==(null==d?void 0:d.index)&&(n=A.nextNode(),h++);}return o}m(t){let i=0;for(const s of this.v)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}}class N{constructor(t,i,s,e){var o;this.type=2,this._$AH=w,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cg=null===(o=null==e?void 0:e.isConnected)||void 0===o||o;}get _$AU(){var t,i;return null!==(i=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==i?i:this._$Cg}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=P(this,t,i),r$1(t)?t===w||null==t||""===t?(this._$AH!==w&&this._$AR(),this._$AH=w):t!==this._$AH&&t!==b&&this.$(t):void 0!==t._$litType$?this.T(t):void 0!==t.nodeType?this.k(t):u(t)?this.S(t):this.$(t);}M(t,i=this._$AB){return this._$AA.parentNode.insertBefore(t,i)}k(t){this._$AH!==t&&(this._$AR(),this._$AH=this.M(t));}$(t){this._$AH!==w&&r$1(this._$AH)?this._$AA.nextSibling.data=t:this.k(l$3.createTextNode(t)),this._$AH=t;}T(t){var i;const{values:s,_$litType$:e}=t,o="number"==typeof e?this._$AC(t):(void 0===e.el&&(e.el=E.createElement(e.h,this.options)),e);if((null===(i=this._$AH)||void 0===i?void 0:i._$AD)===o)this._$AH.m(s);else {const t=new V(o,this),i=t.p(this.options);t.m(s),this.k(i),this._$AH=t;}}_$AC(t){let i=T.get(t.strings);return void 0===i&&T.set(t.strings,i=new E(t)),i}S(t){d(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const o of t)e===i.length?i.push(s=new N(this.M(h()),this.M(h()),this,this.options)):s=i[e],s._$AI(o),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,i){var s;for(null===(s=this._$AP)||void 0===s||s.call(this,!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i;}}setConnected(t){var i;void 0===this._$AM&&(this._$Cg=t,null===(i=this._$AP)||void 0===i||i.call(this,t));}}class S{constructor(t,i,s,e,o){this.type=1,this._$AH=w,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=o,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=w;}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,i=this,s,e){const o=this.strings;let n=!1;if(void 0===o)t=P(this,t,i,0),n=!r$1(t)||t!==this._$AH&&t!==b,n&&(this._$AH=t);else {const e=t;let l,h;for(t=o[0],l=0;l<o.length-1;l++)h=P(this,e[s+l],i,l),h===b&&(h=this._$AH[l]),n||(n=!r$1(h)||h!==this._$AH[l]),h===w?t=w:t!==w&&(t+=(null!=h?h:"")+o[l+1]),this._$AH[l]=h;}n&&!e&&this.C(t);}C(t){t===w?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"");}}class M extends S{constructor(){super(...arguments),this.type=3;}C(t){this.element[this.name]=t===w?void 0:t;}}const k=i$1?i$1.emptyScript:"";class H extends S{constructor(){super(...arguments),this.type=4;}C(t){t&&t!==w?this.element.setAttribute(this.name,k):this.element.removeAttribute(this.name);}}class I extends S{constructor(t,i,s,e,o){super(t,i,s,e,o),this.type=5;}_$AI(t,i=this){var s;if((t=null!==(s=P(this,t,i,0))&&void 0!==s?s:w)===b)return;const e=this._$AH,o=t===w&&e!==w||t.capture!==e.capture||t.once!==e.once||t.passive!==e.passive,n=t!==w&&(e===w||o);o&&this.element.removeEventListener(this.name,this,e),n&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){var i,s;"function"==typeof this._$AH?this._$AH.call(null!==(s=null===(i=this.options)||void 0===i?void 0:i.host)&&void 0!==s?s:this.element,t):this._$AH.handleEvent(t);}}class L{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){P(this,t);}}const z=window.litHtmlPolyfillSupport;null==z||z(E,N),(null!==(t$1=globalThis.litHtmlVersions)&&void 0!==t$1?t$1:globalThis.litHtmlVersions=[]).push("2.2.3");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var l$2,o$1;class s$1 extends a$1{constructor(){super(...arguments),this.renderOptions={host:this},this._$Dt=void 0;}createRenderRoot(){var t,e;const i=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=i.firstChild),i}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Dt=x(i,this.renderRoot,this.renderOptions);}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Dt)||void 0===t||t.setConnected(!0);}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Dt)||void 0===t||t.setConnected(!1);}render(){return b}}s$1.finalized=!0,s$1._$litElement$=!0,null===(l$2=globalThis.litElementHydrateSupport)||void 0===l$2||l$2.call(globalThis,{LitElement:s$1});const n=globalThis.litElementPolyfillSupport;null==n||n({LitElement:s$1});(null!==(o$1=globalThis.litElementVersions)&&void 0!==o$1?o$1:globalThis.litElementVersions=[]).push("3.2.0");

/* eslint-disable no-console */

class KemetIcon extends s$1 {
  static get properties() {
    return {
      /**
       * The name of the icon to reference.
       */
      icon: {
        type: String,
      },
      /**
       * The sprite map from an open source project that an icon belongs too.
       * Values include:
       * (bootstrap | font-awesome-brand | font-awesome-regular | font-awesome-solid)
       */
      set: {
        type: String,
      },
      /**
       * The width and height of the icon in pixels.
       */
      size: {
        type: Number,
      },
    };
  }

  static get styles() {
    return [
      r$3`
        :host {
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      `,
    ];
  }

  constructor() {
    super();

    this.set = 'bootstrap';
    this.icon = 'alarm';
    this.size = 16;
  }

  updated() {
    this.getIcon();
    this.style.width = `${this.size}px`;
    this.style.height = `${this.size}px`;
  }

  render() {
    return $``;
  }

  async getIcon() {
    const parser = new DOMParser();
    let svgString;

    try {
      svgString = await fetch(`${this.getUrl()}/${this.icon}.svg`)
        .then(response => response.text());

      if (svgString.indexOf('</svg>') < 0) {
        throw new Error('Not a valid svg.');
      }
    } catch (error) {
      svgString = '';
      console.error(error);
    }

    const svgElement = parser.parseFromString(svgString, 'image/svg+xml').documentElement;
    const svgPrevious = this.shadowRoot.querySelector('svg');

    if (svgElement.tagName === 'svg') {
      svgElement.setAttribute('id', this.icon);
      svgElement.setAttribute('width', `${this.size}px`);
      svgElement.setAttribute('height', `${this.size}px`);
      svgElement.setAttribute('fill', 'currentColor');

      if (svgPrevious) svgPrevious.remove();
      this.shadowRoot.appendChild(svgElement);
    } else {
      console.error(`Could not find icon "${this.icon}" in set "${this.set}"`);

      const errorIconString = `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="kemet-error" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" width="${this.size}" height="${this.size}">
          <style type="text/css">
            .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
            .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EC1C24;}
          </style>
          <g><path class="st0" d="M256,0c70.7,0,134.7,28.7,181,75c46.3,46.3,75,110.3,75,181c0,70.7-28.7,134.7-75,181   c-46.3,46.3-110.3,75-181,75c-70.7,0-134.7-28.7-181-75C28.7,390.7,0,326.7,0,256c0-70.7,28.7-134.7,75-181S185.3,0,256,0z"/><path class="st1" d="M512,256c0-70.7-28.7-134.7-75-181C390.7,28.7,326.7,0,256,0C193,0,135.5,22.8,90.9,60.6l-0.1-0.1   C85.3,65.1,80,69.9,75,75c-5,5.1-9.9,10.3-14.5,15.8l0.1,0.1C22.8,135.5,0,193,0,256c0,70.7,28.7,134.7,75,181   c46.3,46.3,110.3,75,181,75c63,0,120.5-22.8,165.1-60.6l0.1,0.1c5.4-4.6,10.7-9.5,15.8-14.5c5-5,9.9-10.3,14.5-15.8l-0.1-0.1   C489.2,376.6,512,319,512,256z M256,42.9c58.9,0,112.1,23.9,150.7,62.4c38.6,38.6,62.4,91.9,62.4,150.7c0,51.1-18.1,98-48.1,134.8   L121.2,90.9C158,60.9,204.9,42.9,256,42.9z M256,469.1c-58.8,0-112.1-23.9-150.7-62.4C66.7,368.1,42.9,314.9,42.9,256   c0-51.1,18.1-98,48.1-134.8l299.8,299.8C354,451.1,307.1,469.1,256,469.1z"/></g>
        </svg>
      `;

      const errorIconElement = parser.parseFromString(errorIconString, 'image/svg+xml').documentElement;

      if (svgPrevious) svgPrevious.remove();
      this.shadowRoot.appendChild(errorIconElement);
    }
  }

  getUrl() {
    let url;

    switch (this.set) {
      case 'bootstrap': url = 'https://unpkg.com/bootstrap-icons@latest/icons'; break;
      case 'font-awesome-brands': url = 'https://unpkg.com/@fortawesome/fontawesome-free@latest/svgs/brands'; break;
      case 'font-awesome-regular': url = 'https://unpkg.com/@fortawesome/fontawesome-free@latest/svgs/regular'; break;
      case 'font-awesome-solid': url = 'https://unpkg.com/@fortawesome/fontawesome-free@latest/svgs/solid'; break;
      default: url = 'https://unpkg.com/bootstrap-icons@latest/icons';
    }

    return url;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-icon') || customElements.define('kemet-icon', KemetIcon);

class KemetAccordionPanel extends s$1 {
  static get styles() {
    return [
      r$3`
        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }

        :host {
          display: block;
          padding: 1.5rem 1rem;
          border-bottom: 1px solid var(--kemet-color-primary);
        }

        .trigger {
          cursor: pointer;
          display: grid;
          gap: 1rem;
          grid-template-columns: 1fr auto;
          width: 100%;
          text-align: left;
          padding: 0;
          border: none;
          background: none;
        }

        .body {
          overflow: hidden;
          transition: all var(--kemet-accordion-panel-transition-speed, 300ms) ease;
        }

        ::slotted([slot='body']) {
          padding: 1rem 0;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * Determines the opened state of the panel
       */
      opened: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Sets the max height of the panel's body
       */
      maxHeight: {
        type: String,
        attribute: 'max-height',
      },
      /**
       * Uniquely identifies a panel for accessibility purposes
       */
      slug: {
        type: String,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.opened = undefined;
    this.maxHeight = '0px';
    this.slug = 'panel';
  }

  firstUpdated() {
    this.focusableSelector = 'body, a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    this.bodyElement = this.querySelector('[slot="body"]');
    this.bodyElementFirst = this.bodyElement.querySelector(':first-child');
    this.bodyElementLast = this.bodyElement.querySelector(':last-child');

    if (this.bodyElementFirst) this.bodyElementFirst.style.marginTop = 0;
    if (this.bodyELementLast) this.bodyElementLast.style.marginBottom = 0;
  }

  updated(prevProps) {
    if (!prevProps.get('opened') && this.opened === true) {
      this.maxHeight = `${this.bodyElement.offsetHeight}px`;

      /**
       * Fires when a panel is opened
       */
      this.dispatchEvent(
        new CustomEvent('kemet-accordion-panel-opened', {
          bubbles: true,
          composed: true,
          detail: this,
        }),
      );
    }

    if (prevProps.get('opened') && this.opened === false) {
      this.maxHeight = '0px';

      /**
       * Fires when a panel is closed
       */
      this.dispatchEvent(
        new CustomEvent('kemet-accordion-panel-closed', {
          bubbles: true,
          composed: true,
          detail: this,
        }),
      );
    }

    this.a11y();
    this.focusableBodyElements();
  }

  render() {
    return $`
      <button
        class="trigger"
        part="trigger"
        @click=${() => this.toggle()}
        @keydown=${event => this.handleKeyDown(event)}
      >
        <slot name="trigger"></slot>
        <slot name="icon"></slot>
      </button>
      <section class="body" part="body" style="max-height:${this.maxHeight};">
        <slot name="body"></slot>
      </section>
    `;
  }

  toggle() {
    this.opened = !this.opened;
  }

  focusableBodyElements() {
    const focusableElements = this.bodyElement.querySelectorAll(this.focusableSelector);

    if (this.opened) {
      focusableElements.forEach((element) => {
        element.removeAttribute('tabindex');
      });
    } else {
      focusableElements.forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
    }
  }

  a11y() {
    const trigger = this.shadowRoot.querySelector('.trigger');
    const body = this.shadowRoot.querySelector('.body');

    trigger.setAttribute('id', `${this.slug}-button`);
    trigger.setAttribute('aria-controls', `${this.slug}-content`);

    body.setAttribute('id', `${this.slug}-content`);
    body.setAttribute('aria-labelledby', `${this.slug}-button`);
    body.setAttribute('aria-hidden', `${!this.opened}`);
  }

  handleKeyDown(event) {
    if (event.key === 'Space' || event.key === 'Enter') {
      this.toggle();
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-accordion-panel') || customElements.define('kemet-accordion-panel', KemetAccordionPanel);

class KemetAccordion extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: block;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The index value for the most recently opened panel
       */
      currentPanel: {
        type: Number,
      },
      /**
       * Support for closing all inactive panels when one is opened
       */
      togglePanels: {
        type: Boolean,
        attribute: 'toggle-panels',
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.togglePanels = false;
    this.currentPanel = undefined;

    // bindings
    this.addEventListener('kemet-accordion-panel-opened', this.handlePanelOpened.bind(this));
  }

  firstUpdated() {
    this.onKeyDown = event => this.handleKeyDown(event);
  }

  render() {
    return $`<slot @slotchange=${event => this.handleSlotChange(event)}></slot>`;
  }

  handleSlotChange() {
    this.panels = this.querySelectorAll('kemet-accordion-panel');

    this.panels.forEach((panel) => {
      panel.removeEventListener('keydown', this.onKeyDown);
      panel.addEventListener('keydown', this.onKeyDown);
    });
  }

  handlePanelOpened(event) {
    if (this.togglePanels) {
      this.panels.forEach((panel) => {
        if (panel !== event.detail) {
          panel.opened = false;
        }
      });
    }
  }

  navigatePanels(direction) {
    switch (direction) {
      case 'home':
        this.currentPanel = 0;
        break;
      case 'end':
        this.currentPanel = this.panels.length - 1;
        break;
      case 'next':
        this.currentPanel += 1;
        break;
      case 'prev':
        this.currentPanel -= 1;
        break;
      default:
        this.currentPanelFocus = 0;
        break;
    }

    if (this.currentPanel > this.panels.length - 1) this.currentPanel = 0;
    if (this.currentPanel < 0) this.currentPanel = this.panels.length - 1;

    this.panels[this.currentPanel].shadowRoot.querySelector('button').focus();
  }

  handleKeyDown(event) {
    switch (event.key) {
      case 'Enter':
      case 'Space':
        event.preventDefault();
        event.target.click();
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault();
        this.navigatePanels('prev');
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault();
        this.navigatePanels('next');
        break;
      case 'End':
        event.preventDefault();
        this.navigatePanels('end');
        break;
      case 'Home':
        event.preventDefault();
        this.navigatePanels('home');
        break;
    }
  }

  expandAll() {
    this.panels.forEach((panel) => {
      panel.opened = true;
    });
  }

  collapseAll() {
    this.panels.forEach((panel) => {
      panel.opened = false;
    });
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-accordion') || customElements.define('kemet-accordion', KemetAccordion);

class KemetBadge extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: var(--kemet-badge-padding, 10px);
          line-height: 1;
          color: var(--kemet-color-white);
        }

        :host([status='primary']) {
          background-color: var(--kemet-color-primary);
        }

        :host([status='success']) {
          background-color: var(--kemet-color-success);
        }

        :host([status='standard']) {
          background-color: var(--kemet-color-gray6);
        }

        :host([status='warning']) {
          background-color: var(--kemet-color-warning);
        }

        :host([status='error']) {
          background-color: var(--kemet-color-error);
        }

        :host([circle]) {
          border-radius: 50%;
        }

        :host([pill]) {
          border-radius: 99rem;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The status of the badge
       */
      status: {
        type: String,
        reflect: true,
      },
      /**
       * Displays the badge in a circle
       */
      circle: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Rounds the corners on the badge
       */
      pill: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Padding on the badge as a circle
       */
      circlePadding: {
        type: Number,
        attribute: 'circle-padding',
      },
    };
  }

  constructor() {
    super();

    this.status = 'primary';
    this.pill = false;
    this.circle = false;
    this.circlePadding = 0;
  }

  render() {
    return $`<slot @slotchange=${() => this.handleSlotChange()}></slot>`;
  }

  handleSlotChange() {
    if (this.circle) {
      this.style.height = `${this.offsetWidth + this.circlePadding}px`;
      this.style.width = `${this.offsetWidth + this.circlePadding}px`;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-badge') || customElements.define('kemet-badge', KemetBadge);

class FormSubmitController {
  host;
  form;
  options;

  constructor(host, options) {
    (this.host = host).addController(this);
    this.options = {
      form: (input) => input.closest('form'),
      name: (input) => input.name,
      value: (input) => input.value,
      disabled: (input) => input.disabled,
      checkValidity: (input) => (typeof input.checkValidity === 'function' ? input.checkValidity() : true),
      ...options,
    };

    this.handleFormData = this.handleFormData.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  hostConnected() {
    this.form = this.options.form(this.host);

    if (this.form) {
      this.form.addEventListener('formdata', this.handleFormData);
      this.form.addEventListener('submit', this.handleFormSubmit);
    }
  }

  hostDisconnected() {
    if (this.form) {
      this.form.removeEventListener('formdata', this.handleFormData);
      this.form.removeEventListener('submit', this.handleFormSubmit);
      this.form = undefined;
    }
  }

  handleFormData(event) {
    const disabled = this.options.disabled(this.host);
    const name = this.options.name(this.host);
    const value = this.options.value(this.host);

    if (!disabled && typeof name === 'string' && typeof value !== 'undefined') {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          event.formData?.append(name, val.toString());
        });
      } else {
        event.formData?.append(name, value.toString());
      }
    }
  }

  handleFormSubmit(event) {
    const disabled = this.options.disabled(this.host);
    const checkValidity = this.options.checkValidity;

    this.form = this.options.form(this.host);

    if (this.form && !this.form.noValidate && !disabled && !checkValidity(this.host)) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const components = this.form.querySelectorAll('kemet-input, kemet-textarea, kemet-select, kemet-checkbox, kemet-radios');

      components.forEach((component) => {
        component.checkValidity();

        if (!component.checkValidity()) {
          component.status = 'error';
          component.invalid = true;

          component.dispatchEvent(
            new CustomEvent('kemet-input-status', {
              bubbles: true,
              composed: true,
              detail: {
                status: 'error',
                validity: component.validity ? component.validity : {},
                element: component,
              },
            })
          );
        }

        if (component.checkLimitValidity && !component.checkLimitValidity()) {
          component.status = 'error';
          component.invalid = true;

          component.dispatchEvent(
            new CustomEvent('kemet-input-status', {
              bubbles: true,
              composed: true,
              detail: {
                status: 'error',
                validity: { passedLimit: true },
                element: component,
              },
            })
          );
        }
      });
    }
  }

  submit() {
    const button = document.createElement('button');

    if (this.form) {
      button.type = 'submit';
      button.style.position = 'absolute';
      button.style.width = '0';
      button.style.height = '0';
      button.style.clip = 'rect(0 0 0 0)';
      button.style.clipPath = 'inset(50%)';
      button.style.overflow = 'hidden';
      button.style.whiteSpace = 'nowrap';
      this.form.append(button);
      button.click();
      button.remove();
    }
  }
}

class KemetButton extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: var(--kemet-button-font-size, inherit);
          color: var(--kemet-button-color, var(--kemet-color-white));
          width: var(--kemet-button-width, auto);
          height: var(--kemet-button-height, auto);
          border: var(--kemet-button-border, 0);
          border-radius: var(--kemet-button-border-radius, 0);
          transition: filter var(--kemet-button-transition-speed, 300ms) ease;
          background-color: var(--kemet-button-background-color, var(--kemet-color-primary));
        }

        :host(:hover:not([disabled])) {
          filter: brightness(var(--kemet-button-hover-brightness, 1.25));
        }

        :host([disabled]) {
          opacity: var(--kemet-button-disabled-opacity, 0.5);
        }

        .button {
          cursor: pointer;
          text-decoration: none;
          display: flex;
          gap: var(--kemet-button-gap, 0.5rem);
          align-items: center;
          color: inherit;
          font-size: inherit;
          padding: var(--kemet-button-padding, 1rem 1.25rem);
          border: 0;
          background: none;
        }

        :host([disabled]) .button {
          cursor: not-allowed;
        }

        :host([type='text']) {
          --kemet-button-color: var(--kemet-color-primary);
          --kemet-button-background-color: none;
        }

        :host([type='text']:hover) {
          text-decoration: var(--kemet-button-hover-decoration, underline);
        }

        :host([type='circle']) {
          --kemet-button-border-radius: 50%;
          --kemet-button-width: var(--kemet-button-circle-size, 50px);
          --kemet-button-height: var(--kemet-button-circle-size, 50px);
        }

        :host([type='rounded']) {
          --kemet-button-border-radius: var(--kemet-button-rounded-amount, 6px);
        }

        :host([type='pill']) {
          --kemet-button-border-radius: 10rem;
        }

        :host([outlined]) {
          --kemet-button-color: var(--kemet-color-primary);
          --kemet-button-background-color: var(--kemet-color-white);
          --kemet-button-border: var(--kemet-button-border-width, 1px) var(--kemet-button-border-style, solid) var(--kemet-button-border-color, var(--kemet-color-primary));
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * Determines whether or not the button is active
       */
      active: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Is true when the button is hovered
       */
      hover: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Is true when the button is focused
       */
      focused: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The url a button should link too
       */
      link: {
        type: String,
      },
      /**
       * Outline style for a button
       */
      outlined: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Determines whether not a button is disabled
       */
      disabled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Controls the type of button
       * standard | text | circle | rounded | pill
       */
      type: {
        type: String,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    this.addEventListener('click', this.handleClick.bind(this));
    this.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.addEventListener('mouseout', this.handleMouseOut.bind(this));
    this.addEventListener('blur', this.handleBlur.bind(this));
    this.addEventListener('keyup', event => this.handleKeyUp(event));

    this.type = 'standard';
    this.outline = false;
    this.disable = false;

    /**
      * Used only for form reactive controller
      */
    this.formSubmitController = new FormSubmitController(this);
  }

  render() {
    if (this.link && !this.disabled) {
      return $`
        <a href=${this.link} class="button" role="button" part="button">
          <slot name="left"></slot>
          <slot></slot>
          <slot name="right"></slot>
        </a>
      `;
    }

    return $`
      <button class="button" part="button" ?disabled=${this.disabled} aria-disabled=${this.disabled ? 'true' : 'false'}>
        <slot name="left"></slot>
        <slot></slot>
        <slot name="right"></slot>
      </button>
    `;
  }

  /**
   * Sets hover to true onMouseOver
   * @private
   */
  handleMouseOver() {
    this.hover = true;
  }

  /**
   * Sets hover to false onMouseOut
   * @private
   */
  handleMouseOut() {
    this.hover = false;
  }

  /**
   * Handles click behavior
   * @private
   */
  handleClick() {
    this.hover = false;
    this.active = true;

    setTimeout(() => {
      this.active = false;
    }, 300);

    if (this.shadowRoot.querySelector('button')) {
      this.formSubmitController.submit(this);
    }
  }

  /**
   * Handles blur
   * @private
   */
  handleBlur() {
    this.focused = false;
    this.active = false;
    this.hover = false;
  }

  /**
   * Handles keyup
   * @private
   * @param {object} event - event object
   */
  handleKeyUp(event) {
    if (event.key === 'Tab') {
      this.focused = true;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-button') || customElements.define('kemet-button', KemetButton);

/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const l$1=l=>null!=l?l:w;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},e$1=t=>(...e)=>({_$litDirective$:t,values:e});class i{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i;}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}}

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const r=o=>void 0===o.strings,f={},s=(o,i=f)=>o._$AH=i;

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const l=e$1(class extends i{constructor(r$1){if(super(r$1),r$1.type!==t.PROPERTY&&r$1.type!==t.ATTRIBUTE&&r$1.type!==t.BOOLEAN_ATTRIBUTE)throw Error("The `live` directive is not allowed on child or event bindings");if(!r(r$1))throw Error("`live` bindings can only contain a single expression")}render(r){return r}update(i,[t$1]){if(t$1===b||t$1===w)return t$1;const o=i.element,l=i.name;if(i.type===t.PROPERTY){if(t$1===o[l])return b}else if(i.type===t.BOOLEAN_ATTRIBUTE){if(!!t$1===o.hasAttribute(l))return b}else if(i.type===t.ATTRIBUTE&&o.getAttribute(l)===t$1+"")return b;return s(i),t$1}});

class KemetCheckbox extends s$1 {
  static get styles() {
    return [
      r$3`
        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }

        :host {
          display: inline-block;
        }

        :host([disabled]) {
          opacity: 0.5;
        }

        label {
          display: inline-flex;
          gap: 0.5rem;
          align-items: center;
        }

        input {
          cursor: pointer;
          margin: 0;
          padding: 0;
          width: var(--kemet-checkbox-size, 18px);
          height: var(--kemet-checkbox-size, 18px);
          position: absolute;
          opacity: 0;
        }

        button {
          margin: 0;
          border: none;
          background: none;
        }

        [part='checkbox'] {
          color: var(--kemet-checkbox-color, var(--kemet-color-primary));
          display: flex;
          align-items: center;
          justify-content: center;
          width: var(--kemet-checkbox-size, 18px);
          height: var(--kemet-checkbox-size, 18px);
          border: var(--kemet-checkbox-border, 1px solid var(--kemet-color-primary));
        }

        :host([rounded]) [part='checkbox'] {
          border-radius: var(--kemet-checkbox-border-radius, 4px);
        }

        :host([filled][checked]) [part='checkbox'],
        :host([filled][indeterminate]) [part='checkbox'] {
          border: none;
          background-color: var(--kemet-checkbox-filled-background-color, var(--kemet-color-primary));
        }

        [part='mark'] {
          display: flex;
          width: calc(var(--kemet-checkbox-size, 18px) - 4px);
          height: calc(var(--kemet-checkbox-size, 18px) - 4px);
        }

        :host([filled][checked]) [part='mark'],
        :host([filled][indeterminate]) [part='mark'] {
          color: var(--kemet-checkbox-filled-color, var(--kemet-color-white));
        }

        [part='message'] {
          display: block;
          margin-top: 0.5rem;
        }

        :host([status='error']) [part='message'] {
          color: var(--kemet-color-error);
        }

        :host([status='warning']) [part='message'] {
          color: var(--kemet-color-error);
        }
      `,
    ];
  }

  static get properties() {
    return {
      label: {
        type: String,
      },
      checked: {
        type: Boolean,
        reflect: true,
      },
      indeterminate: {
        type: Boolean,
        reflect: true,
      },
      name: {
        type: String,
      },
      value: {
        type: String,
      },
      disabled: {
        type: Boolean,
        reflect: true,
      },
      required: {
        type: Boolean,
        reflect: true,
      },
      focused: {
        type: Boolean,
        reflect: true,
      },
      rounded: {
        type: Boolean,
        reflect: true,
      },
      filled: {
        type: Boolean,
        reflect: true,
      },
      status: {
        type: String,
        reflect: true,
      },
      message: {
        type: String,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.label = '';
    this.name = 'checkbox';
    this.disabled = false;
    this.required = false;
    this.rounded = false;
    this.filled = false;
    this.status = 'standard';

    /**
     * Used only for form reactive controller
     */
    this.formSubmitController = new FormSubmitController(this);
  }

  firstUpdated() {
    this.input = this.shadowRoot.querySelector('input');
  }

  render() {
    return $`
      <label part="label">
        <input
          type="checkbox"
          name=${l$1(this.name)}
          .value=${this.value}
          .indeterminate=${l(this.indeterminate)}
          .checked=${l(this.checked)}
          .disabled=${this.disabled}
          .required=${this.required}
          aria-checked=${this.checked ? 'true' : 'false'}
          @click=${() => this.handleClick()}
          @blur=${() => this.handleBlur()}
          @focus=${() => this.handleFocus()}
          @change=${() => this.handleChange()}
        />
        <button part="checkbox" aria-label=${this.label}>
          ${this.makeCheckMark()}
        </button>
        <span part="text">${this.label}</span>
      </label>
      ${this.makeMessage()}
    `;
  }

  click() {
    this.input.click();
  }

  handleClick() {
    this.checked = !this.checked;
    this.indeterminate = false;

    /**
     * Fires when the state of the checkbox changes
     */
    this.dispatchEvent(
      new CustomEvent('kemet-checkbox-change', {
        bubbles: true,
        composed: true,
        detail: this,
      }),
    );
  }

  handleBlur() {
    this.focused = false;

    /**
     * Fires when the checkbox loses or receives focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-checkbox-focused', {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    );
  }

  handleFocus() {
    this.focused = true;
    /**
     * Fires when the checkbox loses or receives focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-checkbox-focused', {
        bubbles: true,
        composed: true,
        detail: true,
      }),
    );
  }

  handleChange() {
    this.value = this.checked;

    if (this.input.checkValidity()) {
      this.status = 'standard';
    }
  }

  makeMessage() {
    if (this.status === 'error' || this.status === 'warning') {
      return $`<span part="message">${this.message}</span>`;
    }

    return null;
  }

  makeCheckMark() {
    if (this.checked) {
      return $`
        <span part="mark">
          <svg viewBox="0 0 16 16">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
              <g stroke="currentColor" stroke-width="2">
                <g transform="translate(3.428571, 3.428571)">
                  <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
                  <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
                </g>
              </g>
            </g>
          </svg>
        </span>
      `;
    }

    if (!this.checked && this.indeterminate) {
      return $`
        <span part="mark">
          <svg viewBox="0 0 16 16">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
              <g stroke="currentColor" stroke-width="2">
                <g transform="translate(2.285714, 6.857143)">
                  <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
                </g>
              </g>
            </g>
          </svg>
        </span>
      `;
    }

    return null;
  }

  checkValidity() {
    return this.input.checkValidity();
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-checkbox') || customElements.define('kemet-checkbox', KemetCheckbox);

class KemetCarouselCurrent extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: inline-block;
        }
      `,
    ];
  }

  static get properties() {
    return {
      current: {
        type: Number,
      },
    };
  }

  firstUpdated() {
    this.carousel = this.closest('kemet-carousel');
  }

  updated() {
    this.current = this.carousel.index + 1;
  }

  render() {
    return $`${this.current}`;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel-current') || customElements.define('kemet-carousel-current', KemetCarouselCurrent);

class KemetCarouselFirst extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          cursor: pointer;
        }

        :host([disabled]) {
          cursor: not-allowed;
        }
      `,
    ];
  }

  static get properties() {
    return {
      disabled: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  render() {
    return $`
      <span tabindex="0" @keyup=${() => this.first()} @click=${() => this.first()}>
        <slot></slot>
      </span>
    `;
  }

  first() {
    if (!this.disabled) {
      this.dispatchEvent(new CustomEvent('kemet-carousel-first', {
        bubbles: true,
        composed: true,
        detail: this,
      }));
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel-first') || customElements.define('kemet-carousel-first', KemetCarouselFirst);

class KemetCarouselLast extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          cursor: pointer;
        }

        :host([disabled]) {
          cursor: not-allowed;
        }
      `,
    ];
  }

  static get properties() {
    return {
      disabled: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  render() {
    return $`
      <span tabindex="0" @keyup=${() => this.last()} @click=${() => this.last()}>
        <slot></slot>
      </span>
    `;
  }

  last() {
    if (!this.disabled) {
      this.dispatchEvent(new CustomEvent('kemet-carousel-last', {
        bubbles: true,
        composed: true,
        detail: this,
      }));
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel-last') || customElements.define('kemet-carousel-last', KemetCarouselLast);

class KemetCarouselPrev extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          cursor: pointer;
        }

        :host([disabled]) {
          cursor: not-allowed;
        }
      `,
    ];
  }

  static get properties() {
    return {
      disabled: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  render() {
    return $`
      <span tabindex="0" @keyup=${() => this.prev()} @click=${() => this.prev()}>
        <slot></slot>
      </span>
    `;
  }

  prev() {
    if (!this.disabled) {
      this.dispatchEvent(new CustomEvent('kemet-carousel-prev', {
        bubbles: true,
        composed: true,
        detail: this,
      }));
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel-prev') || customElements.define('kemet-carousel-prev', KemetCarouselPrev);

class KemetCarouselLink extends s$1 {
  static get properties() {
    return {
      slide: {
        type: Number,
        reflect: true,
      },
      selected: {
        type: Boolean,
        reflect: true,
      },
      disabled: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  static get styles() {
    return [
      r$3`
        :host([selected]) {
          color: var(--kemet-carousel-link-selected-color, var(--kemet-color-primary));
        }

        :host(:not([selected])) {
          cursor: pointer;
        }

        :host([disabled]) {
          cursor: not-allowed;
        }
      `,
    ];
  }

  render() {
    return $`
      <span tabindex="0" @keyup=${() => this.changed()} @click=${() => this.changed()}>
        <slot></slot>
      </span>
    `;
  }

  changed() {
    if (!this.disabled) {
      this.dispatchEvent(new CustomEvent('kemet-carousel-link', {
        bubbles: true,
        composed: true,
        detail: this,
      }));
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel-link') || customElements.define('kemet-carousel-link', KemetCarouselLink);

class KemetCarouselNext extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          cursor: pointer;
        }

        :host([disabled]) {
          cursor: not-allowed;
        }
      `,
    ];
  }

  static get properties() {
    return {
      disabled: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  render() {
    return $`
      <span tabindex="0" @keyup=${() => this.next()} @click=${() => this.next()}>
        <slot></slot>
      </span>
    `;
  }

  next() {
    if (!this.disabled) {
      this.dispatchEvent(new CustomEvent('kemet-carousel-next', {
        bubbles: true,
        composed: true,
        detail: this,
      }));
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel-next') || customElements.define('kemet-carousel-next', KemetCarouselNext);

class KemetCarouselSlide extends s$1 {
  static get styles() {
    return [
      r$3`
        :host,
        :host *,
        :host *::before,
        *::after {
          box-sizing: border-box;
        }

        :host {
          flex: 0 0 auto;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * Determines if the slide is selected
       */
      selected: {
        type: Boolean,
        reflect: true,
      },
      'aria-hidden': {
        type: String,
        reflect: true,
      },
    };
  }

  constructor() {
    super();
    this.selected = false;
    this['aria-hidden'] = 'true';
  }

  render() {
    return $`
      <slot></slot>
    `;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel-slide') || customElements.define('kemet-carousel-slide', KemetCarouselSlide);

class KemetCarouselTotal extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: inline-block;
        }
      `,
    ];
  }

  static get properties() {
    return {
      total: {
        type: Number,
      },
    };
  }

  firstUpdated() {
    this.carousel = this.closest('kemet-carousel');
  }

  updated() {
    this.total = this.carousel.total;
  }

  render() {
    return $`${this.total}`;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel-total') || customElements.define('kemet-carousel-total', KemetCarouselTotal);

class KemetCarousel extends s$1 {
  static get styles() {
    return r$3`
      :host,
      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      :host {
        position: relative;
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        align-items: center;
        width: var(--kemet-carousel-width, 100%);
        height: var(--kemet-carousel-height, auto);
        overflow: visible;
      }

      :host([arrows]) {
        grid-template-columns: auto minmax(0, 1fr) auto;
      }

      .toolbar {
        display: flex;
        gap: var(--kemet-carousel-toolbar-gap, 1rem);
        align-items: center;
        justify-content: var(--kemet-carousel-toolbar-justify-content, center);
        line-height: 1;
        padding: var(--kemet-carousel-toolbar-padding, 1rem);
      }

      :host([inner]) .toolbar {
        width: var(--kemet-carousel-toolbar-inner-width, 100%);
        position: absolute;
        bottom: var(--kemet-carousel-toolbar-inner-bottom, 0);
        top: var(--kemet-carousel-toolbar-inner-top, auto);
        color: var(--kemet-carousel-toolbar-inner-color, var(--kemet-color-white));
        background-color: var(--kemet-carousel-toolbar-inner-background-color, rgba(0, 0, 0, 0.4));
      }

      .slides {
        overflow: hidden;
        position: relative;
        padding: 1rem 0;
        border: var(--kemet-carousel-slides-border, 1px solid var(--kemet-color-gray1));
      }

      .slider {
        display: flex;
        flex-wrap: nowrap;
        transition: transform var(--kemet-carousel-transition-speed, 300ms) ease;
      }

      ::slotted([slot='next']),
      ::slotted([slot='prev']) {
        opacity: var(--kemet-carousel-arrows-opacity, 0.25);
        transition: opacity var(--kemet-carousel-arrows-transition-speed, 300ms) ease-in-out;
      }

      :host(:hover) ::slotted([slot='next']),
      :host(:hover) ::slotted([slot='prev']) {
        opacity: var(--kemet-carousel-arrows-opacity-hover, 1);
      }
    `;
  }

  static get properties() {
    return {
      /**
       * The current slide index.
       */
      index: {
        type: Number,
        reflect: true,
      },
      /**
       * The total amount of slides
       */
      total: {
        type: Number,
      },
      /**
       * The width of the slider
       */
      sliderWidth: {
        type: String,
      },
      /**
       * The X position of the slider
       */
      sliderTranslateX: {
        type: String,
      },
      /**
       * Displays the toolbar inside the carousel container
       */
      inner: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Determines whether or not to display arrows
       */
      arrows: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Default options for the carousel
       */
      options: {
        type: Object,
      },
      /**
       * Options are different breakpoints for the carousel. Is mobile first.
       */
      breakpoints: {
        type: Object,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.index = 0;
    this.total = 0;
    this.sliderWidth = 'auto';
    this.sliderTranslateX = '0';
    this.inner = false;
    this.arrows = false;
    this.options = {
      perView: 1,
      perMove: 1,
      gap: 12,
      slideshow: 0,
      rewind: true,
      center: false,
    };
    this.breakpoints = {
      768: {
        perView: 2,
        gap: 24,
        rewind: false,
      },
      1280: {
        perView: 2.5,
        center: true,
      },
    };

    // bindings
    this.addEventListener('kemet-carousel-first', this.handleFirst.bind(this));
    this.addEventListener('kemet-carousel-last', this.handleLast.bind(this));
    this.addEventListener('kemet-carousel-next', this.handleNext.bind(this));
    this.addEventListener('kemet-carousel-prev', this.handlePrev.bind(this));
    this.addEventListener('kemet-carousel-link', this.handleLink.bind(this));
  }

  firstUpdated() {
    // standard properties
    this.slides = [];
    this.links = [];

    // elements
    this.containerElement = this.shadowRoot.querySelector('[part="container"]');
    this.slidesElement = this.shadowRoot.querySelector('[part="slides"]');
    this.sliderElement = this.shadowRoot.querySelector('[part="slider"]');
    this.toolbarElement = this.shadowRoot.querySelector('[part="toolbar"]');
    this.toolbarSlotElement = this.querySelector('[slot="toolbar"]');
    this.informationElement = this.querySelector('kemet-carousel-information');

    // events
    window.addEventListener('resize', () => {
      this.setSlideSize();
      this.setToolbarSize();
      this.updateIndex(this.index);
    });

    this.sliderElement.addEventListener('transitionend', this.handleTransitionEnd.bind(this));

    // methods
    this.swipeMove = (event) => {
      event.preventDefault();

      const pageX = event.touches ? event.touches[0].pageX : event.pageX;
      const currentSlide = this.slides[this.index];

      this.sliderTranslateX = `${pageX - this.startX - currentSlide.offsetLeft}px`;
    };

    this.handleSlideShow = () => {
      if (this.getOption('slideshow') > 0) {
        this.updateIndex(this.index + 1);
        clearTimeout(this.handleSlideShow);
      }
    };

    // setup
    this.setSlideSize();
    this.goToSlide(this.index);
  }

  updated(prevProps) {
    this.setSlideSize();
    this.setToolbarSize();

    if (prevProps.has('index')) {
      this.updateIndex(this.index);
      setTimeout(this.handleSlideShow, this.getOption('slideshow') * 1000);
    }
  }

  render() {
    return $`
      <slot name="prev" @slotchange=${this.handleArrows}></slot>
      <div class="container" part="container">
        <section
          class="slides"
          part="slides"
          @mousedown=${this.swipeStart}
          @mouseup=${this.swipeEnd}
          @touchstart=${this.swipeStart}
          @touchend=${this.swipeEnd}
          @mouseleave=${this.swipeLeave}
        >
          <div class="slider" part="slider" style="width:${this.sliderWidth}; transform:translateX(${this.sliderTranslateX});">
            <slot name="slides" @slotchange="${this.handleSlotChange}"></slot>
          </div>
        </section>
        ${this.makeToolbar()}
      </div>
      <slot name="next" @slotchange=${this.handleArrows}></slot>
    `;
  }

  swipeStart(event) {
    this.startX = event.touches ? event.touches[0].pageX : event.pageX;

    this.addEventListener('mousemove', this.swipeMove);
    this.addEventListener('touchmove', this.swipeMove);
  }

  swipeEnd(event) {
    this.updateIndex(this.swipeUpdate(event));
    this.removeEventListener('mousemove', this.swipeMove, false);
    this.removeEventListener('touchmove', this.swipeMove, false);
  }

  swipeUpdate(event) {
    const pageX = event.changedTouches ? event.changedTouches[0].pageX : event.pageX;
    const direction = this.startX > pageX ? 'right' : 'left';
    const threshold = this.slidesElement.offsetWidth / 3;
    const diff = this.startX - pageX;
    const shouldUpdate = Math.abs(diff) > threshold;

    let { index } = this;

    if (shouldUpdate && direction === 'right') {
      index = this.index >= this.slides.length - 1 ? this.index : this.index + 1;
    }

    if (shouldUpdate && direction === 'left') {
      index = this.index < 1 ? 0 : this.index - 1;
    }

    return index;
  }

  swipeLeave() {
    this.updateIndex(this.index);
    this.removeEventListener('mousemove', this.swipeMove, false);
    this.removeEventListener('touchmove', this.swipeMove, false);
  }

  setSlideSize() {
    this.slideWidth = this.containerElement.offsetWidth / this.getOption('perView');

    this.slides.forEach((slide) => {
      slide.style.marginLeft = `${this.getOption('gap') / 2}px`;
      slide.style.marginRight = `${this.getOption('gap') / 2}px`;
      slide.style.width = `${this.slideWidth - this.getOption('gap')}px`;
    });

    this.sliderWidth = `${this.slideWidth * this.slides.length}px`;
  }

  setToolbarSize() {
    if (this.inner && this.toolbarElement) {
      const width = this.slidesElement.offsetWidth;
      this.toolbarElement.style.width = `${width}px`;
    }
  }

  makeToolbar() {
    if (this.toolbarSlotElement) {
      return $`
        <section class="toolbar" part="toolbar">
          <slot name="toolbar"></slot>
        </section>
      `;
    }

    return null;
  }

  handleSlotChange() {
    const slides = this.querySelectorAll('kemet-carousel-slide');
    const links = this.querySelectorAll('kemet-carousel-link');

    // handle slides
    slides.forEach((slide) => {
      this.slides.push(slide);
    });

    this.updateInformation();
    this.total = slides.length;
    slides[this.index].selected = true;

    // handle links
    links.forEach((link) => {
      this.links.push(link);
    });
  }

  handleArrows() {
    this.arrows = true;
  }

  handleFirst() {
    this.updateIndex(0);
  }

  handleLast() {
    this.updateIndex(this.slides.length - 1);
  }

  handleNext() {
    let newIndex = this.index + this.getOption('perMove');

    if (newIndex >= this.slides.length) {
      if (this.getOption('rewind')) {
        newIndex = 0;
      } else {
        newIndex = this.index;
      }
    }

    this.updateIndex(newIndex);
  }

  handlePrev() {
    let newIndex = this.index - this.getOption('perMove');

    // send them to the last slide
    if (newIndex < 0) {
      if (this.getOption('rewind')) {
        newIndex = this.slides.length - 1;
      } else {
        newIndex = this.index;
      }
    }

    this.updateIndex(newIndex);
  }

  updateIndex(newIndex) {
    let currentSlide = this.slides[this.index];
    let currentLink = this.links[newIndex];

    // remove selected from all links
    this.links.forEach((link) => {
      link.selected = false;
    });

    // if current link is invalid assume it's the first link
    if (!currentLink) {
      [currentLink] = this.links;
    }

    // add selected to current link
    if (currentLink) {
      currentLink.selected = true;
    }

    if (currentSlide) {
      currentSlide.setAttribute('aria-hidden', 'true');

      // correct for invalid indexes
      if (newIndex > -1 && newIndex < this.slides.length) {
        this.index = newIndex;
      } else {
        // eslint-disable-next-line no-console
        console.warn('An invalid index number was entered. The kemet-carousel has been reset to the first slide.');
        this.index = 0;
      }

      // move
      this.goToSlide(this.index);

      // update new slide
      currentSlide = this.slides[this.index];
      currentSlide.setAttribute('aria-hidden', 'false');

      this.slides.forEach((slide) => {
        slide.selected = false;
      });

      currentSlide.selected = true;

      // notify consumers of slide change

      /**
       * Fires with the a slide has begun to change
       */
      this.dispatchEvent(new CustomEvent('kemet-carousel-change-start', {
        bubbles: true,
        composed: true,
        detail: this,
      }));

      // update information element
      this.updateInformation();
    }
  }

  updateInformation() {
    this.informationSlot = this.slides[this.index].querySelector('[slot="information"]');

    if (this.informationElement) {
      if (this.informationSlot) {
        this.informationElement.innerHTML = this.informationSlot.outerHTML;
      } else {
        this.informationElement.innerHTML = '';
      }
    }
  }

  goToSlide(index) {
    if (this.getOption('center') === true) {
      const slidesCenter = this.slidesElement.offsetWidth / 2;
      const slideX = this.slideWidth * index;
      this.sliderTranslateX = `${slideX - (slideX - slidesCenter) - this.slideWidth / 2 - slideX}px`;
    } else {
      this.sliderTranslateX = `${(this.slideWidth * index) * -1}px`;
    }
  }

  handleTransitionEnd() {
    const currentElement = this.querySelector('kemet-carousel-current');

    if (currentElement) {
      currentElement.current = this.index + 1;
    }

    /**
     * Fires when a slide has changed and finished animating
     */
    this.dispatchEvent(new CustomEvent('kemet-carousel-change-finished', {
      bubbles: true,
      composed: true,
      detail: this,
    }));
  }

  handleLink(event) {
    this.updateIndex(event.detail.slide);
  }

  getOption(option) {
    const breakpoints = Object.keys(this.breakpoints);
    let value = this.options[option];

    breakpoints.forEach((breakpoint) => {
      if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches && this.breakpoints[breakpoint][option] !== undefined) {
        value = this.breakpoints[breakpoint][option];
      }

      return value;
    });

    return value;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-carousel') || customElements.define('kemet-carousel', KemetCarousel);

class KemetCombo extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          opacity: 0;
          width: var(--kemet-combo-width, calc(100% - 2px));
          margin: var(--kemet-combo-margin, 1rem auto);
          pointer-events: none;
          display: block;
          position: relative;
          transition: opacity 0.3s ease-in-out;
        }

        :host([show]) {
          opacity: 1;
          pointer-events: auto;
        }

        ul {
          width: 100%;
          max-height: var(--kemet-combo-max-height, calc(5 * 3rem));
          position: absolute;
          z-index: 1;
          list-style: none;
          margin: 0;
          padding: 0;
          overflow-y: scroll;
          border: var(--kemet-combo-border, 1px solid var(--kemet-color-primary));
          border-radius: var(--kemet-combo-border-radius, var(--kemet-border-radius));
          background-color: var(--kemet-combo-background-color, var(--kemet-color-white));
          box-shadow: var(--kemet-combo-shadow, 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1));
        }
        li {
          line-height: 3rem;
          padding: 0 1.5rem;
          cursor: pointer;
        }
        li:hover,
        li:focus {
          color: var(--kemet-combo-hover-color, var(--kemet-color-white));
          outline: none;
          background-color: var(--kemet-combo-hover-background-color, var(--kemet-color-primary));
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * Uniquely identifies the component. Should match the slug used in a control.
       */
      slug: {
        type: String,
      },
      /**
       * An array of items listed for the combo box
       */
      options: {
        type: Array,
      },
      /**
       * Used internally
       */
      filteredOptions: {
        type: Array,
      },
      /**
       * Controls the display of the combo box
       */
      show: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();
    this.options = [];
  }

  firstUpdated() {
    // standard properties
    this.field = this.closest('kemet-field');
    this.input = this.field.querySelector('[slot="input"]');

    // managed properties
    this.slug = this.field.slug || 'slug';

    // events listeners
    this.input.addEventListener('kemet-input-input', this.handleInput.bind(this));
    this.input.addEventListener('keydown', event => this.handleInputKeyDown(event));
  }

  render() {
    return $`
      <div
        role="combobox"
        aria-expanded=${this.show}
        aria-controls="${this.slug}-listbox"
        aria-haspopup="listbox"
        id="${this.slug}-combobox"
        aria-label="${this.field?.label}"
      >
        <ul role="listbox" aria-labelledby="${this.slug}-label" id="${this.slug}-listbox">
          ${this.makeOptions()}
        </ul>
      </div>
    `;
  }

  makeOptions() {
    if (this.input) {
      this.filteredOptions = this.options.filter(
        option => option.toLowerCase().indexOf(this.input.value?.toLowerCase()) !== -1,
      );

      const options = this.filteredOptions.map(
        (option, index) => $`<li
            id="${this.slug}-option-${index}"
            role="option"
            tabindex="0"
            aria-selected="false"
            @click=${event => this.handleSelection(event)}
            @keydown=${event => this.handleOptionKeyDown(event)}
          >
            ${option}
          </li>`,
      );

      return options;
    }

    return null;
  }

  handleInput(event) {
    this.makeOptions();

    if (event.detail.length > 0) {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  handleSelection(event) {
    this.input.value = event.target.innerText;
    this.show = false;

    /**
     * Fires when a selection has been made
     */
    this.dispatchEvent(
      new CustomEvent('kemet-combo-selection', {
        bubbles: true,
        composed: true,
        detail: {
          element: event.target,
          text: event.target.innerText,
          id: event.target.getAttribute('id'),
        },
      }),
    );
  }

  handleOptionKeyDown(event) {
    event.preventDefault();

    if (event.code === 'ArrowDown') {
      const next = event.target.nextElementSibling;

      if (next) {
        next.focus();
      } else {
        this.shadowRoot.querySelector('li').focus();
      }
    }

    if (event.code === 'ArrowUp') {
      const previous = event.target.previousElementSibling;

      if (previous) {
        previous.focus();
      } else {
        this.shadowRoot.querySelector('li:last-child').focus();
      }
    }

    if (event.code === 'Escape' || event.code === 'Tab') {
      this.show = false;
      this.input.focus();
    }

    if (event.code === 'Enter' || event.code === 'Space') {
      this.handleSelection(event);
    }
  }

  handleInputKeyDown(event) {
    if (event.code === 'ArrowDown') {
      this.shadowRoot.querySelector('li').focus();
    }

    if (event.code === 'Escape') {
      this.show = false;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-combo') || customElements.define('kemet-combo', KemetCombo);

class KemetCount extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: block;
          font-size: var(--kemet-count-font-size, 90%);
          margin-top: 0.8rem;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The text label shown to users
       */
      message: {
        type: String,
      },
      /**
       * The number of characters remaining
       */
      remaining: {
        type: Number,
      },
      /**
       * The maximum number of characters allowed
       */
      limit: {
        type: Number,
      },
      /**
       * Set to true if the field should validate as soon as the character limit is reached
       */
      validateImmediately: {
        type: Boolean,
        attribute: 'validate-immediately',
      },
    };
  }

  firstUpdated() {
    this.field = this.closest('kemet-field');
    this.inputSlot = this.field.querySelector('[slot="input"]');

    this.remaining = this.limit - this.field.length;

    this.field.addEventListener('kemet-field-input', (event) => {
      this.remaining = this.limit - event.detail;

      const nativeElement = this.input || this.textarea;

      if (nativeElement) {
        if (this.remaining < 0) {
          nativeElement.validity.passedLimit = true;

          if (this.validateImmediately) {
            this.inputSlot.status = 'error';
            this.inputSlot.invalid = true;

            /**
             * Fires when there's a change in status.
             */
            this.dispatchEvent(
              new CustomEvent('kemet-count-status', {
                bubbles: true,
                composed: true,
                detail: {
                  status: 'error',
                  validity: nativeElement.validity,
                  element: this.inputSlot,
                },
              }),
            );
          }
        } else {
          this.inputSlot.status = 'standard';
          nativeElement.checkValidity();

          /**
           * Fires when there's a change in status.
           */
          this.dispatchEvent(
            new CustomEvent('kemet-count-status', {
              bubbles: true,
              composed: true,
              detail: {
                status: 'standard',
                validity: nativeElement.validity,
                element: this.inputSlot,
              },
            }),
          );
        }
      }
    });

    this.input = this.inputSlot.shadowRoot.querySelector('input');
    this.textarea = this.inputSlot.shadowRoot.querySelector('textarea');
  }

  render() {
    return $`${this.remaining} ${this.message}`;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-count') || customElements.define('kemet-count', KemetCount);

class KemetDraggable extends s$1 {
  static get styles() {
    return r$3`
      :host {
        display: inline-block;
      }

      #draggable {
        position: absolute;
      }
    `;
  }

  static get properties() {
    return {
      /**
       * A unique identifier used to store the element's position in local storage.
       */
      memory: {
        type: String,
      },
      /**
       * The elements top position in pixels.
       */
      top: {
        type: String,
      },
      /**
       * The element's left position in pixels.
       */
      left: {
        type: String,
      },
      /**
       * If set to true, will measure the width and height
       * of the element's content and apply it to the host element.
       */
      measure: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();

    // managed properties defaults
    this.top = 'auto';
    this.left = 'auto';
    this.measure = false;
  }

  firstUpdated() {
    // standard properties
    this.position1 = 0;
    this.position2 = 0;
    this.position3 = 0;
    this.position4 = 0;
    this.mouseMove = event => this.drag(event);
    this.mouseUp = () => this.stopDrag();
    this.draggableElement = this.shadowRoot.getElementById('draggable');

    const savedPosition = JSON.parse(localStorage.getItem(this.memory));

    if (savedPosition) {
      this.top = savedPosition.top;
      this.left = savedPosition.left;
    }

    if (this.measure) {
      this.measureContent();
    }
  }

  render() {
    return $`
      <div id="draggable" @mousedown=${event => this.startDrag(event)} style="top:${this.top}; left:${this.left}">
        <slot></slot>
      </div>
    `;
  }

  startDrag(event) {
    if (event) {
      event.preventDefault();

      this.position3 = event.clientX;
      this.position4 = event.clientY;
    }

    document.addEventListener('mouseup', this.mouseUp);
    document.addEventListener('mousemove', this.mouseMove);

    this.dispatchEvent(new CustomEvent('kemet-draggable-start', {
      bubbles: true,
      composed: true,
      detail: this,
    }));
  }

  drag(event) {
    event.preventDefault();

    this.position1 = this.position3 - event.clientX;
    this.position2 = this.position4 - event.clientY;
    this.position3 = event.clientX;
    this.position4 = event.clientY;

    this.top = `${this.draggableElement.offsetTop - this.position2}px`;
    this.left = `${this.draggableElement.offsetLeft - this.position1}px`;
  }

  stopDrag() {
    document.removeEventListener('mouseup', this.mouseUp);
    document.removeEventListener('mousemove', this.mouseMove);

    if (this.memory) {
      const savedPosition = {
        top: this.top,
        left: this.left,
      };

      localStorage.setItem(this.memory, JSON.stringify(savedPosition));
    }

    this.dispatchEvent(new CustomEvent('kemet-draggable-stop', {
      bubbles: true,
      composed: true,
      detail: this,
    }));
  }

  measureContent() {
    this.style.width = `${this.draggableElement.offsetWidth}px`;
    this.style.height = `${this.draggableElement.offsetHeight}px`;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-draggable') || customElements.define('kemet-draggable', KemetDraggable);

const documentHeight = `${document.documentElement.scrollHeight}px`;

const stylesBase$1 = r$3`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host {
    width: 100%;
  }

  .off-canvas {
    position: relative;
    overflow: hidden;
  }

  .off-canvas__nav {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    visibility: hidden;
    height: 100%;
    transition: all 0.5s;
  }

  .off-canvas__nav::after {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    content: '';
    opacity: 1;
    transition: opacity 0.5s;
  }

  :host([opened]) .off-canvas__nav::after {
    width: 0;
    height: 0;
    opacity: 0;
    transition: opacity 0.5s, width 0.1s 0.5s, height 0.1s 0.5s;
  }

  .off-canvas__pusher {
    position: relative;
    left: 0;
    z-index: 99;
    height: 100%;
    transition: transform 0.5s;
  }

  :host([overlay]) .off-canvas__pusher::after {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    background: var(--kemet-drawer-overlay-color, rgba(0, 0, 0, 0.2));
    content: '';
    opacity: 0;
    transition: opacity 0.5s, width 0.1s 0.5s, height 0.1s 0.5s;
  }

  :host([opened]) .off-canvas__pusher::after {
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: opacity 0.5s;
    transform: scale(2);
  }

  .off-canvas__content {
    position: relative;
    /* overflow-y: scroll; */
    min-height: 100vh;
  }

  .off-canvas__wrapper {
    position: relative;
  }

  ::slotted([slot="content"]) {
    min-height: 100vh;
  }

  /* -------------------------------------- */
  /* custom properties */
  /* -------------------------------------- */

  .off-canvas__nav {
    width: var(--kemet-drawer-width, 300px);
    height: var(--kemet-drawer-height, 100%);
    color: var(--kemet-drawer-color, #fafafa);
    background: var(--kemet-drawer-background-color, #202020);
  }
`;

const stylesEffects$1 = r$3`
  /* slide */
  :host([effect='slide']) .off-canvas__nav {
    visibility: visible;
    transform: translate3d(-100%, 0, 0);
  }

  :host([effect='slide'][opened]) .off-canvas__nav {
    visibility: visible;
    transform: translate3d(0, 0, 0);
  }

  :host([effect='slide']) .off-canvas__nav:after {
    display: none;
  }

  :host([effect='slide'][side='right']) .off-canvas__nav {
    transform: translate3d(100vw, 0, 0);
  }

  :host([effect='slide'][side='right'][opened]) .off-canvas__nav {
    transform: translate3d(calc(100vw - var(--kemet-drawer-width, 300px)), 0, 0);
  }

  :host([effect='slide'][side='top']) .off-canvas__nav {
    width: 100vw;
    height: var(--kemet-drawer-height, 100vh);
    transform: translate3d(0, calc(var(--kemet-drawer-height, 100vh) * -1), 0);
  }

  :host([effect='slide'][side='top'][opened]) .off-canvas__nav {
    transform: translate3d(0, 0, 0);
  }

  :host([effect='slide'][side='bottom']) .off-canvas__nav {
    width: 100vw;
    height: var(--kemet-drawer-height, 100vh);
    transform: translate3d(0, ${o$4(documentHeight)}, 0);
  }

  :host([effect='slide'][side='bottom'][opened]) .off-canvas__nav {
    transform: translate3d(0, calc(100vh - var(--kemet-drawer-height, 100vh)), 0);
  }

  /* reveal */
  :host([effect='reveal'][opened]) .off-canvas__pusher {
    transform: translate3d(var(--kemet-drawer-width, 300px), 0, 0);
  }

  :host([effect='reveal']) .off-canvas__nav {
    z-index: 1;
  }

  :host([effect='reveal'][opened]) .off-canvas__nav {
    visibility: visible;
    transition: transform 0.5s;
  }

  :host([effect='reveal']) .off-canvas__nav::after {
    display: none;
  }

  :host([effect='reveal'][side='right'][opened]) .off-canvas__pusher {
    transform: translate3d(0, 0, 0);
  }

  :host([effect='reveal'][side='right']) .off-canvas__nav {
    transform: translate3d(100vw, 0, 0);
  }

  :host([effect='reveal'][side='right'][opened]) .off-canvas__nav {
    transform: translate3d(calc(100vw - var(--kemet-drawer-width, 300px)), 0, 0);
  }

  :host([effect='reveal'][side='top']) .off-canvas__nav {
    width: 100vw;
    height: var(--kemet-drawer-height, 100vh);
    transform: translate3d(0, calc(var(--kemet-drawer-height, 100vh) * -1), 0);
  }

  :host([effect='reveal'][side='top'][opened]) .off-canvas__nav {
    transform: translate3d(0, 0, 0);
  }

  :host([effect='reveal'][side='top'][opened]) .off-canvas__pusher {
    transform: translate3d(0, var(--kemet-drawer-height, 100vh), 0);
  }

  :host([effect='reveal'][side='bottom']) .off-canvas__nav {
    width: 100vw;
    height: var(--kemet-drawer-height, 100vh);
    transform: translate3d(0, ${o$4(documentHeight)}, 0);
  }

  :host([effect='reveal'][side='bottom'][opened]) .off-canvas__nav {
    transform: translate3d(0, calc(100vh - var(--kemet-drawer-height, 100vh)), 0);
  }

  :host([effect='reveal'][side='bottom'][opened]) .off-canvas__pusher {
    transform: translate3d(0, calc(var(--kemet-drawer-height, 100vh) * -1), 0);
  }

  /* push */
  :host([effect='push'][opened]) .off-canvas__pusher {
    transform: translate3d(var(--kemet-drawer-width, 300px), 0, 0);
  }

  :host([effect='push']) .off-canvas__nav {
    transform: translate3d(-100%, 0, 0);
  }

  :host([effect='push'][opened]) .off-canvas__nav {
    visibility: visible;
    transition: transform 0.5s;
    transform: translate3d(0, 0, 0);
  }

  :host([effect='push']) .off-canvas__nav::after {
    display: none;
  }

  :host([effect='push'][side='right'][opened]) .off-canvas__pusher {
    transform: translate3d(calc(var(--kemet-drawer-width, 300px) * -1), 0, 0);
  }

  :host([effect='push'][side='right']) .off-canvas__nav {
    transform: translate3d(100vw, 0, 0);
  }

  :host([effect='push'][side='right'][opened]) .off-canvas__nav {
    transform: translate3d(calc(100vw - var(--kemet-drawer-width, 300px)), 0, 0);
  }

  :host([effect='push'][side='top']) .off-canvas__nav {
    width: 100vw;
    height: var(--kemet-drawer-height, 100vh);
    transform: translate3d(0, calc(var(--kemet-drawer-height, 100vh) * -1), 0);
  }

  :host([effect='push'][side='top'][opened]) .off-canvas__nav {
    transform: translate3d(0, 0, 0);
  }

  :host([effect='push'][side='top'][opened]) .off-canvas__pusher {
    transform: translate3d(0, var(--kemet-drawer-height, 100vh), 0);
  }

  :host([effect='push'][side='bottom']) .off-canvas__nav {
    width: 100vw;
    height: var(--kemet-drawer-height, 100vh);
    transform: translate3d(0, ${o$4(documentHeight)}, 0);
  }

  :host([effect='push'][side='bottom'][opened]) .off-canvas__nav {
    transform: translate3d(0, calc(100vh - var(--kemet-drawer-height, 100vh)), 0);
  }

  :host([effect='push'][side='bottom'][opened]) .off-canvas__pusher {
    transform: translate3d(0, calc(var(--kemet-drawer-height, 100vh) * -1), 0);
  }

  /* scale */
  :host([effect='scale']) .off-canvas__pusher {
    transform-style: preserve-3d;
  }

  :host([effect='scale'][opened]) .off-canvas__pusher {
    transform: translate3d(0, 0, 0) scale(0.95);
  }

  :host([effect='scale']) .off-canvas__nav {
    opacity: 1;
    transform: translate3d(-100%, 0, 0);
  }

  :host([effect='scale'][opened]) .off-canvas__nav {
    visibility: visible;
    transition: transform 0.5s;
    transform: translate3d(0, 0, 0);
  }

  :host([effect='scale']) .off-canvas__nav::after {
    display: none;
  }

  :host([effect='scale'][side='right']) .off-canvas__nav {
    transform: translate3d(100vw, 0, 0);
  }

  :host([effect='scale'][side='right'][opened]) .off-canvas__nav {
    transform: translate3d(calc(100vw - var(--kemet-drawer-width, 300px)), 0, 0);
  }

  :host([effect='scale'][side='top']) .off-canvas__nav {
    width: 100vw;
    height: var(--kemet-drawer-height, 100vh);
    transform: translate3d(0, calc(var(--kemet-drawer-height, 100vh) * -1), 0);
  }

  :host([effect='scale'][side='top'][opened]) .off-canvas__nav {
    transform: translate3d(0, 0, 0);
  }

  :host([effect='scale'][side='bottom']) .off-canvas__nav {
    width: 100vw;
    height: var(--kemet-drawer-height, 100vh);
    transform: translate3d(0, ${o$4(documentHeight)}, 0);
  }

  :host([effect='scale'][side='bottom'][opened]) .off-canvas__nav {
    transform: translate3d(0, calc(100vh - var(--kemet-drawer-height, 100vh)), 0);
  }
`;

class KemetDrawer extends s$1 {
  static get styles() {
    return [stylesBase$1, stylesEffects$1];
  }

  static get properties() {
    return {
      /**
       * Determines if the drawer is opened or not.
       */
      opened: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The animation effect for opening and closing the drawer.
       * Values include: (slide | reveal | push | scale)
       */
      effect: {
        type: String,
        reflect: true,
      },
      /**
       * Allows you to control which side the drawer opens from.
       * Values include: (left | right | top | bottom)
       */
      side: {
        type: String,
        reflect: true,
      },
      /**
       * Adds a overlay over the content section of the Drawer when opened
       */
      overlay: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.opened = undefined;
    this.effect = 'slide';
    this.side = 'left';
    this.overlay = false;
  }

  firstUpdated() {
    this.addEventListener('click', (event) => {
      if (this.opened && event.target.tagName.toLowerCase() === 'kemet-drawer') {
        this.opened = false;
      }
    });
  }

  updated(prevProps) {
    if (!prevProps.get('opened') && this.opened === true) {
      /**
       * Fires when the drawer opens.
       */
      this.dispatchEvent(
        new CustomEvent('kemet-drawer-opened', {
          bubbles: true,
          composed: true,
          detail: this,
        }),
      );
    }

    if (prevProps.get('opened') && this.opened === false) {
      /**
       * Fires when the drawer closes.
       */
      this.dispatchEvent(
        new CustomEvent('kemet-drawer-closed', {
          bubbles: true,
          composed: true,
          detail: this,
        }),
      );
    }
  }

  render() {
    return $`
      <section class="off-canvas" part="container">
        <nav class="off-canvas__nav" part="drawer" title="Drawer">
          <slot name="navigation"></slot>
        </nav>
        <div class="off-canvas__pusher" part="pusher">
          <main class="off-canvas__content" part="content">
            <div class="off-canvas__wrapper" part="wrapper">
              <slot name="content"></slot>
            </div>
          </main>
        </div>
      </section>
    `;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-drawer') || customElements.define('kemet-drawer', KemetDrawer);

class KemetFAB extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          --kemet-fab-size: 50px;

          display: inline-block;
          position: relative;
        }

        button {
          color: var(--kemet-fab-color, var(--kemet-color-white));
          font-size: inherit;
          display: inline-flex;
          padding: 0;
          position: relative;
          min-height: var(--kemet-fab-size);
          min-width: var(--kemet-fab-size);
          max-width: var(--kemet-fab-size);
          align-items: center;
          justify-content: flex-start;
          transition: all 0.4s ease;
          border: none;
          background-color: var(--kemet-fab-background-color, var(--kemet-color-primary));
        }

        :host([outlined]) button {
          color: var(--kemet-fab-outlined-color, var(--kemet-color-primary));
          border: var(--kemet-fab-outlined-border, 1px solid var(--kemet-color-primary));
          background-color: transparent;
        }

        :host([pill]) button {
          border-radius: var(--kemet-fab-pill-radius, 10rem);
        }

        button::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: -1;
          width: 100%;
          height: 100%;
          transition: background-color 0.3s ease-in-out;
          background-color: var(--kemet-fab-background-color, var(--kemet-color-primary));
        }

        :host([pill]) button::before {
          border-radius: var(--kemet-fab-pill-radius, 10rem);
        }

        :host([outlined]) button::before {
          border: var(--kemet-fab-outline-border, 1px solid var(--kemet-color-primary));
          background-color: transparent;
        }

        :host([expanded]) button {
          max-width: 99rem;
          padding: 0 1.35rem 0 0.25rem;
        }

        :host([disabled]) button {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .icon {
          width: var(--kemet-fab-size);
          height: var(--kemet-fab-size);
          display: flex;
          flex: 0 0 auto;
          align-items: center;
          justify-content: center;
        }

        .text {
          color: var(--kemet-fab-color, var(--kemet-color-white));
          z-index: 1;
          white-space: nowrap;
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.2s ease-in-out;
        }

        :host([outlined]) .text {
          color: var(--kemet-fab-outlined-color, var(--kemet-color-primary));
        }

        :host([expanded]) .text {
          opacity: 1;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The expanded state of the button
       */
      expanded: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Outline style for a button
       */
      outlined: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Determines whether not a button is disabled
       */
      disabled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Displays the fab with rounded corners
       */
      pill: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The distance, in pixels, where the fab should automatically expand
       */
      expandPoint: {
        type: Number,
        attribute: 'expand-point',
      },
      /**
       * The distance, in pixels, where the fab should automatically collapse
       */
      collapsePoint: {
        type: Number,
        attribute: 'collapse-point',
      },
    };
  }

  constructor() {
    super();

    this.outlined = false;
    this.disabled = false;
    this.expanded = false;
  }

  firstUpdated() {
    // events
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.addEventListener('mouseout', this.handleMouseOut.bind(this));
  }

  render() {
    return $`
      <button class="button" part="button" ?disabled=${this.disabled} aria-disabled=${this.disabled ? 'true' : 'false'}>
        <span class="icon" part="icon">
          <slot name="icon"></slot>
        </span>
        <span class="text" part="text">
          <slot></slot>
        </span>
      </button>
    `;
  }

  handleMouseOver() {
    if (!this.disabled) {
      this.expanded = true;
    }
  }

  handleMouseOut() {
    if (!this.disabled) {
      this.expanded = false;
    }
  }

  handleScroll() {
    if (window.scrollY > this.expandPoint) {
      this.expanded = true;
    }

    if (window.scrollY < this.expandPoint) {
      this.expanded = false;
    }

    if (window.scrollY > this.collapsePoint) {
      this.expanded = false;
    }

    if (window.scrollY < this.collapsePoint) {
      this.expanded = true;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-fab') || customElements.define('kemet-fab', KemetFAB);

class KemetField extends s$1 {
  static get styles() {
    return [
      r$3`
        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }

        :host {
          display: block;
        }

        :host([disabled]) {
          opacity: 0.5;
        }

        label {
          position: relative;
          display: block;
        }

        label span {
          color: inherit;
          display: inline-flex;
          gap: 0.5rem;
          align-items: center;
          margin-bottom: 0.8rem;
        }

        :host([status='error']) kemet-icon {
          color: var(--kemet-color-error);
        }

        :host([status='success']) kemet-icon {
          color: var(--kemet-color-success);
        }

        :host([status='warning']) kemet-icon {
          color: var(--kemet-color-warning);
        }

        .message {
          font-size: 0.9rem;
          line-height: 1;
          display: block;
          margin-top: 0.8rem;
        }

        :host([status='error']) .message {
          color: var(--kemet-color-error);
        }

        :host([status='success']) .message {
          color: var(--kemet-color-success);
        }

        :host([status='warning']) .message {
          color: var(--kemet-color-warning);
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * Uniquely identifies the control. Use the same slug for slotted sub components.
       */
      slug: {
        type: String,
      },
      /**
       * The label text
       */
      label: {
        type: String,
      },
      /**
       * The validation message for error or success
       */
      message: {
        type: String,
      },
      /**
       * Determines if the containing input is focused
       */
      focused: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The validation status of standard, error, or success
       */
      status: {
        type: String,
        reflect: true,
      },
      /**
       * Is true when the containing input has a value
       */
      filled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The length of the containing input
       */
      length: {
        type: Number,
      },
      /**
       * Determines the disabled state of the control
       */
      disabled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The icon while in an error or warning state
       */
      errorIcon: {
        type: String,
        attribute: 'error-icon',
      },
      /**
       * The icon while in an success state
       */
      successIcon: {
        type: String,
        attribute: 'success-icon',
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.status = 'standard';
    this.errorIcon = 'exclamation-triangle-fill';
    this.successIcon = 'check-lg';

    // listeners
    this.addEventListener('kemet-input-focused', event => this.handleFocused(event));
    this.addEventListener('kemet-input-status', event => this.handleStatus(event));
    this.addEventListener('kemet-input-input', event => this.handleInput(event));
    this.addEventListener('kemet-count-status', event => this.handleStatus(event));
    this.addEventListener('kemet-combo-selection', event => this.handleSelection(event));
  }

  firstUpdated() {
    this.slotInput = this.querySelector('[slot="input"]');
    this.slotCombo = this.querySelector('[slot="combo"]');

    if (this.slotInput.value) {
      this.length = this.slotInput.value.length;
    } else {
      this.length = 0;
    }
  }

  render() {
    return $`
      <label for="${this.slug}" id="${this.slug}-label" part="label">
        <span>${this.label}${this.makeStatusIcon()}</span>
        <slot name="input"></slot>
      </label>
      ${this.makeStatusMessage()}
      <slot name="component"></slot>
    `;
  }

  makeStatusIcon() {
    if (this.status === 'error' || this.status === 'warning') {
      return $`<kemet-icon icon="${this.errorIcon}" size="16"></kemet-icon>`;
    }

    if (this.status === 'success') {
      return $`<kemet-icon icon="${this.successIcon}" size="16"></kemet-icon>`;
    }

    return null;
  }

  makeStatusMessage() {
    if (this.status !== 'standard') {
      return $`<span class="message" part="message">${this.message}</span>`;
    }

    return null;
  }

  handleFocused(event) {
    this.focused = event.detail;

    if (!this.focused && this.slotCombo && this.slotCombo.options.length < 1) {
      this.slotCombo.show = false;
    }
  }

  handleStatus(event) {
    this.status = event.detail.status;
  }

  handleInput(event) {
    /**
     * Fires when input fires on the input slot
     */
    this.dispatchEvent(
      new CustomEvent('kemet-field-input', {
        bubbles: false,
        detail: event.detail.length,
      }),
    );

    if (event.detail === '') {
      this.filled = false;
    } else {
      this.filled = true;
    }
  }

  handleSelection(event) {
    this.slotInput.setAttribute('aria-activedescendant', event.detail);
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-field') || customElements.define('kemet-field', KemetField);

class KemetFlipcardTrigger extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          cursor: pointer;
        }
      `,
    ];
  }

  firstUpdated() {
    this.keyCodes = {
      ENTER: 13,
      SPACE: 32,
    };
  }

  render() {
    return $`
      <slot tabindex="0" @click=${() => this.trigger()} @keypress=${event => this.handleKeyup(event)}></slot>
    `;
  }

  trigger() {
    this.dispatchEvent(new CustomEvent('kemet-flipcard-flipped', {
      bubbles: true,
      composed: true,
      detail: this,
    }));
  }

  handleKeyup(event) {
    event.preventDefault();

    if (event.keyCode === this.keyCodes.ENTER) {
      this.trigger();
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-flipcard-trigger') || customElements.define('kemet-flipcard-trigger', KemetFlipcardTrigger);

class KemetFlipcard extends s$1 {
  static get styles() {
    return r$3`
      *,
      ::after,
      ::before {
        box-sizing: border-box;
      }

      :host {
        display: inline-block;
        width: var(--kemet-flipcard-width, 100%);
        height: var(--kemet-flipcard-height, auto);
        aspect-ratio: var(--kemet-flipcard-ratio, 16/9);
        perspective: 1000px;
      }

      section {
        position: relative;
        width: 100%;
        height: 100%;
        transition: transform 0.8s;
        transform-style: preserve-3d;
      }

      .front,
      .back {
        position: absolute;
        display: flex;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        /* overflow: hidden; */
        border-radius: var(--kemet-flipcard-border-radius, 0);
        border: var(--kemet-flipcard-border, 2px solid var(--kemet-color-primary));
      }

      :host([rounded]) .front,
      :host([rounded]) .back {
        border-radius: var(--kemet-border-radius);
      }

      .front {
        color: var(--kemet-flipcard-front-color, #202020);
        background-color: var(--kemet-flipcard-front-background-color, #fafafa);
      }

      :host([flipped]) .front {
        z-index: -1;
      }

      .back {
        color: var(--kemet-flipcard-back-color, #202020);
        background-color: var(--kemet-flipcard-back-background-color, #fafafa)
      }

      :host([axis="horizontal"]) .back {
        transform: rotateY(180deg);
      }

      :host([flipped][axis="horizontal"]) section {
        transform: rotateY(180deg);
      }

      :host([axis="vertical"]) .back {
        transform: rotateX(180deg);
      }

      :host([flipped][axis="vertical"]) section {
        transform: rotateX(180deg);
      }

      :host([flip-on-hover]) section {
        cursor: pointer;
      }

      ::slotted([slot="front"]),
      ::slotted([slot="back"]) {
        display: inline-block;
        margin: auto;
        position: relative;
        width: 100%;
        height: 100%;
      }
    `;
  }

  static get properties() {
    return {
      axis: {
        type: String,
        reflect: true,
      },

      flipped: {
        type: Boolean,
        reflect: true,
      },

      flipOnHover: {
        type: Boolean,
        attribute: 'flip-on-hover',
      },

      height: {
        type: String,
      },

      measure: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.axis = 'horizontal';
    this.flipped = false;
    this.flipOnHover = false;
    this.height = 'auto';
    this.measure = false;

    this.addEventListener('kemet-flipcard-flipped', () => {
      this.flipped = !this.flipped;
    });
  }

  firstUpdated() {
    this.frontChildren = this.shadowRoot.querySelector('[name="front"]').assignedNodes({ flatten: true });
    this.backChildren = this.shadowRoot.querySelector('[name="back"]').assignedNodes({ flatten: true });

    [this.frontElement] = this.frontChildren;
    [this.backElement] = this.backChildren;

    window.addEventListener('resize', this.determineHeight.bind(this));
  }

  updated() {
    this.determineHeight();
  }

  render() {
    return $`
      <section
        tabindex="0"
        part="wrapper"
        @blur=${() => { if (this.flipOnHover) this.flipped = false; }}
        @focus=${() => { if (this.flipOnHover) this.flipped = true; }}
        @mouseover=${() => { if (this.flipOnHover) this.flipped = true; }}
        @mouseout=${() => { if (this.flipOnHover) this.flipped = false; }}>
        <div id="front" class="front" part="front">
          <slot name="front" @slotchange="${() => this.determineHeight()}"></slot>
        </div>
        <div id="back" class="back" part="back">
          <slot name="back" @slotchange="${() => this.determineHeight()}"></slot>
        </div>
      </section>
    `;
  }

  determineHeight() {
    // setTimeout is need to simulate a DOM repaint
    // without the repaint, offsetHeight on Custom Elements = 0
    // so this is needed for 'measure' to work correctly

    setTimeout(() => {
      if (this.measure) {
        if (this.frontElement.offsetHeight > this.backElement.offsetHeight) {
          this.height = `${this.frontElement.offsetHeight}px`;
        } else {
          this.height = `${this.backElement.offsetHeight}px`;
        }

        this.style.height = this.height;
      } else {
        this.style.removeProperty('height');
      }
    }, 0);
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-flipcard') || window.customElements.define('kemet-flipcard', KemetFlipcard);

class KemetInput extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          position: relative;
          display: block;
        }

        input {
          display: block;
          font-size: 1rem;
          width: 100%;
          height: var(--kemet-input-height, 50px);
          padding: var(--kemet-input-padding, 0.5rem 1rem);
          border: var(--kemet-input-border, 1px solid var(--kemet-color-primary));
          appearance: none;
          box-sizing: border-box;
        }

        input[type='color'] {
          min-width: 10rem;
        }

        input[type='search']::-webkit-search-decoration,
        input[type='search']::-webkit-search-cancel-button,
        input[type='search']::-webkit-search-results-button,
        input[type='search']::-webkit-search-results-decoration {
          display: none;
        }

        :host([status='error']) input {
          border: var(--kemet-input-border-color-error, 1px solid var(--kemet-color-error));
        }

        :host([status='success']) input {
          border: var(--kemet-input-border-color-success, 1px solid var(--kemet-color-success));
        }

        :host([status='warning']) input {
          border: var(--kemet-input-border-color-warning, 1px solid var(--kemet-color-warning));
        }

        :host([disabled]) input {
          opacity: 0.5;
        }

        :host([icon-left]) input {
          padding-left: var(--kemet-input-icon-left-padding, 3rem);
        }

        :host([icon-right]) input {
          padding-right: var(--kemet-input-icon-right-padding, 3rem);
        }

        :host([rounded]) input {
          border-radius: var(--kemet-input-border-radius-rounded, var(--kemet-border-radius));
        }

        :host([filled]) input {
          border: var(--kemet-input-border-filled, none);
          color: var(--kemet-input-color-filled, var(--kemet-color-white));
          background-color: var(--kemet-input-background-color-filled, var(--kemet-color-primary));
        }

        :host([filled]) kemet-icon,
        :host([filled]) input::placeholder {
          color: var(--kemet-input-color-filled, var(--kemet-color-white));
        }

        :host([status='error'][filled]) input {
          background-color: var(--kemet-input-background-color-error, var(--kemet-color-error));
        }

        :host([status='success'][filled]) input {
          background-color: var(--kemet-input-background-color-success, var(--kemet-color-success));
        }

        :host([status='warning'][filled]) input {
          background-color: var(--kemet-input-background-color-warning, var(--kemet-color-warning));
        }

        kemet-icon {
          color: var(--kemet-color-primary);
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        kemet-icon.left {
          left: 1rem;
        }

        kemet-icon.right {
          right: 1rem;
        }

        kemet-icon.eye,
        kemet-icon.search {
          cursor: pointer;
        }

        :host([status='error']) kemet-icon {
          color: var(--kemet-color-error);
        }

        :host([status='warning']) kemet-icon {
          color: var(--kemet-color-error);
        }

        :host([status='success']) kemet-icon {
          color: var(--kemet-color-success);
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * Used for the id of the input. Should match the slug used in a control if applicable.
       */
      slug: {
        type: String,
      },
      /**
       * The name of the input
       */
      name: {
        type: String,
      },
      /**
       * The placeholder attribute
       */
      placeholder: {
        type: String,
      },
      /**
       * The minlength attribute
       */
      minlength: {
        type: String,
      },
      /**
       * The maxlength attribute
       */
      maxlength: {
        type: String,
      },
      /**
       * The min attribute
       */
      min: {
        type: String,
      },
      /**
       * The max attribute
       */
      max: {
        type: String,
      },
      /**
       * The step attribute
       */
      step: {
        type: String,
      },
      /**
       * The autocomplete attribute
       */
      autocomplete: {
        type: String,
      },
      /**
       * The pattern attribute
       */
      pattern: {
        type: String,
      },
      /**
       * The input mode attribute
       */
      inputmode: {
        type: String,
      },
      /**
       * The autofocus attribute
       */
      autofocus: {
        type: Boolean,
      },
      /**
       * The disable attribute
       */
      disabled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The readonly attribute
       */
      readonly: {
        type: Boolean,
      },
      /**
       * The required attribute
       */
      required: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The type of input
       */
      type: {
        type: String,
      },
      /**
       * The input's value
       */
      value: {
        type: String,
      },
      /**
       * States whether or not the input is invalid
       */
      invalid: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The status of the input
       */
      status: {
        type: String,
        reflect: true,
      },
      /**
       * Activates validation on blur
       */
      validateOnBlur: {
        type: Boolean,
        attribute: 'validate-on-blur',
      },
      /**
       * Aria Autocomplete
       */
      ariaAutoComplete: {
        type: String,
        attribute: 'aria-autocomplete',
      },
      /**
       * Aria Controls
       */
      ariaControls: {
        type: String,
        attribute: 'aria-controls',
      },
      /**
       * Aria Active Descendant
       */
      ariaActiveDescendant: {
        type: String,
        attribute: 'aria-activedescendant',
      },
      /**
       * Displays rounded corners
       */
      rounded: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Displays a filled input box
       */
      filled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Custom Icon to the right of the input
       */
      iconRight: {
        type: String,
        reflect: true,
        attribute: 'icon-right',
      },
      /**
       * Custom Icon to the left of the input
       */
      iconLeft: {
        type: String,
        reflect: true,
        attribute: 'icon-left',
      },
      /**
       * Size of the icons
       */
      iconSize: {
        type: Number,
      },
      /**
       * The HTML5 validity object.
       */
      validity: {
        type: Object,
      },
      /**
       * Manages password visibility
       */
      isPasswordVisible: {
        type: Boolean,
      },
      /**
       * Input Type of keypress handled through handleInput(e)
       */
      inputType: {
        type: String,
      },
      /**
       * Determines if the input is focused
       */
      focused: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.name = 'input';
    this.type = 'text';
    this.value = '';
    this.status = 'standard';
    this.iconSize = 20;
    this.validateOnBlur = false;
    this.isPasswordVisible = false;
    this.focused = false;

    /**
     * Used only for form reactive controller
     */
    this.formSubmitController = new FormSubmitController(this);
  }

  firstUpdated() {
    // elements
    this.input = this.shadowRoot.querySelector('input');
    this.field = this.closest('kemet-field');
    this.form = this.closest('form');
    this.slug = this.field ? this.field.slug : 'input';

    if (this.field) {
      this.field.addEventListener('fmc-password-status', event => this.handleStatus(event));
    }
  }

  render() {
    return $`
      <div>
        ${this.makeIconLeft()}
        <input
          part="input"
          id=${this.slug}
          name=${this.name}
          placeholder=${l$1(this.placeholder)}
          minlength=${l$1(this.minlength)}
          maxlength=${l$1(this.maxlength)}
          min=${l$1(this.min)}
          max=${l$1(this.max)}
          step=${l$1(this.step)}
          autocomplete=${l$1(this.autocomplete)}
          aria-autocomplete=${l$1(this.ariaAutoComplete)}
          aria-controls=${l$1(this.ariaControls)}
          aria-activedescendant=${l$1(this.ariaActiveDescendant)}
          pattern=${l$1(this.pattern)}
          inputmode=${l$1(this.inputmode)}
          aria-invalid=${this.invalid ? 'true' : 'false'}
          ?autofocus=${this.autofocus}
          ?disabled=${this.disabled}
          ?readonly=${this.readonly}
          ?required=${this.required}
          .type="${this.type === 'password' && this.isPasswordVisible ? 'text' : this.type}"
          .value=${l(this.value)}
          @change=${this.handleChange}
          @input=${this.handleInput}
          @invalid=${this.handleInvalid}
          @focus=${this.handleFocus}
          @blur=${this.handleBlur}
        />
        ${this.makeIconRight()} ${this.makeIconClear()} ${this.makeVisibilityToggle()}
      </div>
    `;
  }

  /**
   * Makes the right icon
   * @private
   * @returns {templateResult} A right icon
   */
  makeIconRight() {
    if (this.iconRight) {
      return $`
        <kemet-icon class="right" icon="${this.iconRight}" size="${this.iconSize ? this.iconSize : 20}"></kemet-icon>
      `;
    }

    return null;
  }

  /**
   * Makes the left icon
   * @private
   * @returns {templateResult} A left icon
   */
  makeIconLeft() {
    if (this.iconLeft) {
      return $`
        <kemet-icon class="left" icon="${this.iconLeft}" size="${this.iconSize ? this.iconSize : 16}"></kemet-icon>
      `;
    }

    return null;
  }

  /**
   * Makes a clear icon for search.
   * @private
   * @returns {templateResult} A search icon
   */
  makeIconClear() {
    if (this.type === 'search' && this.value !== '') {
      return $`
        <kemet-icon class="search right" icon="x-lg" size="${this.iconSize}" @click=${() => this.handleClear()}></kemet-icon>
      `;
    }

    return null;
  }

  /**
   * Makes a password visibility toggle button
   * @returns {templateResult} A mask or unmask icon
   */
  makeVisibilityToggle() {
    if (this.type === 'password') {
      return $`<kemet-icon
        class="eye right"
        icon="${this.setPasswordIcon()}"
        @click=${() => this.togglePasswordVisibility()}
      ></kemet-icon>`;
    }

    return null;
  }

  setPasswordIcon() {
    if (this.isPasswordVisible) {
      return 'eye';
    }

    return 'eye-slash';
  }

  /**
   * Handles when the input receives focus
   * @private
   */
  handleFocus() {
    this.focused = true;

    /**
     * Fires when the input receives and loses focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-focused', {
        bubbles: true,
        composed: true,
        detail: true,
      }),
    );
  }

  /**
   * Handles when the input loses focus
   * @private
   */
  handleBlur() {
    if (this.validateOnBlur && this.form && !this.form.noValidate) {
      this.input.checkValidity();
      this.validity = this.input.validity;
    }

    this.focused = false;

    /**
     * Fires when the input receives and loses focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-focused', {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    );
  }

  /**
   * Handles when the input changes value
   * @private
   */
  handleChange() {
    this.value = this.input.value;

    if (this.input.checkValidity() && this.checkLimitValidity() && this.status !== 'success') {
      this.invalid = false;
      this.status = 'standard';
      this.validity = this.input.validity;

      /**
       * Fires when there's a change in status.
       * This event includes an object that reports:
       * 1) the status. 2) HTML5 validity object. 3) the component element.
       * Use the validity object to support custom validation messages.
       */
      this.dispatchEvent(
        new CustomEvent('kemet-input-status', {
          bubbles: true,
          composed: true,
          detail: {
            status: 'standard',
            validity: this.input.validity,
            element: this,
          },
        }),
      );
    }
  }

  /**
   * Handles when the input receives input
   * @private
   */
  handleInput() {
    this.value = this.input.value;

    /**
     * Fires when the input receives input
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-input', {
        bubbles: true,
        composed: true,
        detail: this.value,
      }),
    );
  }

  /**
   * Handles when the input has an error
   * @private
   */
  handleInvalid() {
    this.validity = this.input.validity;

    if (this.validateOnBlur) {
      this.invalid = true;
      this.status = 'error';

      /**
       * Fires when there's a change in status
       */
      this.dispatchEvent(
        new CustomEvent('kemet-input-status', {
          bubbles: true,
          composed: true,
          detail: {
            status: 'error',
            validity: this.input.validity,
            element: this,
          },
        }),
      );
    }
  }

  handleStatus(event) {
    this.status = event.detail.status;
  }

  /**
   * Toggles password visibility
   * @private
   */
  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  /**
   * Handles the clear button for search
   * @private
   */
  handleClear() {
    this.value = '';

    /**
     * Fires when the input receives input
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-input', {
        bubbles: true,
        composed: true,
        detail: this.value,
      }),
    );
  }

  /**
   * Checks the validity of the character limit for the count component
   * @private
   * @returns {boolean}
   */
  checkLimitValidity() {
    if (this.field) {
      const count = this.field.querySelector('kemet-count');
      if (count) {
        return this.value.length < count.limit;
      }
    }

    return true;
  }

  /**
   * Checks the validity of the standard input
   * @public
   * @returns {boolean}
   */
  checkValidity() {
    return this.input.checkValidity();
  }

  /**
   * Focuses the standard input
   * @public
   */
  focus() {
    this.input.focus();
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-input') || customElements.define('kemet-input', KemetInput);

class KemetModalClose extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          position: absolute;
          top: -0.5rem;
          right: -0.5rem;
          border: 2px solid white;
          border-radius: 50%;
          cursor: pointer;
        }
      `,
    ];
  }

  render() {
    return $`
      <slot @keyup=${() => this.close()} @click=${() => this.close()}></slot>
    `;
  }

  close() {
    /**
     * Fires when the close button is pressed
     */
    this.dispatchEvent(new CustomEvent('kemet-modal-close-pressed', {
      bubbles: true,
      composed: true,
      detail: this,
    }));
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-modal-close') || customElements.define('kemet-modal-close', KemetModalClose);

const stylesBase = r$3`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host {
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100vh;
    visibility: hidden;
    backface-visibility: hidden;
  }

  :host([opened]) {
    visibility: visible;
  }

  .content {
    position: relative;
    z-index: 3;
    margin: auto;
    min-width: var(--kemet-modal-content-min-width, 0);
    max-width: var(--kemet-modal-content-max-width, none);
  }

  :host([mobile]) .content {
    min-width: var(--kemet-modal-content-mobile-min-width, 100%);
    min-height: var(--kemet-modal-content-mobile-min-height, 80vh);
    padding: var(--kemet-modal-content-mobile-padding, 1rem);
  }

  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    visibility: hidden;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 0;
    background: var(--kemet-modal-overlay-background-color, rgba(0,0,0,0.2));
    transition: all var(--kemet-modal-transition-speed, 0.3s);
  }

  :host([opened]) .overlay {
    opacity: 1;
    visibility: visible;
  }
`;

const stylesEffects = r$3`
  /* fadein-scaleup */
  :host([effect="fadein-scaleup"]) .content {
    transform: scale(0.7);
    opacity: 0;
    transition: all var(--kemet-modal-transition-speed, 0.3s);
  }

  :host([effect="fadein-scaleup"][opened]) .content {
    transform: scale(1);
    opacity: 1;
  }

  /* slide-right */
  :host([effect="slide-right"]) .content {
    transform: translateX(20%);
    opacity: 0;
    transition: all var(--kemet-modal-transition-speed, 0.3s) cubic-bezier(0.25, 0.5, 0.5, 0.9);
  }

  :host([effect="slide-right"][opened]) .content {
    transform: translateX(0);
    opacity: 1;
  }

  /* slide-bottom */
  :host([effect="slide-bottom"]) .content {
    transform: translateY(20%);
    opacity: 0;
    transition: all var(--kemet-modal-transition-speed, 0.3s);
  }

  :host([effect="slide-bottom"][opened]) .content {
    transform: translateY(0);
    opacity: 1;
  }

  /* newspaper */
  :host([effect="newspaper"]) .content {
    transform: scale(0) rotate(720deg);
    opacity: 0;
    transition: all var(--kemet-modal-transition-speed, 0.3s);
  }

  :host([effect="newspaper"][opened]) .content {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }

  /* fall */
  :host([effect="fall"]) {
    perspective: 1300px;
  }

  :host([effect="fall"]) .content {
    transform-style: preserve-3d;
    transform: translateZ(600px) rotateX(20deg);
    opacity: 0;
  }

  :host([effect="fall"][opened]) .content {
    transition: all var(--kemet-modal-transition-speed, 0.3s) ease-in;
    transform: translateZ(0px) rotateX(0deg);
    opacity: 1;
  }

  /* side-fall */
  :host([effect="side-fall"]) {
    perspective: 1300px;
  }

  :host([effect="side-fall"]) .content {
    transform-style: preserve-3d;
    transform: translate(30%) translateZ(600px) rotate(10deg);
    opacity: 0;
  }

  :host([effect="side-fall"][opened]) .content {
    transition: all var(--kemet-modal-transition-speed, 0.3s) ease-in;
    transform: translate(0%) translateZ(0) rotate(0deg);
    opacity: 1;
  }

  /* flip-horizontal */
  :host([effect="flip-horizontal"]) {
    perspective: 1300px;
  }

  :host([effect="flip-horizontal"]) .content {
    transform-style: preserve-3d;
    transform: rotateY(-70deg);
    transition: all var(--kemet-modal-transition-speed, 0.3s);
    opacity: 0;
  }

  :host([effect="flip-horizontal"][opened]) .content {
    transform: rotateY(0deg);
    opacity: 1;
  }

  /* flip-vertical */
  :host([effect="flip-vertical"]) {
    perspective: 1300px;
  }

  :host([effect="flip-vertical"]) .content {
    transform-style: preserve-3d;
    transform: rotateX(-70deg);
    transition: all var(--kemet-modal-transition-speed, 0.3s);
    opacity: 0;
  }

  :host([effect="flip-vertical"][opened]) .content {
    transform: rotateX(0deg);
    opacity: 1;
  }

  /* sign-3d */
  :host([effect="sign-3d"]) {
    perspective: 1300px;
  }

  :host([effect="sign-3d"]) .content {
    transform-style: preserve-3d;
    transform: rotateX(-60deg);
    transform-origin: 50% 0;
    opacity: 0;
    transition: all var(--kemet-modal-transition-speed, 0.3s);
  }

  :host([effect="sign-3d"][opened]) .content {
    transform: rotateX(0deg);
    opacity: 1;
  }

  /* super-scaled */
  :host([effect="super-scaled"]) .content {
    transform: scale(2);
    opacity: 0;
    transition: all var(--kemet-modal-transition-speed, 0.3s);
  }

  :host([effect="super-scaled"][opened]) .content {
    transform: scale(1);
    opacity: 1;
  }

  /* slit */
  :host([effect="slit"]) {
    perspective: 1300px;
  }

  :host([effect="slit"]) .content {
    transform-style: preserve-3d;
    transform: translateZ(-3000px) rotateY(90deg);
    opacity: 0;
  }

  :host([effect="slit"][opened]) .content {
    animation: slit .7s forwards ease-out;
  }

  @keyframes slit {
    50% {
      transform: translateZ(-250px) rotateY(89deg);
      opacity: 1;
      animation-timing-function: ease-in;}
    100% {
      transform: translateZ(0) rotateY(0deg);
      opacity: 1;
    }
  }

  /* rotate-bottom */
  :host([effect="rotate-bottom"]) {
    perspective: 1300px;
  }

  :host([effect="rotate-bottom"]) .content {
    transform-style: preserve-3d;
    transform: translateY(100%) rotateX(90deg);
    transform-origin: 0 100%;
    opacity: 0;
    transition: all var(--kemet-modal-transition-speed, 0.3s) ease-out;
  }

  :host([effect="rotate-bottom"][opened]) .content {
    transform: translateY(0%) rotateX(0deg);
    opacity: 1;
  }

  /* rotate-left */
  :host([effect="rotate-left"]) {
    perspective: 1300px;
  }

  :host([effect="rotate-left"]) .content {
    transform-style: preserve-3d;
    transform: translateZ(100px) translateX(-30%) rotateY(90deg);
    transform-origin: 0 100%;
    opacity: 0;
    transition: all var(--kemet-modal-transition-speed, 0.3s);
  }

  :host([effect="rotate-left"][opened]) .content {
    transform: translateZ(0px) translateX(0%) rotateY(0deg);
    opacity: 1;
  }
`;

class KemetModal extends s$1 {
  static get styles() {
    return [
      stylesBase,
      stylesEffects,
    ];
  }

  static get properties() {
    return {
      opened: {
        type: Boolean,
        reflect: true,
      },
      effect: {
        type: String,
        reflect: true,
      },
      closeOnClick: {
        type: Boolean,
        attribute: 'close-on-click',
      },
      breakpoint: {
        type: String,
      },
      mobile: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.opened = false;
    this.closeOnClick = false;
    this.breakpoint = '600px';

    // bindings
    this.addEventListener('kemet-modal-close-pressed', () => { this.opened = false; });
  }

  firstUpdated() {
    // standard properties
    this.focusableSelector = 'body, a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    this.focusableElements = this.querySelectorAll(this.focusableSelector);

    // events
    this.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.opened = false;
      }
    });

    this.addEventListener('click', (event) => {
      if (this.opened && this.closeOnClick && event.target.tagName.toLowerCase() === 'kemet-modal') {
        this.opened = false;
      }
    });

    window.addEventListener('resize', () => {
      this.isMobile();
    });

    this.focusableElements.forEach((element) => {
      element.addEventListener('keydown', event => this.handleFocusableDown(event));
    });
  }

  updated(prevProps) {
    if (!prevProps.get('opened') && this.opened === true) {
      setTimeout(() => {
        this.focusableElements[0]?.focus();
      }, 100);

      /**
       * Fires when the modal opens
       */
      this.dispatchEvent(
        new CustomEvent('kemet-modal-opened', {
          bubbles: true,
          composed: true,
          detail: this,
        }),
      );
    }

    if (prevProps.get('opened') && this.opened === false) {
      /**
       * Fires when the modal closes
       */
      this.dispatchEvent(
        new CustomEvent('kemet-modal-closed', {
          bubbles: true,
          composed: true,
          detail: this,
        }),
      );
    }

    this.isMobile();
  }

  render() {
    return $`
      <div class="content" part="content">
        <slot></slot>
      </div>
      <div class="overlay" part="overlay"></div>
    `;
  }

  isMobile() {
    const mediaQuery = window.matchMedia(`(max-width: ${this.breakpoint})`);
    this.mobile = mediaQuery.matches;
  }

  handleFocusableDown(event) {
    const firstFocusable = this.focusableElements[0];
    const lastFocusable = this.focusableElements[this.focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-modal') || customElements.define('kemet-modal', KemetModal);

class KemetPassword extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          color: inherit;
          display: none;
        }

        :host([show]) {
          display: block;
        }

        p {
          margin: 1.6rem 0;
        }

        .status {
          display: grid;
          align-items: center;
          grid-template-columns: 1fr auto;
          line-height: 1;
          margin-top: 0.8rem;
        }

        .status > span {
          text-transform: capitalize;
        }

        .status--weak,
        .status--better {
          color: var(--kemet-color-error);
        }

        .status--strong {
          color: var(--kemet-color-success);
        }

        .indicator {
          display: flex;
          gap: 0.4rem;
          margin: 0;
          list-style: none;
        }

        .indicator li {
          width: 1.6rem;
          height: 0.2rem;
          background-color: var(--fds-color--gray2);
        }

        .status--weak .indicator li:nth-child(1) {
          background-color: var(--kemet-color-error);
        }

        .status--better .indicator li:nth-child(1),
        .status--better .indicator li:nth-child(2) {
          background-color: var(--kemet-color-error);
        }

        .status--strong .indicator li {
          background-color: var(--kemet-color-success);
        }

        .rules {
          color: var(--kemet-color-primary);
          list-style: none;
          font-size: 90%;
          padding-left: 2rem;
        }

        .rules li {
          position: relative;
        }

        .rules kemet-icon {
          color: var(--kemet-color-success);
          position: absolute;
          left: -2.4rem;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * An array of objects containing the rules the password must meet
       */
      rules: {
        type: Array,
      },
      /**
       * Controls the display of the component
       */
      show: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The value of the input component
       */
      value: {
        type: String,
      },
      /**
       * A message that is above the rules
       */
      message: {
        type: String,
      },
      /**
       * The strength of the password. Weak | Better | Strong
       */
      strength: {
        type: String,
      },
      icon: {
        type: String,
      },
      iconSize: {
        type: Number,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.rules = [
      { pattern: '(?=.{8,}$)', message: 'At least 8 characters long' },
      { pattern: '(?=.*[a-z])(?=.*[A-Z])', message: 'Uppercase and lowercase' },
      { pattern: '(?=.*[0-9])', message: 'At least one number (0-9)' },
    ];
    this.message = 'Please make sure you meet all the requirements.';
    this.icon = 'check2';
    this.iconSize = 16;
  }

  firstUpdated() {
    // standard properties
    this.field = this.closest('kemet-field');
    this.input = this.field.querySelector('[slot="input"]');

    // managed properties
    this.slug = this.field.slug;

    // events listeners
    this.input.addEventListener('kemet-input-input', this.handleInput.bind(this));
  }

  render() {
    return $`
      <div role="alert" aria-live="assertive">
        <div class="status status--${this.strength}" part="status">
          <span>${this.strength}</span>
          <ul class="indicator" part="indicator">
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
        <p class="message" part="message">${this.message}</p>
        <ul class="rules" part="rules">
          ${this.makeRules()}
        </ul>
      </div>
    `;
  }

  /**
   * Makes the list of rules
   * @private
   * @returns {templateResults} the criteria rules
   */
  makeRules() {
    if (this.input) {
      const rules = this.rules.map((rule, index) => {
        const regExp = new RegExp(rule.pattern);
        const meetsCriteria = regExp.test(this.input.value);
        this.rules[index].meetsCriteria = meetsCriteria;
        return $`<li>${this.makeCheckIcon(meetsCriteria)} ${rule.message}</li>`;
      });

      return rules;
    }

    return null;
  }

  /**
   * Makes the check icon if the criteria has been met
   * @param {boolean} meetsCriteria
   * @private
   * @returns {templateResults} an icon component
   */
  makeCheckIcon(meetsCriteria) {
    if (meetsCriteria) {
      return $`<kemet-icon icon=${this.icon} size=${this.iconSize}></kemet-icon>`;
    }

    return null;
  }

  /**
   * Handles the kemet-input-input event
   * @param {*} event
   * @private
   */
  handleInput(event) {
    this.value = event.detail;
    this.setStrength();
    this.visibility();
  }

  /**
   * Determines the strength of the password
   * @private
   */
  setStrength() {
    // We use a setTimeout here because makeRules adds the meetsCriteria
    // property to the rules. We need that to be set by render() before
    // setting the Strength because the percentage calc is based on it
    setTimeout(() => {
      const totalRules = this.rules.length;
      const metRules = this.rules.filter(rule => rule.meetsCriteria).length;
      const metRulesPercentage = Math.round((metRules / totalRules) * 100) / 100;

      if (metRulesPercentage <= 0.33) {
        this.strength = 'weak';
        this.status = 'error';
      }

      if (metRulesPercentage > 0.33 && metRulesPercentage <= 0.67) {
        this.strength = 'better';
        this.status = 'error';
      }

      if (metRulesPercentage > 0.67) {
        this.strength = 'strong';
        this.status = 'success';
      }

      /**
       * Fires when there's a change in status.
       */
      this.dispatchEvent(
        new CustomEvent('kemet-password-status', {
          bubbles: true,
          composed: true,
          detail: {
            status: this.status,
            validity: { meetsPasswordCriteria: this.status === 'success' },
            element: this,
          },
        }),
      );
    }, 1);
  }

  /**
   * Determines whether to show or hide the component
   * @private
   */
  visibility() {
    if (this.value.length > 0) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-password') || customElements.define('kemet-password', KemetPassword);

const keyCodes$1 = {
  ENTER: 13,
  SPACE: 32,
  ESC: 27,
};

class KemetPopoverClose extends s$1 {
  static get styles() {
    return [
      r$3`
        button {
          font: inherit;
          color: inherit;
          cursor: pointer;
          border: 0;
          background: transparent;
        }
      `,
    ];
  }

  render() {
    return $`
      <button @click=${() => this.close()} @keyup=${event => this.handleKeyboard(event)}>
        <slot></slot>
      </button>
    `;
  }

  close() {
    this.dispatchEvent(
      new CustomEvent('kemet-popover-close-btn', {
        bubbles: true,
        composed: true,
        detail: this,
      }),
    );
  }

  handleKeyboard(event) {
    event.preventDefault();

    if (event.keyCode === keyCodes$1.SPACE || event.keyCode === keyCodes$1.ENTER) {
      this.close();
    }
  }
}

window.customElements.define('kemet-popover-close', KemetPopoverClose);

const fade = r$3`
  :host([effect="fade"]) #content {
    opacity: 0;
    transition: all var(--kemet-popover-transition-speed, 0.3s);
  }

  :host([effect="fade"][opened]) #content {
    opacity: 1;
  }
`;

const scale = r$3`
  :host([effect="scale"]) #content {
    opacity: 0;
    transition: all var(--kemet-popover-transition-speed, 0.3s);
  }

  :host([effect="scale"][opened]) #content {
    opacity: 1;
  }

  :host([effect="scale"][position="top"]) #content,
  :host([effect="scale"][position="bottom"]) #content {
    transform: translateX(-50%) scale(0.7);
  }

  :host([effect="scale"][position="top"][opened]) #content,
  :host([effect="scale"][position="bottom"][opened]) #content {
    transform: translateX(-50%) scale(1);
  }

  :host([effect="scale"][position="left"]) #content,
  :host([effect="scale"][position="right"]) #content {
    transform: translateY(-50%) scale(0.7);
  }

  :host([effect="scale"][position="left"][opened]) #content,
  :host([effect="scale"][position="right"][opened]) #content {
    transform: translateY(-50%) scale(1);
  }
`;

const slide = r$3`
  :host([effect="slide"]) #content {
    opacity: 0;
    transition: all var(--kemet-popover-transition-speed, 0.3s) cubic-bezier(0.25, 0.5, 0.5, 0.9);
  }

  :host([effect="slide"][opened]) #content {
    opacity: 1;
  }

  :host([effect="slide"][position="top"]) #content {
    transform: translateX(-50%) translateY(20%);
  }

  :host([effect="slide"][position="top"][opened]) #content {
    transform: translateX(-50%) translateY(0);
  }

  :host([effect="slide"][position="bottom"]) #content {
    transform: translateX(-50%) translateY(-20%);
  }

  :host([effect="slide"][position="bottom"][opened]) #content {
    transform: translateX(-50%) translateY(0);
  }

  :host([effect="slide"][position="right"]) #content {
    transform: translateY(-50%) translateX(-20%);
  }

  :host([effect="slide"][position="right"][opened]) #content {
    transform: translateY(-50%) translateX(0);
  }

  :host([effect="slide"][position="left"]) #content {
    transform: translateY(-50%) translateX(20%);
  }

  :host([effect="slide"][position="left"][opened]) #content {
    transform: translateY(-50%) translateX(0);
  }
`;

const fall = r$3`
  :host([effect="fall"]) {
    perspective: 1300px;
  }

  :host([effect="fall"]) #content {
    transform-style: preserve-3d;
    opacity: 0;
  }

  :host([effect="fall"][opened]) #content {
    transition: all var(--kemet-popover-transition-speed, 0.3s) ease-in;
    opacity: 1;
  }

  :host([effect="fall"][position="top"]) #content {
    transform: translateX(-50%) translateZ(600px) rotateX(20deg);
  }

  :host([effect="fall"][position="top"][opened]) #content {
    transform: translateX(-50%) translateZ(0px) rotateX(0deg);
  }

  :host([effect="fall"][position="bottom"]) #content {
    transform: translateX(-50%) translateZ(600px) rotateX(20deg);
  }

  :host([effect="fall"][position="bottom"][opened]) #content {
    transform: translateX(-50%) translateZ(0px) rotateX(0deg);
  }

  :host([effect="fall"][position="right"]) #content {
    transform: translateY(-50%) translateZ(600px) rotateX(20deg);
  }

  :host([effect="fall"][position="right"][opened]) #content {
    transform: translateY(-50%) translateZ(0px) rotateX(0deg);
  }

  :host([effect="fall"][position="left"]) #content {
    transform: translateY(-50%) translateZ(600px) rotateX(20deg);
  }

  :host([effect="fall"][position="left"][opened]) #content {
    transform: translateY(-50%) translateZ(0px) rotateX(0deg);
  }
`;

const flipHorizontal = r$3`
  :host([effect="flip-horizontal"]) {
    perspective: 1300px;
  }

  :host([effect="flip-horizontal"]) #content {
    transform-style: preserve-3d;
    transition: all var(--kemet-popover-transition-speed, 0.3s);
    opacity: 0;
  }

  :host([effect="flip-horizontal"][opened]) #content {
    opacity: 1;
  }

  :host([effect="flip-horizontal"][position="top"]) #content {
    transform: translateX(-50%) rotateY(-70deg);
  }

  :host([effect="flip-horizontal"][position="top"][opened]) #content {
    transform: translateX(-50%) rotateY(0deg);
  }

  :host([effect="flip-horizontal"][position="bottom"]) #content {
    transform: translateX(-50%) rotateY(-70deg);
  }

  :host([effect="flip-horizontal"][position="bottom"][opened]) #content {
    transform: translateX(-50%) rotateY(0deg);
  }

  :host([effect="flip-horizontal"][position="right"]) #content {
    transform: translateY(-50%) rotateY(-70deg);
  }

  :host([effect="flip-horizontal"][position="right"][opened]) #content {
    transform: translateY(-50%) rotateY(0deg);
  }

  :host([effect="flip-horizontal"][position="left"]) #content {
    transform: translateY(-50%) rotateY(-70deg);
  }

  :host([effect="flip-horizontal"][position="left"][opened]) #content {
    transform: translateY(-50%) rotateY(0deg);
  }
`;

const flipVertical = r$3`
  :host([effect="flip-vertical"]) {
    perspective: 1300px;
  }

  :host([effect="flip-vertical"]) #content {
    transform-style: preserve-3d;
    transition: all var(--kemet-popover-transition-speed, 0.3s);
    opacity: 0;
  }

  :host([effect="flip-vertical"][opened]) #content {
    opacity: 1;
  }

  :host([effect="flip-vertical"][position="top"]) #content {
    transform: translateX(-50%) rotateX(-70deg);
  }

  :host([effect="flip-vertical"][position="top"][opened]) #content {
    transform: translateX(-50%) rotateX(0deg);
  }

  :host([effect="flip-vertical"][position="bottom"]) #content {
    transform: translateX(-50%) rotateX(-70deg);
  }

  :host([effect="flip-vertical"][position="bottom"][opened]) #content {
    transform: translateX(-50%) rotateX(0deg);
  }

  :host([effect="flip-vertical"][position="right"]) #content {
    transform: translateY(-50%) rotateX(-70deg);
  }

  :host([effect="flip-vertical"][position="right"][opened]) #content {
    transform: translateY(-50%) rotateX(0deg);
  }

  :host([effect="flip-vertical"][position="left"]) #content {
    transform: translateY(-50%) rotateX(-70deg);
  }

  :host([effect="flip-vertical"][position="left"][opened]) #content {
    transform: translateY(-50%) rotateX(0deg);
  }
`;

const sign = r$3`
  :host([effect="sign"]) {
    perspective: 1300px;
  }

  :host([effect="sign"]) #content {
    transform-style: preserve-3d;
    transition: all var(--kemet-popover-transition-speed, 0.3s);
    opacity: 0;
  }

  :host([effect="sign"][opened]) #content {
    opacity: 1;
  }

  :host([effect="sign"][position="top"]) #content {
    transform-origin: 0 100%;
    transform: translateX(-50%) rotateX(90deg);
  }

  :host([effect="sign"][position="top"][opened]) #content {
    transform: translateX(-50%) rotateX(0deg);
  }

  :host([effect="sign"][position="bottom"]) #content {
    transform-origin: 100% 0;
    transform: translateX(-50%) rotateX(90deg);
  }

  :host([effect="sign"][position="bottom"][opened]) #content {
    transform: translateX(-50%) rotateX(0deg);
  }

  :host([effect="sign"][position="right"]) #content {
    transform-origin: 0 100%;
    transform: translateY(-50%) rotateY(90deg);
  }

  :host([effect="sign"][position="right"][opened]) #content {
    transform: translateY(-50%) rotateY(0deg);
  }

  :host([effect="sign"][position="left"]) #content {
    transform-origin: 100% 0;
    transform: translateY(-50%) rotateY(90deg);
  }

  :host([effect="sign"][position="left"][opened]) #content {
    transform: translateY(-50%) rotateY(0deg);
  }
`;

const superScaled = r$3`
  :host([effect="super-scaled"]) #content {
    opacity: 0;
    transition: all var(--kemet-popover-transition-speed, 0.3s);
  }

  :host([effect="super-scaled"][opened]) #content {
    opacity: 1;
  }

  :host([effect="super-scaled"][position="top"]) #content,
  :host([effect="super-scaled"][position="bottom"]) #content {
    transform: translateX(-50%) scale(2);
  }

  :host([effect="super-scaled"][position="top"][opened]) #content,
  :host([effect="super-scaled"][position="bottom"][opened]) #content {
    transform: translateX(-50%) scale(1);
  }

  :host([effect="super-scaled"][position="left"]) #content,
  :host([effect="super-scaled"][position="right"]) #content {
    transform: translateY(-50%) scale(2);
  }

  :host([effect="super-scaled"][position="left"][opened]) #content,
  :host([effect="super-scaled"][position="right"][opened]) #content {
    transform: translateY(-50%) scale(1);
  }
`;

const tooltip = r$3`
  #tooltip {
    display: flex;
    position: absolute;
  }

  #tooltip polygon {
    fill: var(--kemet-popover-background-color, #202020);
  }

  :host([position="top"]) #tooltip {
    left: 50%;
    transform: translateX(-50%);
  }

  :host([position="right"]) #tooltip {
    right: 100%;
    top: 50%;
    transform-origin: top;
    transform: translateY(-50%);
  }

  :host([position="bottom"]) #tooltip {
    bottom: 100%;
    left: 50%;
    transform-origin: left;
    transform: translateX(-50%);
  }

  :host([position="left"]) #tooltip {
    left: 100%;
    top: 50%;
    transform-origin: top;
    transform: translateY(-50%);
  }

  /* svg */
  #tooltip svg {
    position: relative;
  }

  :host([position="right"]) svg {
    transform: rotate(90deg);
    right: -8px;
  }

  :host([position="bottom"]) svg {
    transform: rotate(180deg);
    right: -8px;
  }

  :host([position="left"]) svg {
    transform: rotate(270deg);
    right: 8px;
  }
`;

const customTooltip = r$3`
  #custom-tooltip {
    display: flex;
    position: absolute;
    z-index: 3;
  }

  :host([position="top"]) #custom-tooltip {
    left: 50%;
    transform: translateX(-50%);
  }

  :host([position="right"]) #custom-tooltip {
    right: 100%;
    top: 50%;
    transform-origin: top;
    transform: translateY(-50%);
  }

  :host([position="bottom"]) #custom-tooltip {
    bottom: 100%;
    left: 50%;
    transform-origin: left;
    transform: translateX(-50%);
  }

  :host([position="left"]) #custom-tooltip {
    left: 100%;
    top: 50%;
    transform-origin: top;
    transform: translateY(-50%);
  }

  ::slotted([slot="custom-tooltip"]) {
    display: flex;
  }
`;

const keyCodes = {
  ENTER: 13,
  SPACE: 32,
  ESC: 27,
};

class KemetPopover extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: inline-block;
          position: relative;
          z-index: unset;
        }

        #trigger {
          display: inline-block;
          cursor: pointer;
        }

        ::slotted([slot="trigger"]) {
          position: relative;
          /* z-index: 2; */
        }

        #content {
          visibility: hidden;
          pointer-events: none;
          width: var(--kemet-popover-width, 100%);
          height: var(--kemet-popover-height, auto);
          position: absolute;
          z-index: -1;
        }

        :host([opened]) #content {
          visibility: visible;
          z-index: 9;
          pointer-events: auto;
        }

        ::slotted([slot="content"]) {
          color: var(--kemet-popover-color, #fafafa);
          display: block;
          position: relative;
          z-index: 2;
          cursor: default;
          width: 100%;
          padding: 1rem;
          box-sizing: border-box;
          background-color: var(--kemet-popover-background-color, #202020);
          transform: translate(var(--kemet-popover-content-offset-x, 0), var(--kemet-popover-content-offset-y, 0));
        }

        :host([position="top"]) #content {
          bottom: calc(100% + var(--kemet-popover-gap, 1rem));
          left: 50%;
          transform: translateX(-50%);
        }

        :host([position="right"]) #content {
          left: calc(100% + var(--kemet-popover-gap, 1rem));
          top: 50%;
          transform: translateY(-50%);
        }

        :host([position="bottom"]) #content {
          top: calc(100% + var(--kemet-popover-gap, 1rem));
          left: 50%;
          transform: translateX(-50%);
        }

        :host([position="left"]) #content {
          right: calc(100% + var(--kemet-popover-gap, 1rem));
          top: 50%;
          transform: translateY(-50%);
        }

        #overlay {
          display: none;
        }

        :host([opened]) #overlay {
          display: block;
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
          min-height: 100vh;
        }
      `,
      tooltip,
      customTooltip,
      fade,
      scale,
      slide,
      fall,
      flipHorizontal,
      flipVertical,
      sign,
      superScaled,
    ];
  }

  static get properties() {
    return {
      /**
       * Determines whether or not the popover displays.
       */
      opened: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The opening and closing effect of the popover. Is optional.
       * Values include:
       * (fade | scale | slide | fall | flip horizontal | flip vertical | sign | super scaled)
       */
      effect: {
        string: String,
        reflect: true,
      },
      /**
       * Determines the placement of the popover.
       * Values include: (top | right | bottom | left)
       */
      position: {
        type: String,
        reflect: true,
      },
      /**
       * Adds a built in tooltip to the popover.
       */
      tooltip: {
        type: Boolean,
      },
      /**
       * Adds a custom tooltip to the popover.
       * Use the custom-tooltip slot to specify the custom tooltip.
       */
      customTooltip: {
        type: Boolean,
        attribute: 'custom-tooltip',
      },
      /**
       * Controls how the trigger should activate the popover.
       * Values include: (click | hover)
       */
      fireOn: {
        type: String,
        attribute: 'fire-on',
      },
      /**
       * Allows the popover to be closed by clicking outside of its content.
       */
      clickOutside: {
        type: Boolean,
        attribute: 'click-outside',
      },
      /**
       * Intelligently positions the popover.
       */
      smart: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();

    this.opened = false;
    this.effect = null;
    this.position = 'top';
    this.tooltip = false;
    this.customTooltip = false;
    this.fireOn = 'hover';
    this.clickOutside = false;
    this.smart = true;

    this.addEventListener('kemet-popover-close-btn', this.close.bind(this));
  }

  firstUpdated() {
    // standard properties
    this.focusableSelector = 'body, a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable], kemet-popover-close';
    this.focusableElements = this.querySelectorAll(this.focusableSelector);

    // eslint-disable-next-line prefer-destructuring
    this.contentElement = this.shadowRoot
      .querySelector('slot[name="content"]')
      .assignedNodes({ flatten: true })[0];

    window.addEventListener('resize', () => {
      this.smartContent();
    });

    if (this.fireOn === 'click') {
      this.focusableElements.forEach((element) => {
        element.addEventListener('keydown', event => this.handleFocusableDown(event));
      });
    }
  }

  updated(prevProps) {
    if (!prevProps.get('opened') && this.opened === true) {
      /**
       * Fires when the popover opens.
       */
      this.dispatchEvent(
        new CustomEvent('kemet-popover-opened', {
          bubbles: true,
          composed: true,
          detail: this,
        }),
      );
    }

    if (prevProps.get('opened') && this.opened === false) {
      /**
       * Fires when the popover closes.
       */
      this.dispatchEvent(
        new CustomEvent('kemet-popover-closed', {
          bubbles: true,
          composed: true,
          detail: this,
        }),
      );
    }

    this.smartContent();
  }

  render() {
    return $`
      <div
        id="trigger"
        part="trigger"
        tabIndex="0"
        @click=${this.fireOn === 'click' ? event => this.toggle(event) : null}
        @keyup=${this.fireOn === 'click' ? event => this.handleKeyUp(event) : null}
        @mouseover=${this.fireOn !== 'click' ? () => this.open() : null}
        @focus=${this.fireOn !== 'click' ? () => this.open() : null}
        @mouseout=${this.fireOn !== 'click' ? () => this.close() : null}
        @blur=${this.fireOn !== 'click' ? () => this.close() : null}>
        <slot name="trigger"></slot>
        <div id="content" part="content">
          <slot name="content"></slot>
          ${this.makeTooltip()}
        </div>
      </div>
      ${this.makeOverlay()}
    `;
  }

  open() {
    this.opened = true;
  }

  close() {
    this.opened = false;
  }

  toggle(event) {
    const isSlotTrigger = event.target.getAttribute('slot') === 'trigger';
    const isPartTrigger = event.target.getAttribute('part') === 'trigger';

    if (isSlotTrigger || isPartTrigger) {
      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  handleKeyUp(event) {
    event.preventDefault();

    if (event.keyCode === keyCodes.ESC) {
      this.close();
    }

    if (event.keyCode === keyCodes.ENTER || event.keyCode === keyCodes.SPACE) {
      this.toggle();
    }
  }

  handleFocusableDown(event) {
    const firstFocusable = this.focusableElements[0];
    const lastFocusable = this.focusableElements[this.focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  makeTooltip() {
    if (this.customTooltip) {
      return $`
        <div id="custom-tooltip" part="custom-tooltip">
          <slot name="custom-tooltip"></slot>
        </div>
      `;
    }

    if (this.tooltip) {
      return $`
        <div id="tooltip" part="tooltip">
          <svg width="29px" height="14px" enable-background="new 0 0 29 14" viewBox="0 0 29 14">
            <polygon points="0.15,0 14.5,14.35 28.85,0 "/>
          </svg>
        </div>
      `;
    }

    return null;
  }

  makeOverlay() {
    if (this.clickOutside) {
      return $`
        <div id="overlay" @keyup=${() => this.close()} @click=${() => this.close()}></div>
      `;
    }

    return null;
  }

  smartContent() {
    if (this.smart) {
      // order here is important. to properly detect an offscreen popover,
      // we must remove the direction properties before getting contentRect
      this.contentElement.style.removeProperty('left');
      this.contentElement.style.removeProperty('right');
      this.contentElement.style.removeProperty('top');
      this.contentElement.style.removeProperty('bottom');

      const contentRect = this.contentElement.getBoundingClientRect();

      const padding = 24;
      const isOffScreenLeft = contentRect.left < 0;
      const isOffScreenRight = window.innerWidth - contentRect.right < 0;
      const isOffScreenTop = contentRect.top < 0;
      const isOffScreenBottom = contentRect.bottom > window.innerHeight;

      // adjust positioning
      if (this.position === 'top' && isOffScreenTop) {
        this.setPosition(contentRect);
      }

      if (this.position === 'right' && isOffScreenRight) {
        this.setPosition(contentRect);
      }

      if (this.position === 'bottom' && isOffScreenBottom) {
        this.setPosition(contentRect);
      }

      if (this.position === 'left' && isOffScreenLeft) {
        this.setPosition(contentRect);
      }

      // adjust content
      if (isOffScreenLeft) {
        this.contentElement.style.left = `${Math.abs(contentRect.left - padding)}px`;
      } else {
        this.contentElement.style.removeProperty('left');
      }

      if (isOffScreenRight) {
        this.contentElement.style.right = `${Math.abs(window.innerWidth - contentRect.right - padding)}px`;
      } else {
        this.contentElement.style.removeProperty('right');
      }

      if (isOffScreenTop) {
        this.contentElement.style.top = `${Math.abs(contentRect.top - padding)}px`;
      } else {
        this.contentElement.style.removeProperty('top');
      }

      if (isOffScreenBottom) {
        this.contentElement.style.bottom = `${Math.abs(contentRect.bottom - window.innerHeight - padding)}px`;
      } else {
        this.contentElement.style.removeProperty('bottom');
      }
    }
  }

  setPosition(contentRect) {
    if (contentRect.top > 0) {
      this.position = 'top';
    } else if (contentRect.right < window.innerWidth) {
      this.position = 'right';
    } else if (contentRect.bottom < window.innerHeight) {
      this.position = 'bottom';
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-popover') || customElements.define('kemet-popover', KemetPopover);

class KemetRadio extends s$1 {
  static get styles() {
    return [
      r$3`
        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }

        :host {
          display: inline-block;
        }

        :host([disabled]) {
          opacity: 0.5;
        }

        label {
          cursor: pointer;
          display: inline-flex;
          gap: 0.5rem;
          align-items: center;
          margin-right: 0.5rem;
        }

        input {
          cursor: pointer;
          margin: 0;
          padding: 0;
          width: var(--kemet-radio-size, 18px);
          height: var(--kemet-radio-size, 18px);
          position: absolute;
          opacity: 0;
        }

        button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: var(--kemet-radio-size, 18px);
          height: var(--kemet-radio-size, 18px);
          padding: 0;
          border-radius: 50%;
          background: none;
          border: var(--kemet-radio-border, 1px solid var(--kemet-color-primary));
        }

        [part='dot'] {
          display: inline-flex;
          border-radius: 50%;
          width: var(--kemet-radio-size, 18px);
          height: var(--kemet-radio-size, 18px);
          background: var(--kemet-radio-dot-color, var(--kemet-color-primary));
          border: var(--kemet-radio-border, 1px solid var(--kemet-color-primary));
          box-shadow: inset 0px 0px 0px var(--kemet-radio-dot-border-width, 3px) var(--kemet-radio-dot-border-color, var(--kemet-color-white));
        }

        :host([filled]) [part='dot'] {
          background: var(--kemet-radio-dot-color-filled, var(--kemet-color-white));
          box-shadow: inset 0px 0px 0px var(--kemet-radio-dot-border-width, 4px) var(--kemet-radio-dot-border-color, var(--kemet-color-primary));
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The text next to the radio button
       */
      label: {
        type: String,
      },
      /**
       * Determines whether or not the button is checked
       */
      checked: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The name of the field
       */
      name: {
        type: String,
      },
      /**
       * The value of the radio button
       */
      value: {
        type: String,
      },
      /**
       * Determines if the button should be disabled
       */
      disabled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Is true when the button is focused on
       */
      focused: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Displayed the button as a filled button
       */
      filled: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.label = '';
    this.name = this.closest('kemet-radios').name || 'radio-button';
    this.disabled = false;
  }

  firstUpdated() {
    this.input = this.shadowRoot.querySelector('input');
    this.setAttribute('role', 'radio');

    if (this.checked) {
      this.setAttribute('aria-checked', 'true');
    } else {
      this.setAttribute('aria-checked', 'false');
    }
  }

  render() {
    return $`
      <label part="label">
        <input
          type="radio"
          name=${l$1(this.name)}
          .value=${this.value}
          .checked=${l(this.checked)}
          .disabled=${this.disabled}
          @blur=${() => this.handleBlur()}
          @focus=${() => this.handleFocus()}
        />
        <button part="button" aria-label=${this.label}>${this.makeDot()}</button>
        <span part="text">${this.label}</span>
      </label>
    `;
  }

  click() {
    this.input.click();
  }

  blur() {
    this.input.blur();
  }

  focus() {
    this.input.focus();
  }

  handleBlur() {
    this.focused = false;

    /**
     * Fires when the checkbox loses or receives focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-radio-focused', {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    );
  }

  handleFocus() {
    this.focused = true;

    /**
     * Fires when the checkbox loses or receives focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-radio-focused', {
        bubbles: true,
        composed: true,
        detail: true,
      }),
    );
  }

  makeDot() {
    if (this.checked) {
      return $`
        <span part="dot"></span>
      `;
    }

    return null;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-radio') || customElements.define('kemet-radio', KemetRadio);

class KemetRadios extends s$1 {
  static get styles() {
    return [
      r$3`
        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }

        :host {
          display: block;
        }

        fieldset {
          border: 0;
          margin: 0;
          padding: 0;
          display: flex;
          gap: 0.5rem;
        }

        legend {
          margin-bottom: 1rem;
        }

        :host([axis='vertical']) fieldset {
          flex-direction: column;
        }

        [part='message'] {
          display: block;
          margin-top: 0.5rem;
        }

        :host([status='error']) [part='message'] {
          color: var(--kemet-color-error);
        }

        :host([status='warning']) [part='message'] {
          color: var(--kemet-color-error);
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The legend text for the fieldset
       */
      legend: {
        type: String,
      },
      /**
       * The direction of the button's layout
       */
      axis: {
        type: String,
        reflect: true,
      },
      /**
       * The value of the selected radio button
       */
      value: {
        type: String,
      },
      /**
       * The name of the radio button set
       */
      name: {
        type: String,
      },
      /**
       * The status of the radio button set
       */
      status: {
        type: String,
        reflect: true,
      },
      /**
       * Validation message for the user
       */
      message: {
        type: String,
      },
      /**
       * Determines whether or not the radio button set is required
       */
      required: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.legend = '';
    this.axis = 'horizontal';
    this.name = 'radios';
    this.status = 'standard';

    /**
     * Used only for form reactive controller
     */
    this.formSubmitController = new FormSubmitController(this);
  }

  firstUpdated() {
    this.radios = this.querySelectorAll('kemet-radio');
    this.setAttribute('role', 'radiogroup');
  }

  render() {
    return $`
      <fieldset part="fieldset">
        ${this.legend !== '' ? $`<legend part="legend">${this.legend}</legend>` : null}
        <slot @click=${event => this.handleClick(event)} @keydown=${event => this.handleKeyDown(event)} @slotchange=${() => this.handleSlotChange()}></slot>
      </fieldset>
      ${this.makeMessage()}
    `;
  }

  handleClick(event) {
    const { target } = event;

    this.radios.forEach((radio) => {
      radio.checked = false;
      radio.tabIndex = radio === target ? 0 : -1;
      radio.setAttribute('aria-checked', 'false');
    });

    if (!target.disabled) {
      target.checked = true;
      target.setAttribute('aria-checked', 'true');
      this.value = target.value;
      this.status = 'standard';

      /**
       * Fires when the state of the checkbox changes
       */
      this.dispatchEvent(
        new CustomEvent('kemet-radios-change', {
          bubbles: true,
          composed: true,
          detail: target,
        }),
      );
    }
  }

  handleKeyDown(event) {
    const radios = Array.from(this.radios);
    const arrowKeys = ['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft'];
    const forwardKeys = ['ArrowRight', 'ArrowDown'];
    const shift = forwardKeys.includes(event.key) ? 1 : -1;
    const checkedIndex = radios.findIndex(radio => radio.checked) ?? radios[0];

    let index = checkedIndex + shift;

    if (arrowKeys.includes(event.key)) {
      if (index < 0) {
        index = radios.length - 1;
      }

      if (index > radios.length - 1) {
        index = 0;
      }

      this.radios.forEach((radio) => {
        radio.checked = false;
        radio.tabIndex = -1;
      });

      this.radios[index].focus();
      this.radios[index].checked = true;
      this.radios[index].tabIndex = 0;
    }
  }

  handleSlotChange() {
    const radios = Array.from(this.radios);
    const checkedRadio = radios.find(radio => radio.checked);

    this.radios.forEach((radio) => {
      radio.tabIndex = -1;
      radio.input.tabIndex = -1;
    });

    if (checkedRadio) {
      checkedRadio.tabIndex = 0;
    }
  }

  makeMessage() {
    if (this.status === 'error' || this.status === 'warning') {
      return $`<span part="message">${this.message}</span>`;
    }

    return null;
  }

  checkValidity() {
    if (this.required) {
      return !!this.value;
    }

    return true;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-radios') || customElements.define('kemet-radios', KemetRadios);

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class e extends i{constructor(i){if(super(i),this.it=w,i.type!==t.CHILD)throw Error(this.constructor.directiveName+"() can only be used in child bindings")}render(r){if(r===w||null==r)return this.ft=void 0,this.it=r;if(r===b)return r;if("string"!=typeof r)throw Error(this.constructor.directiveName+"() called with a non-string value");if(r===this.it)return this.ft;this.it=r;const s=[r];return s.raw=s,this.ft={_$litType$:this.constructor.resultType,strings:s,values:[]}}}e.directiveName="unsafeHTML",e.resultType=1;const o=e$1(e);

class KemetRotator extends s$1 {
  static get styles() {
    return r$3`
      :host {
        display: flex;
      }

      .rotator__slide {
        pointer-events: none;
      }

      .rotator__slide--active {
        pointer-events: auto;
      }

      /* fade effect */
      :host([effect="fade"]) .rotator {
        display: inline-flex;
        flex-wrap: nowrap;
        flex-direction: row;
      }

      :host([effect="fade"]) .rotator__slide {
        width: 100%;
        flex: none;
        opacity: 0;
        box-sizing: border-box;
        transition: all var(--kemet-rotator-transition-speed, 500ms) ease;
      }

      :host([effect="fade"]) .rotator__slide:not(:first-child) {
        margin-left: -100%; /* this is the bulk of the overlay trick */
      }

      :host([effect="fade"]) .rotator__slide--active {
        opacity: 1;
      }

      /* flip effect */
      :host([effect="flip"]) .rotator {
        display: flex;
        position: relative;

        perspective: 500;
      }

      :host([effect="flip"]) .rotator__slide {
        display: block;
        width: auto;
        position: absolute;
        top: -20px;
        left: 0;

        opacity: 0;

        transform: rotateX(90deg);
        transform-origin: 0% 0%;
        transition: all var(--kemet-rotator-transition-speed, 500ms) ease;
      }

      :host([effect="flip"]) .rotator__slide--active {
        top: 0;
        opacity: 1;

        transform: rotateX(0deg);
      }

      :host([effect="flip"]) .rotator__slide--prev {
        top: 40px;;
        transform: rotateX(-90deg);
      }
    `;
  }

  static get properties() {
    return {
      /**
       * The index number for the current slide.
       */
      activeSlide: {
        type: Number,
      },
      /**
       * The width of the rotator block.
       */
      width: {
        type: String,
      },
      /**
       * The height of the rotator block.
       */
      height: {
        type: String,
      },
      /**
       * Text in the rotator. Supports HTML.
       */
      messages: {
        type: Array,
      },
      /**
       * The transition effect type.
       */
      effect: {
        type: String,
        reflect: true,
      },
      /**
       * How fast, in seconds, each slide lasts. Stop the rotator with 0.
       */
      rotationSpeed: {
        type: Number,
        attribute: 'rotation-speed',
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.activeSlide = 0;
    this.messages = [];
    this.effect = 'fade';
    this.rotationSpeed = 3;
    this.width = 'auto';
    this.height = 'auto';
  }

  firstUpdated() {
    // standard properties
    this.prevSlide = null;

    window.addEventListener('resize', this.setDimensions.bind(this));
  }

  updated(changed) {
    const widthHasChanged = !!changed.get('width');
    const heightHasChanged = !!changed.get('height');

    this.setDimensions();

    // only trigger slide updates when width and height has not changed
    if (!widthHasChanged && !heightHasChanged) {
      setTimeout(() => {
        if (this.rotationSpeed > 0) {
          this.nextSlide();
        }
      }, this.rotationSpeed * 1000);
    }
  }

  render() {
    const setWidth = this.effect === 'flip' ? `width:${this.width};` : '';
    const setHeight = this.effect === 'flip' ? `height:${this.height};` : '';

    return $`
      <span class="rotator" style="${setWidth} ${setHeight}">
        ${this.makeMessages()}
      </span>
    `;
  }

  makeMessages() {
    const messages = this.messages.map((message, index) => {
      const setActiveClass = this.activeSlide === index ? 'rotator__slide--active' : '';
      const setPrevClass = this.prevSlide === index ? 'rotator__slide--prev' : '';

      return $`
        <span class="rotator__slide ${setActiveClass} ${setPrevClass}">
          ${o(message)}
        </span>
      `;
    });

    return messages;
  }

  setDimensions() {
    if (this.effect === 'flip') {
      this.width = `${this.offsetWidth}px`;

      const slides = this.shadowRoot.querySelectorAll('.rotator__slide');
      let tallest = 0;

      slides.forEach((slide) => {
        if (slide.offsetHeight > tallest) {
          tallest = slide.offsetHeight;
        }
      });

      this.height = `${tallest}px`;
    }
  }

  nextSlide() {
    if (this.activeSlide < this.messages.length - 1) {
      this.activeSlide += 1;
      this.prevSlide = this.activeSlide - 1;
    } else {
      this.activeSlide = 0;
      this.prevSlide = this.messages.length - 1;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-rotator') || customElements.define('kemet-rotator', KemetRotator);

class KemetScrollLink extends s$1 {
  static get styles() {
    return r$3`
      :host {
        cursor: pointer;
        display: inline-block;
      }
    `;
  }

  static get properties() {
    return {
      /**
       * A DOM element that establishes the context of scrolling.
       */
      element: {
        type: Object,
      },
      /**
       * A DOM element that represents the destination of the scroll link.
       * If no target is specified it will default to the top of the page.
       */
      target: {
        type: Object,
      },
      /**
       * Allows the horizontal scrolling to stop short of the given value.
       */
      xOffset: {
        type: Number,
        attribute: 'x-offset',
        reflect: true,
      },
      /**
       * Allows the vertical scrolling to stop short of the given value.
       */
      yOffset: {
        type: Number,
        attribute: 'y-offset',
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.element = this.element || window;
    this.target = this.target || document.querySelector('body');
    this.xOffset = 0;
    this.yOffset = 0;
  }

  firstUpdated() {
    // standard properties
    this.keyCodes = {
      ENTER: 13,
      SPACE: 32,
    };
    this.isSmoothSupported = 'scrollBehavior' in document.documentElement.style;
  }

  render() {
    return $`
      <div tabindex="0" @click=${() => this.handleScroll()} @keyup=${event => this.handleKeyup(event)}>
        <slot></slot>
      </div>
    `;
  }

  handleKeyup(event) {
    if (event.keyCode === this.keyCodes.ENTER || event.keyCode === this.keyCodes.SPACE) {
      this.handleScroll();
    }
  }

  handleScroll() {
    const scrollTop = this.target.offsetTop + this.yOffset;
    const scrollLeft = this.target.offsetLeft + this.xOffset;

    if (this.isSmoothSupported) {
      this.element.scrollTo({
        top: scrollTop,
        left: scrollLeft,
        behavior: 'smooth',
      });
    } else {
      this.element.scrollTo(scrollLeft, scrollTop);
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-scroll-link') || customElements.define('kemet-scroll-link', KemetScrollLink);

class KemetScrollNav extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: block;
          box-sizing: border-box;
          padding: var(--kemet-scroll-nav-padding, 1rem 2rem);
          background-color: var(--kemet-scroll-nav-background, #fafafa);
          transition: all var(--kemet-scroll-nav-transition, 300ms) ease;
        }

        :host([transform]),
        :host([effect="resize"]) {
          position: fixed;
          top: 0;
          width: 100%;
        }

        :host([effect="resize"]) {
          height: var(--kemet-scroll-nav-resize-height, 400px);
        }

        :host([transform][effect="resize"]) {
          height: var(--kemet-scroll-nav-resize-height-transformed, 100px);
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * Determines where the transform point is activated. Values include: (sticky | resize)
       */
      effect: {
        type: String,
        reflect: true,
      },
      /**
       * Whether or not the nav has shifted into a new state.
       */
      transform: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Allows for an arbitrary adjustment of the transform point in pixels.
       * Works with negative values.
       */
      offset: {
        type: Number,
      },
    };
  }

  constructor() {
    super();

    this.effect = 'sticky';
    this.transform = false;
    this.offset = 0;
  }

  render() {
    return $`
      <slot></slot>
    `;
  }

  firstUpdated() {
    const stickPoint = this.offsetTop;
    const elementHeight = this.offsetHeight;

    window.addEventListener('scroll', () => {
      // we pass stickPoint and elementHeight as recorded constants
      // so that it does not update for each call to handleScroll
      this.handleScroll(stickPoint, elementHeight);
    });
  }

  handleScroll(stickPoint, elementHeight) {
    const transformPoint = (this.effect === 'sticky')
      ? stickPoint + this.offset
      : elementHeight + this.offset;

    if (window.pageYOffset >= transformPoint) {
      this.transform = true;
    } else {
      this.transform = false;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-scroll-nav') || customElements.define('kemet-scroll-nav', KemetScrollNav);

class KemetScrollSnapPaginator extends s$1 {
  static get styles() {
    return r$3`
      :host {
        margin: auto;
        padding: var(--kemet-scroll-snap-paginator-padding, 1rem 0);
      }

      nav {
        display: flex;
        gap: var(--kemet-scroll-snap-paginator-gap, 0.5rem);
      }

      :host([center]) nav {
        justify-content: center;
      }

      .link {
        cursor: pointer;
        color: var(--kemet-scroll-snap-paginator-link-color, var(--kemet-color-primary));
      }
    `;
  }

  static get properties() {
    return {
      /**
       * Information about each slide.
       */
      slides: {
        type: Array,
      },
      /**
       * A string representing which icon to use for pagination. Supports icons used in kemet-icon.
       */
      icon: {
        type: String,
      },
      /**
       * The size in pixels of the icons.
       */
      size: {
        type: Number,
      },
      /**
       * Determines whether to center the pagination items.
       */
      center: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Will hide inactive pagination items if set to true.
       */
      hideFocusedLinks: {
        type: Boolean,
        attribute: 'hide-focused-links',
      },
      /**
       * If set to true, the pages in the pagination iterator will appear as a set of numbers.
       */
      useNumberPages: {
        type: Boolean,
        reflect: true,
        attribute: 'use-number-pages',
      },
      /**
       * If set to true, the pages in the pagination iterator will appear as the label set on
       * the slide.
       */
      useLabelPages: {
        type: Boolean,
        reflect: true,
        attribute: 'use-label-pages',
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.slides = [];
    this.icon = 'circle-fill';
    this.size = 16;
    this.hideFocusedLinks = false;
    this.useNumberPages = false;
    this.useLabelPages = false;
  }

  updated() {
    const scrollSnapElement = this.closest('kemet-scroll-snap');

    if (scrollSnapElement) {
      scrollSnapElement.addEventListener('kemet-scroll-snap-make-slides', (event) => {
        this.slides = event.detail;
      });
    }
  }

  render() {
    return $`
      <nav part="nav">${this.makePagination()}</nav>
    `;
  }

  makePagination() {
    let counter = 0;

    if (this.slides) {
      return this.slides.map((slide) => {
        counter = counter += 1;

        if (slide.focused) {
          return $`
            <span part="span">${this.pageDisplay(slide, counter)}</span>
          `;
        }

        return $`
          <span
            class="link"
            tabindex="0"
            role="button"
            @keyup="${event => this.handleKeyboardInput(event, slide.id)}"
            @click=${() => this.slideLink(slide.id)}
            aria-label="${slide.label}">
            ${this.pageDisplay(slide, counter)}
          </span>
        `;
      });
    }

    return null;
  }

  pageDisplay(slide, visibleIndex) {
    if (this.useNumberPages) {
      return visibleIndex;
    }

    if (this.useLabelPages) {
      return slide.label;
    }

    return $`<kemet-icon icon=${this.icon} size=${this.size}></kemet-icon>`;
  }

  slideLink(index) {
    /**
     * Fires when a set of slides are focused on.
     */
    this.dispatchEvent(new CustomEvent('kemet-scroll-snap-focus', {
      bubbles: true,
      composed: true,
      detail: index,
    }));
  }

  handleKeyboardInput(event, id) {
    if (event.code === 'Enter' || event.code === 'Space') {
      this.slideLink(id);
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-scroll-snap-paginator') || customElements.define('kemet-scroll-snap-paginator', KemetScrollSnapPaginator);

class KemetScrollSnapSlide extends s$1 {
  static get styles() {
    return r$3`
      :host {
        display: block;
        flex: 0 0 auto;
        width: var(--kemet-scroll-snap-slide-width, 100%);
        scroll-snap-align: var(--kemet-scroll-snap-slide-align, center);
      }
    `;
  }

  static get properties() {
    return {
      /**
       * Is true when the slide is fully visible in it's container.
       */
      focused: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Identifies the slide.
       */
      index: {
        type: String,
        reflect: true,
      },
      /**
       * Labels the slide.
       */
      label: {
        type: String,
        reflect: true,
      },
    };
  }

  updated() {
    this.addTabIndex();
  }

  render() {
    return $`
      <slot></slot>
    `;
  }

  addTabIndex() {
    this.setAttribute('tabindex', '0');
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-scroll-snap-slide') || customElements.define('kemet-scroll-snap-slide', KemetScrollSnapSlide);

class KemetScrollSnap extends s$1 {
  static get styles() {
    return r$3`
      *,
      *::after,
      *::before {
        box-sizing: border-box;
      }

      :host {
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      :host([axis='horizontal']) {
        margin: auto;
        max-width: var(--kemet-scroll-snap-horizontal-max-width, 1024px);
      }

      :host([pagination="left"]),
      :host([pagination="right"]) {
        flex-direction: row;
      }

      :host([pagination="none"]) ::slotted([slot="pagination"]) {
        display: none;
      }

      :host([pagination="top"]) ::slotted([slot="pagination"]),
      :host([pagination="left"]) ::slotted([slot="pagination"]) {
        order: -1;
      }


      ::slotted([slot="slides"]) {
        display: flex;
        gap: var(--kemet-scroll-snap-gap, 1.5rem);
        scroll-snap-type: x mandatory;
        overflow-x: scroll;
      }

      /* vertical */
      :host([axis="vertical"]) {
        height: var(--kemet-scroll-snap-vertical-height, 100vh);
      }

      :host([axis="vertical"]) ::slotted([slot="slides"]) {
        flex-direction: column;
        overflow-x: hidden;
        scroll-snap-type: y mandatory;
        padding: var(--kemet-scroll-snap-slides-vertical-padding, 0 2rem);
      }
    `;
  }

  static get properties() {
    return {
      /**
       * Determines the direction the component flows. Values include: (horizontal|vertical)
       */
      axis: {
        type: String,
        reflect: true,
      },
      /**
       * Determines where to display the paginator. Values include: (top | right | bottom | left)
       */
      pagination: {
        type: String,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.axis = 'horizontal';
    this.pagination = 'bottom';

    this.addEventListener('kemet-scroll-snap-focus', (event) => {
      this.focusSlide(event.detail);
    });
  }

  firstUpdated() {
    // standard properties
    this.isTouchDevice = 'ontouchstart' in document.documentElement;
    this.slides = [];

    this.setFocusedSlides();
  }

  updated() {
    this.setVerticalAttribute();
  }

  render() {
    return $`
      <slot name="slides"></slot>
      <slot name="pagination"></slot>
    `;
  }

  setFocusedSlides() {
    // reference: https://24ways.org/2019/beautiful-scrolling-experiences-without-libraries/
    // reference: https://css-tricks.com/an-explanation-of-how-the-intersection-observer-watches/
    const slides = this.querySelectorAll('kemet-scroll-snap-slide');
    const container = this.querySelector('[slot="slides"]');

    const options = {
      root: container,
      rootMargin: '0px',
      threshold: 0.5,
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        const { target } = entry;

        if (entry.intersectionRatio >= 0.5) {
          target.focused = true;
        } else {
          target.focused = false;
        }
      });

      this.makeSlides();
    };

    const observer = new IntersectionObserver(callback, options);

    slides.forEach((slide) => {
      observer.observe(slide);
    });
  }

  makeSlides() {
    const slides = [];

    this.querySelectorAll('kemet-scroll-snap-slide').forEach((element, index) => {
      const slide = element;

      slide.index = index;
      slides.push({
        id: index,
        focused: slide.focused,
        label: slide.label,
      });
    });

    this.slides = slides;

    /**
     * Fires when slide data has been created.
     */
    this.dispatchEvent(new CustomEvent('kemet-scroll-snap-make-slides', {
      bubbles: true,
      composed: true,
      detail: this.slides,
    }));
  }

  focusSlide(index) {
    const activeSlide = this.querySelector(`kemet-scroll-snap-slide[index="${index}"]`);
    activeSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  setVerticalAttribute() {
    if (this.axis === 'vertical') {
      document.querySelector('html').setAttribute('kemet-scroll-snap-axis', 'vertical');
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-scroll-snap') || customElements.define('kemet-scroll-snap', KemetScrollSnap);

class KemetOption extends s$1 {
  static get properties() {
    return {
      /**
       * The label of the option
       */
      label: {
        type: String,
      },
      /**
       * The value of the options
       */
      value: {
        type: String,
      },
      /**
       * Determines whether to disable the option
       */
      disabled: {
        type: Boolean,
      },
      /**
       * Selects the option if true
       */
      selected: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();

    this.value = '';
  }

  render() {
    return $`<slot></slot>`;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-option') || customElements.define('kemet-option', KemetOption);

class KemetSelect extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          position: relative;
          display: block;
        }

        select {
          display: block;
          font-size: 1rem;
          width: 100%;
          padding: var(--kemet-select-padding, 1rem);
          border: var(--kemet-select-border, 1px solid var(--kemet-color-primary));
          appearance: none;
          box-sizing: border-box;
          background-color: transparent;
        }

        :host([status='error']) select {
          border: var(--kemet-select-border-color-error, 1px solid var(--kemet-color-error));
        }

        :host([status='success']) select {
          border: var(--kemet-select-border-color-success, 1px solid var(--kemet-color-success));
        }

        :host([status='warning']) select {
          border: var(--kemet-select-border-color-warning, 1px solid var(--kemet-color-warning));
        }

        :host([disabled]) select {
          opacity: 0.5;
        }

        :host([rounded]) select {
          border-radius: var(--kemet-select-border-radius-rounded, var(--kemet-border-radius));
        }

        :host([filled]) select {
          border: var(--kemet-select-border-filled, none);
          color: var(--kemet-select-color-filled, var(--kemet-color-white));
          background-color: var(--kemet-select-background-color-filled, var(--kemet-color-primary));
        }

        :host([filled]) kemet-icon {
          color: var(--kemet-select-color-filled, var(--kemet-color-white));
        }

        :host([status='error'][filled]) select {
          background-color: var(--kemet-select-background-color-error, var(--kemet-color-error));
        }

        :host([status='success'][filled]) select {
          background-color: var(--kemet-select-background-color-success, var(--kemet-color-success));
        }

        :host([status='warning'][filled]) select {
          background-color: var(--kemet-select-background-color-warning, var(--kemet-color-warning));
        }

        kemet-icon {
          position: absolute;
          right: var(--kemet-select-icon-right, 1rem);
          top: 50%;
          transform: translateY(-50%);
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * A string the uniquely identifies the select
       */
      slug: {
        type: String,
      },
      /**
       * The name of the select
       */
      name: {
        type: String,
      },
      /**
       * The value of the select
       */
      value: {
        type: String,
      },
      /**
       * The options the select contains
       */
      options: {
        type: Array,
      },
      /**
       * The status of the select
       */
      status: {
        type: String,
        reflect: true,
      },
      /**
       * Determines whether or not the field is required
       */
      required: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Determines whether or not the field is disabled
       */
      disabled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Support of multiple choice selections
       */
      multiple: {
        type: Boolean,
      },
      /**
       * The dropdown icon
       */
      icon: {
        type: String,
      },
      /**
       * The dropdown icon size
       */
      iconSize: {
        type: Number,
        attribute: 'icon-size',
      },
      /**
       * Displays a filled select
       */
      filled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Displays rounded corners
       */
      rounded: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.name = 'select';
    this.icon = 'chevron-down';
    this.iconSize = 16;

    /**
     * Used only for form reactive controller
     */
    this.formSubmitController = new FormSubmitController(this);

    // elements
    this.control = this.closest('kemet-field');
  }

  firstUpdated() {
    // elements
    this.select = this.shadowRoot.querySelector('select');
    this.selectedOption = this.querySelector('[selected]');

    this.value = this.selecltedOption ? this.selectedOption.value : '';
  }

  render() {
    return $`
      <select
        part="select"
        id=${this.slug}
        name=${this.name}
        ?required=${this.required}
        ?disabled=${this.disabled}
        ?multiple=${this.multiple}
        @change=${this.handleChange}
        @focus=${this.handleFocus}
        @blur=${this.handleBlur}
        @invalid=${this.handleInvalid}
      >
        ${this.makeOptions()}
      </select>
      ${this.makeIcon()}
      <slot @slotchange=${() => this.makeOptions()}></slot>
    `;
  }

  /**
   * Generates the option elements
   * @private
   * @returns {TemplateResult} An option element
   */
  makeOptions() {
    this.options = [];
    this.optionElements = this.querySelectorAll('kemet-option');

    this.optionElements.forEach((option) => {
      // if (index === 0) this.value = option.value;
      // this.value = option.selected ? option.value : this.value;
      this.options = this.options.concat({
        label: option.label,
        value: option.value,
        disabled: option.disabled,
        selected: option.selected,
      });
    });

    return this.options.map(
      option => $`<option value=${option.value} ?disabled=${option.disabled} ?selected=${option.selected}>
          ${option.label}
        </option>`,
    );
  }

  /**
   * Generates an dropdown icon
   * @private
   */
  makeIcon() {
    if (this.icon || this.icon !== '') {
      return $`<kemet-icon icon=${this.icon} size=${this.iconSize}></kemet-icon>`;
    }

    return null;
  }

  /**
   * Handles when the input receives focus
   * @private
   */
  handleFocus() {
    this.hasFocus = true;

    /**
     * Fires when the input receives and loses focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-focused', {
        bubbles: true,
        composed: true,
        detail: true,
      }),
    );
  }

  /**
   * Handles when the input loses focus
   * @private
   */
  handleBlur() {
    this.hasFocus = false;

    /**
     * Fires when the input receives and loses focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-focused', {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    );

    this.select.checkValidity();

    if (!this.select.checkValidity()) {
      this.invalid = true;
      this.status = 'error';
      this.control.status = 'error';

      this.dispatchEvent(
        new CustomEvent('kemet-input-status', {
          bubbles: true,
          composed: true,
          detail: {
            status: 'error',
            validity: this.select.validity,
            element: this,
          },
        }),
      );
    }
  }

  /**
   * Handles when the input changes value
   * @private
   */
  handleChange() {
    this.value = this.select.value;

    if (this.select.checkValidity()) {
      this.invalid = false;
      this.status = 'standard';

      /**
       * Fires when there's a change in status
       */
      this.dispatchEvent(
        new CustomEvent('kemet-input-status', {
          bubbles: true,
          composed: true,
          detail: {
            status: 'standard',
            validity: this.select.validity,
            element: this,
          },
        }),
      );
    }
  }

  /**
   * Handles when the input has an error
   * @private
   */
  handleInvalid() {
    this.invalid = true;
    this.status = 'error';

    /**
     * Fires when there's a change in status
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-status', {
        bubbles: true,
        composed: true,
        detail: {
          status: 'error',
          validity: this.select.validity,
          element: this,
        },
      }),
    );
  }

  /**
   * Checks the validity of the standard select
   * @public
   * @returns {boolean}
   */
  checkValidity() {
    this.select.checkValidity();
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-select') || customElements.define('kemet-select', KemetSelect);

class KemetSortableItem extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          cursor: grab;
          display: block;
          padding: 1rem;
          border: 1px solid var(--kemet-color-primary);
        }

        :host([ghost]) {
          opacity: 0.5;
          border-style: dashed;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /* Automatically set to true when an item is dragged to a new spot */
      ghost: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  firstUpdated() {
    this.draggable = true;
  }

  render() {
    return $`<slot></slot>`;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-sortable-item') || customElements.define('kemet-sortable-item', KemetSortableItem);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var index_min = {exports: {}};

/*! mobile-drag-drop 2.1.0 | Copyright (c) 2017 Tim Ruffles | MIT License */

(function (module, exports) {
	!function(a,b){b(exports);}(commonjsGlobal,function(a){function b(){var a={dragEvents:"ondragstart"in document.documentElement,draggable:"draggable"in document.documentElement,touchEvents:"ontouchstart"in document.documentElement,userAgentSupportingNativeDnD:void 0},b=!!window.chrome||/chrome/i.test(navigator.userAgent);return a.userAgentSupportingNativeDnD=!(/iPad|iPhone|iPod|Android/.test(navigator.userAgent)||b&&a.touchEvents),a}function c(){var a=!1;try{var b=Object.defineProperty({},"passive",{get:function(){a=!0;}});window.addEventListener("test",null,b);}catch(a){}return a}function d(a){if(a&&Object.keys(a).forEach(function(b){B[b]=a[b];}),!B.forceApply){var d=b();if(d.userAgentSupportingNativeDnD&&d.draggable&&d.dragEvents)return !1}return y=c(),B.holdToDrag?h("touchstart",w,!1):h("touchstart",e,!1),!0}function e(a){if(!z){var b=f(a);if(b)try{z=new J(a,B,b,g);}catch(b){throw g(B,a,3),b}}}function f(a){var b=a.target;do if(b.draggable!==!1&&b.getAttribute&&"true"===b.getAttribute("draggable"))return b;while((b=b.parentNode)&&b!==document.body)}function g(a,b,c){if(0===c&&a.defaultActionOverride)try{a.defaultActionOverride(b),b.defaultPrevented;}catch(a){}z=null;}function h(a,b,c){void 0===c&&(c=!0),document.addEventListener(a,b,!!y&&{passive:c});}function i(a,b){document.removeEventListener(a,b);}function j(a){return 0===a.length?0:a.reduce(function(a,b){return b+a},0)/a.length}function k(a){return a&&a.tagName}function l(a,b){for(var c=0;c<a.changedTouches.length;c++){var d=a.changedTouches[c];if(d.identifier===b)return !0}return !1}function m(a,b,c,d,e,f,g){void 0===g&&(g=null);var h=b.changedTouches[0],i=new Event(c,{bubbles:!0,cancelable:d});i.dataTransfer=f,i.relatedTarget=g,i.screenX=h.screenX,i.screenY=h.screenY,i.clientX=h.clientX,i.clientY=h.clientY,i.pageX=h.pageX,i.pageY=h.pageY;var j=a.getBoundingClientRect();return i.offsetX=i.clientX-j.left,i.offsetY=i.clientY-j.top,i}function n(a,b,c){for(var d=[],e=[],f=0;f<b.touches.length;f++){var g=b.touches[f];d.push(g[a+"X"]),e.push(g[a+"Y"]);}c.x=j(d),c.y=j(e);}function o(a,b){if(1===a.nodeType){for(var c=getComputedStyle(a),d=0;d<c.length;d++){var e=c[d];b.style.setProperty(e,c.getPropertyValue(e),c.getPropertyPriority(e));}b.style.pointerEvents="none",b.removeAttribute("id"),b.removeAttribute("class"),b.removeAttribute("draggable");}if(a.hasChildNodes())for(var d=0;d<a.childNodes.length;d++)o(a.childNodes[d],b.childNodes[d]);}function p(a){var b=a.cloneNode(!0);return o(a,b),b.style.position="absolute",b.style.left="0px",b.style.top="0px",b.style.zIndex="999999",b.classList.add(G),b.classList.add(I),b}function q(a){return E.map(function(b){var c=a.style[b+"transform"];return c&&"none"!==c?c.replace(/translate\(\D*\d+[^,]*,\D*\d+[^,]*\)\s*/g,""):""})}function r(a,b,c,d,e){void 0===e&&(e=!0);var f=b.x,g=b.y;d&&(f+=d.x,g+=d.y),e&&(f-=parseInt(a.offsetWidth,10)/2,g-=parseInt(a.offsetHeight,10)/2);for(var h="translate3d("+f+"px,"+g+"px, 0)",i=0;i<E.length;i++){var j=E[i]+"transform";a.style[j]=h+" "+c[i];}}function s(a,b,c,d){var e=getComputedStyle(a);if("hidden"===e.visibility||"none"===e.display)return void d();b.classList.add(H);var f=getComputedStyle(b),g=parseFloat(f.transitionDuration);if(isNaN(g)||0===g)return void d();var h=a.getBoundingClientRect(),i={x:h.left,y:h.top};i.x+=document.body.scrollLeft||document.documentElement.scrollLeft,i.y+=document.body.scrollTop||document.documentElement.scrollTop,i.x-=parseInt(e.marginLeft,10),i.y-=parseInt(e.marginTop,10);var j=parseFloat(f.transitionDelay),k=Math.round(1e3*(g+j));r(b,i,c,void 0,!1),setTimeout(d,k);}function t(a,b){return a?a===C[0]?D[0]:0===a.indexOf(C[1])||a===C[7]?D[1]:0===a.indexOf(C[4])?D[3]:a===C[6]?D[2]:D[1]:3===b.nodeType&&"A"===b.tagName?D[3]:D[1]}function u(a,b,c,d,e,f,g){if(void 0===f&&(f=!0),void 0===g&&(g=null),A);var k=m(b,c,a,f,document.defaultView,e,g),l=!b.dispatchEvent(k);return d.g=0,l}function v(a,b){if(!a||a===C[7])return b;if(b===D[1]){if(0===a.indexOf(D[1]))return D[1]}else if(b===D[3]){if(0===a.indexOf(D[3])||a.indexOf("Link")>-1)return D[3]}else if(b===D[2]&&(0===a.indexOf(D[2])||a.indexOf("Move")>-1))return D[2];return D[0]}function w(a){var b=a.target,c=function(){g.off(),h.off(),i.off(),e(a);},d=function(){g.off(),h.off(),i.off(),clearTimeout(f);},f=setTimeout(c,B.holdToDrag),g=x(b,"touchend",d,this),h=x(b,"touchcancel",d,this),i=x(window,"scroll",d,this);}function x(a,b,c,d){return d&&(c=c.bind(d)),a.addEventListener(b,c),{off:function(){return a.removeEventListener(b,c)}}}var y,z,A=!1,B={iterationInterval:150},C=["none","copy","copyLink","copyMove","link","linkMove","move","all"],D=["none","copy","move","link"],E=["","-webkit-"],F="dnd-poly-",G=F+"drag-image",H=F+"snapback",I=F+"icon",J=function(){function a(a,b,c,d){this.h=a,this.i=b,this.j=c,this.k=d,this.l=0,this.m=null,this.o=null,this.p=a,this.q=a.changedTouches[0],this.s=this.t.bind(this),this.u=this.v.bind(this),h("touchmove",this.s,!1),h("touchend",this.u,!1),h("touchcancel",this.u,!1);}return a.prototype.A=function(){var a=this;this.l=1,this.B=D[0],this.C={D:{},F:void 0,g:3,G:[]},this.H={x:null,y:null},this.I={x:null,y:null};var b=this.j;if(this.J=new K(this.C,function(c,d,e){b=c,"number"!=typeof d&&"number"!=typeof e||(a.K={x:d||0,y:e||0});}),this.C.g=2,this.J.dropEffect=D[0],u("dragstart",this.j,this.p,this.C,this.J))return this.l=3,this.L(),!1;if(n("page",this.p,this.I),this.M=p(b),this.N=q(this.M),!this.K)if(this.i.dragImageOffset)this.K={x:this.i.dragImageOffset.x,y:this.i.dragImageOffset.y};else if(this.i.dragImageCenterOnTouch){var c=getComputedStyle(b);this.K={x:0-parseInt(c.marginLeft,10),y:0-parseInt(c.marginTop,10)};}else {var d=b.getBoundingClientRect(),c=getComputedStyle(b);this.K={x:d.left-this.q.clientX-parseInt(c.marginLeft,10)+d.width/2,y:d.top-this.q.clientY-parseInt(c.marginTop,10)+d.height/2};}return r(this.M,this.I,this.N,this.K,this.i.dragImageCenterOnTouch),document.body.appendChild(this.M),this.O=setInterval(function(){a.P||(a.P=!0,a.R(),a.P=!1);},this.i.iterationInterval),!0},a.prototype.L=function(){this.O&&(clearInterval(this.O),this.O=null),i("touchmove",this.s),i("touchend",this.u),i("touchcancel",this.u),this.M&&(this.M.parentNode.removeChild(this.M),this.M=null),this.k(this.i,this.p,this.l);},a.prototype.t=function(a){var b=this;if(l(a,this.q.identifier)!==!1){if(this.p=a,0===this.l){var c=void 0;if(this.i.dragStartConditionOverride)try{c=this.i.dragStartConditionOverride(a);}catch(a){c=!1;}else c=1===a.touches.length;return c?void(this.A()===!0&&(this.h.preventDefault(),a.preventDefault())):void this.L()}if(a.preventDefault(),n("client",a,this.H),n("page",a,this.I),this.i.dragImageTranslateOverride)try{var d=!1;if(this.i.dragImageTranslateOverride(a,{x:this.H.x,y:this.H.y},this.m,function(a,c){b.M&&(d=!0,b.H.x+=a,b.H.y+=c,b.I.x+=a,b.I.y+=c,r(b.M,b.I,b.N,b.K,b.i.dragImageCenterOnTouch));}),d)return}catch(a){}r(this.M,this.I,this.N,this.K,this.i.dragImageCenterOnTouch);}},a.prototype.v=function(a){if(l(a,this.q.identifier)!==!1){if(this.i.dragImageTranslateOverride)try{this.i.dragImageTranslateOverride(void 0,void 0,void 0,function(){});}catch(a){}if(0===this.l)return void this.L();a.preventDefault(),this.l="touchcancel"===a.type?3:2;}},a.prototype.R=function(){var a=this;var e=this.B;this.C.g=3,this.J.dropEffect=D[0];var f=u("drag",this.j,this.p,this.C,this.J);if(f&&(this.B=D[0]),f||2===this.l||3===this.l){var g=this.S(this.l);return g?void s(this.j,this.M,this.N,function(){a.T();}):void this.T()}var h=document.elementFromPoint(this.H.x,this.H.y),i=this.o;h!==this.m&&h!==this.o&&(this.m=h,null!==this.o&&(this.C.g=3,this.J.dropEffect=D[0],u("dragexit",this.o,this.p,this.C,this.J,!1)),null===this.m?this.o=this.m:(this.C.g=3,this.J.dropEffect=t(this.C.F,this.j),u("dragenter",this.m,this.p,this.C,this.J)?(this.o=this.m,this.B=v(this.J.effectAllowed,this.J.dropEffect)):this.m!==document.body&&(this.o=document.body))),i!==this.o&&k(i)&&(this.C.g=3,this.J.dropEffect=D[0],u("dragleave",i,this.p,this.C,this.J,!1,this.o)),k(this.o)&&(this.C.g=3,this.J.dropEffect=t(this.C.F,this.j),u("dragover",this.o,this.p,this.C,this.J)===!1?this.B=D[0]:this.B=v(this.J.effectAllowed,this.J.dropEffect)),e!==this.B&&this.M.classList.remove(F+e);var j=F+this.B;this.M.classList.contains(j)===!1&&this.M.classList.add(j);},a.prototype.S=function(a){var d=this.B===D[0]||null===this.o||3===a;return d?k(this.o)&&(this.C.g=3,this.J.dropEffect=D[0],u("dragleave",this.o,this.p,this.C,this.J,!1)):k(this.o)&&(this.C.g=1,this.J.dropEffect=this.B,u("drop",this.o,this.p,this.C,this.J)===!0?this.B=this.J.dropEffect:this.B=D[0]),d},a.prototype.T=function(){this.C.g=3,this.J.dropEffect=this.B,u("dragend",this.j,this.p,this.C,this.J,!1),this.l=2,this.L();},a}(),K=function(){function a(a,b){this.U=a,this.V=b,this.W=D[0];}return Object.defineProperty(a.prototype,"types",{get:function(){if(0!==this.U.g)return Object.freeze(this.U.G)},enumerable:!0,configurable:!0}),a.prototype.setData=function(a,b){if(2===this.U.g){if(a.indexOf(" ")>-1)throw new Error("illegal arg: type contains space");this.U.D[a]=b,this.U.G.indexOf(a)===-1&&this.U.G.push(a);}},a.prototype.getData=function(a){if(1===this.U.g||2===this.U.g)return this.U.D[a]||""},a.prototype.clearData=function(a){if(2===this.U.g){if(a&&this.U.D[a]){delete this.U.D[a];var b=this.U.G.indexOf(a);return void(b>-1&&this.U.G.splice(b,1))}this.U.D={},this.U.G=[];}},a.prototype.setDragImage=function(a,b,c){2===this.U.g&&this.V(a,b,c);},Object.defineProperty(a.prototype,"effectAllowed",{get:function(){return this.U.F},set:function(a){2===this.U.g&&C.indexOf(a)>-1&&(this.U.F=a);},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"dropEffect",{get:function(){return this.W},set:function(a){0!==this.U.g&&C.indexOf(a)>-1&&(this.W=a);},enumerable:!0,configurable:!0}),a}();a.polyfill=d,Object.defineProperty(a,"__esModule",{value:!0});});
	
} (index_min, index_min.exports));

const getMouseOffset = (event) => {
  const targetRect = event.target.getBoundingClientRect();
  const offset = {
    x: event.pageX - targetRect.left,
    y: event.pageY - targetRect.top,
  };

  return offset;
};

const getElementVerticalCenter = (element) => {
  const rect = element.getBoundingClientRect();
  return (rect.bottom - rect.top) / 2;
};

class KemetSortable extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: flex;
          gap: 1rem;
          flex-direction: column;
        }
      `,
    ];
  }

  firstUpdated() {
    index_min.exports.polyfill();

    this.addEventListener('dragstart', event => this.handleDragStart(event), false);
    this.addEventListener('dragenter', (event) => { event.preventDefault(); });
  }

  render() {
    return $`<slot></slot>`;
  }

  handleDragStart(event) {
    this.sortableItem = event.target;

    this.addEventListener('dragover', dragOverEvent => this.handleDragOver(dragOverEvent), false);
    this.addEventListener('dragend', dragEndEvent => this.handleDragEnd(dragEndEvent), false);

    setTimeout(() => {
      this.sortableItem.ghost = true;
    }, 0);
  }

  handleDragOver(event) {
    event.preventDefault();

    const { target } = event;

    if (target && target.tagName === 'KEMET-SORTABLE-ITEM') {
      const offset = getMouseOffset(event);
      const middleY = getElementVerticalCenter(event.target);

      if (offset.y > middleY) {
        this.insertBefore(this.sortableItem, target.nextSibling);
      } else {
        this.insertBefore(this.sortableItem, target);
      }
    }
  }

  handleDragEnd(event) {
    event.preventDefault();
    this.sortableItem.ghost = false;

    /**
     * Fires when an item has been moved to a new spot
     */
    this.dispatchEvent(
      new CustomEvent('kemet-sortable-drag-end', {
        bubbles: true,
        composed: true,
        detail: {
          event,
          current: this.sortableItem,
          all: this.querySelectorAll('kemet-sortable-item'),
        },
      }),
    );
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-sortable') || customElements.define('kemet-sortable', KemetSortable);

class KemetSVG extends s$1 {
  static get styles() {
    return r$3`
      :host {
        display: inline-block;
      }

      svg {
        width: 100%;
        height: 100%;
      }
    `;
  }

  static get properties() {
    return {
      /**
       * Defines which set of svgs is referenced.
       */
      set: {
        type: String,
      },
      /**
       * The name (id) of the svg to be displayed.
       */
      svg: {
        type: String,
      },
      /**
       * Sets the width and height of a the svg to the given value in pixels.
       */
      size: {
        type: Number,
      },
      /**
       * The value for the preserveAspectRatio attribute of the svg.
       */
      ratio: {
        type: String,
      },
      /**
       * The value for the viewBox attribute of the svg.
       */
      viewBox: {
        type: String,
      },
    };
  }

  constructor() {
    super();

    this.set = 'svgs';
    this.ratio = 'none';
    this.viewBox = '0 0 128 128';
  }

  updated() {
    this.setSize();
    this.getIcon();
  }

  render() {
    return $`
      <svg part="svg" viewBox="${this.viewBox}" preserveAspectRatio="${this.ratio}"></svg>
    `;
  }

  setSize() {
    if (this.size) {
      this.style.width = `${this.size}px`;
      this.style.height = `${this.size}px`;
    }
  }

  getIcon() {
    let svgElement;
    const svgs = document.kemetSVGs[this.set];

    svgs.forEach((svg, index) => {
      const id = svg.getAttribute('id');

      if (id && id === this.svg) {
        svgElement = svgs[index];
      }
    });

    if (svgElement) {
      this.fillSVG(svgElement);
    } else {
      // eslint-disable-next-line no-console
      console.error(`Could not find svg "${this.svg}" in set "${this.set}".`);
    }
  }

  fillSVG(element) {
    const content = element.cloneNode(true);
    const svg = this.shadowRoot.querySelector('svg');
    const g = svg.querySelector('g');

    if (g) g.remove();
    svg.appendChild(content);
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-svg') || customElements.define('kemet-svg', KemetSVG);

class KemetSVGs extends s$1 {
  static get styles() {
    return r$3`
      :host {
        display: none;
      }
    `;
  }

  static get properties() {
    return {
      /**
       * Defines the name for the set of svgs.
       */
      set: {
        type: String,
      },
    };
  }

  constructor() {
    super();

    this.set = 'svgs';
  }

  firstUpdated() {
    this.slotElement = this.shadowRoot.querySelector('slot');
    document.kemetSVGs = document.kemetSVGs || {};

    this.populateIcons();
    this.slotElement.addEventListener('slotchange', this.populateIcons());
  }

  render() {
    return $`<slot></slot>`;
  }

  populateIcons() {
    const svg = this.slotElement.assignedElements()[0];
    const svgContents = svg ? svg.querySelectorAll('defs > g') : null;

    if (svgContents) {
      document.kemetSVGs[this.set] = svgContents;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-svgs') || customElements.define('kemet-svgs', KemetSVGs);

class KemetTabPanel extends s$1 {
  static get styles() {
    return r$3`
      :host {
        width: 100%;
        flex: 0 0 auto;
      }

      ::slotted(img) {
        max-width: 100%;
      }

      :host(.fade) {
        opacity: 0;
        pointer-events: none;
        transition: opacity var(--kemet-tab-panel-fade-speed, 0.5s) ease;
      }

      :host(.fade[selected]) {
        opacity: 1;
        pointer-events: auto;
      }

      :host(.fade.push) {
        margin-left: -100%;
      }

      :host(.vertical) {
        display: none;
      }

      :host(.vertical[selected]) {
        display: block;
      }
    `;
  }

  static get properties() {
    return {
      /**
       * Is true when a panel is selected
       */
      selected: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Identifies the panel to be linked by a tab
       */
      panel: {
        type: String,
      },
    };
  }

  constructor() {
    super();
    this.selected = false;
  }

  updated() {
    this.a11y();
  }

  render() {
    return $`
      <slot></slot>
    `;
  }

  a11y() {
    this.setAttribute('role', 'tabpanel');

    if (this.selected) {
      this.setAttribute('tabindex', '0');
    } else {
      this.setAttribute('tabindex', '-1');
    }
  }
}

customElements.define('kemet-tab-panel', KemetTabPanel);

class KemetTab extends s$1 {
  static get styles() {
    return r$3`
      :host {
        cursor: pointer;
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        padding: var(--kemet-tab-padding, 1rem);
      }

      :host([selected]) {
        cursor: auto;
        color: var(--kemet-tab-color, var(--kemet-color-primary));
      }

      kemet-icon {
        cursor: pointer;
        margin-left: 0.5rem;
      }
    `;
  }

  static get properties() {
    return {
      /**
       * Is true when the tab is selected
       */
      selected: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Links to a panel name
       */
      link: {
        type: String,
      },
      /**
       * Determines if the tab can be closed
       */
      closable: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();

    // property defaults
    this.selected = false;
  }

  firstUpdated() {
    this.addEventListener('click', this.select.bind(this));
  }

  updated() {
    this.a11y();
  }

  render() {
    return $`
      <slot></slot>
      ${this.makeCloseable()}
    `;
  }

  select() {
    /**
     * Fires when a tab is selected
     */
    this.dispatchEvent(new CustomEvent('kemet-tab-selected', {
      bubbles: true,
      composed: true,
      detail: this,
    }));
  }

  a11y() {
    this.setAttribute('role', 'tab');

    if (this.selected) {
      this.setAttribute('aria-selected', 'true');
      this.setAttribute('tabindex', '0');
    } else {
      this.setAttribute('aria-selected', 'false');
      this.setAttribute('tabindex', '-1');
    }
  }

  makeCloseable() {
    if (this.closable) {
      return $`<kemet-icon icon="x-lg" @click=${() => this.handleClosable()}></kemet-icon>`;
    }

    return null;
  }

  handleClosable() {
    /**
     * Fires when the tab should close
     */
    this.dispatchEvent(new CustomEvent('kemet-tab-close', {
      bubbles: true,
      composed: true,
      detail: this,
    }));
  }
}

customElements.define('kemet-tab', KemetTab);

const stylesKemetTabs = r$3`
  :host {
    --kemet-tabs-ink-size: 6px;
    --kemet-tabs-ink-radius: 6px;
    --kemet-tabs-divider-size: 1px;
    --kemet-tabs-spacer: 1rem;

    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }

  :host([placement='bottom']) {
    flex-direction: column-reverse;
  }

  :host([placement='left']) {
    flex-direction: row;
  }

  :host([placement='right']) {
    flex-direction: row-reverse;
  }

  :host([placement='left']),
  :host([placement='right']) {
    overflow: unset;
  }

  /* panels */

  [part='panels'] > div {
    display: flex;
  }

  :host([panel-effect='slide']) [part='panels'] {
    transition: transform var(--kemet-tabs-transition-speed, 0.5s) linear;
  }

  :host([panel-effect='fade']) [part='panels'] {
    transform: none !important;
  }

  :host([panel-effect='fade']) [part='panels'] > div {
    flex-flow: row nowrap;
  }

  :host([placement='left']) [part='panels'],
  :host([placement='right']) [part='panels'] {
    transform: none !important;
    position: relative;
    width: 100%;
  }

  :host([placement='top']) [part='panels'] > div {
    margin-top: var(--kemet-tabs-spacer);
  }

  :host([placement='right']) [part='panels'] > div {
    margin-right: var(--kemet-tabs-spacer);
  }

  :host([placement='bottom']) [part='panels'] > div {
    margin-bottom: var(--kemet-tabs-spacer);
  }

  :host([placement='left']) [part='panels'] > div {
    margin-left: var(--kemet-tabs-spacer);
  }

  /* tablist */

  [part='tablist'] {
    display: flex;
  }

  :host([placement='left']) [part='tablist'],
  :host([placement='right']) [part='tablist'] {
    display: flex;
    flex-direction: column;
    align-items: start;
  }

  :host([tabs-align='center']) [part='tablist'] {
    justify-content: center;
  }

  :host([tabs-align='between']) [part='tablist'] {
    justify-content: space-between;
  }

  :host([tabs-align='evenly']) [part='tablist'] {
    justify-content: space-evenly;
  }

  :host([tabs-align='around']) [part='tablist'] {
    justify-content: space-around
  }

  :host([tabs-align='start']) [part='tablist'] {
    justify-content: flex-start;
  }

  :host([tabs-align='end']) [part='tablist'] {
    justify-content: flex-end;
  }

  :host([overflow]) [part='tablist'] {
    justify-content: start;
  }

  /* divider */

  [part='divider'] {
    height: var(--kemet-tabs-divider-size);
    background-color: var(--kemet-tabs-divider-color, var(--kemet-color-gray4));
  }

  :host([placement='left']) [part='divider'],
  :host([placement='right']) [part='divider'] {
    width: var(--kemet-tabs-divider-size);
    height: auto;
  }

  /* ink */

  [part='ink'] {
    height: var(--kemet-tabs-ink-size);
    border-top-left-radius: var(--kemet-tabs-ink-radius);
    border-top-right-radius: var(--kemet-tabs-ink-radius);
    transition: all 300ms ease;
    background-color: var(--kemet-tabs-ink-color, var(--kemet-color-primary));
  }

  :host([placement='right']) [part='ink'] {
    width: var(--kemet-tabs-ink-size);
    border-top-right-radius: var(--kemet-tabs-ink-radius);
    border-bottom-right-radius: var(--kemet-tabs-ink-radius);
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  :host([placement='left']) [part='ink'] {
    width: var(--kemet-tabs-ink-size);
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-top-left-radius: var(--kemet-tabs-ink-radius);
    border-bottom-left-radius: var(--kemet-tabs-ink-radius);
  }

  :host([placement='bottom']) [part='ink'] {
    border-top-right-radius: 0px;
    border-bottom-right-radius: var(--kemet-tabs-ink-radius);
    border-top-left-radius: 0px;
    border-bottom-left-radius: var(--kemet-tabs-ink-radius);
  }

  /* links */

  :host([overflow]) [part='links'] {
    overflow-x: auto;
    margin: 0 2rem;
    scroll-behavior: smooth;
  }

  :host([overflow]) [part='links']::-webkit-scrollbar {
    display: none;
    width: 0;
    background: transparent;
  }

  :host([placement='bottom']) [part='links'] {
    display: flex;
    flex-direction: column-reverse;
  }

  /* icon */

  [icon*='chevron'] {
    cursor: pointer;
    position: absolute;
    top: 1rem;
  }

  [icon='chevron-left'] {
    left: 0;
  }

  [icon='chevron-right'] {
    right: 0;
  }

  :host([placement='bottom']) [icon*='chevron'] {
    top: auto;
    bottom: 1rem;
  }
`;

/* eslint-disable no-lonely-if */

class KemetTabs extends s$1 {
  static get styles() {
    return [stylesKemetTabs];
  }

  static get properties() {
    return {
      /**
       * The selected tab by name
       */
      selected: {
        type: String,
        reflect: true,
      },
      /**
       * The selected tab by index
       */
      selectedIndex: {
        type: Number,
      },
      /**
       * Positions the current panel
       */
      panelPosition: {
        type: Number,
      },
      /**
       * The transition effect for panels
       */
      panelEffect: {
        type: String,
        reflect: true,
        attribute: 'panel-effect',
      },
      /**
       * Determines whether or not to enable swipe behavior
       */
      swipe: {
        type: Boolean,
      },
      /**
       * Places the tabs to the top, right, bottom, or left
       */
      placement: {
        type: String,
        reflect: true,
      },
      /**
       * Determines whether or not to show a divider line
       */
      divider: {
        type: Boolean,
      },
      /**
       * Spacing alignment of the tabs
       */
      tabsAlign: {
        type: String,
        reflect: true,
        attribute: 'tabs-align',
      },
      /**
       * An object that contains information about the ink
       */
      ink: {
        type: Object,
      },
      /**
       * Determines whether or not to hide the ink
       */
      hideInk: {
        type: Boolean,
        attribute: 'hide-ink',
      },
      /**
       * Is true when the space of the tabs is larger than it's container
       */
      overflow: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.selectedIndex = 0;
    this.panelPosition = 0;
    this.panelEffect = 'none';
    this.placement = 'top';
    this.tabsAlign = 'center';
    this.hideInk = false;

    this.addEventListener('kemet-tab-selected', this.tabSelectedChange.bind(this));
    this.addEventListener('kemet-tab-close', this.handleTabClose.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  firstUpdated() {
    // standard properties
    this.tabs = [];
    this.panels = [];
    this.xDown = null;
    this.yDown = null;

    this.links = this.shadowRoot.getElementById('links');
  }

  render() {
    return $`
      ${this.makeLeftArrow()}
      ${this.makeRightArrow()}
      <div id="links" part="links">
        <div part='tablist' role="tablist">
          <slot name="tab" @slotchange=${() => this.handleLinksSlotChange()}></slot>
        </div>
        ${this.makeInk('links')}
      </div>
      ${this.makeInk('host')}
      ${this.makeDivider()}
      <section id="panels" part="panels" style="transform:translateX(${this.panelPosition}px);">
        <div>
          <slot name="panel" @slotchange=${() => this.handlePanelsSlotChange()}></slot>
        </div>
      </section>
    `;
  }

  updated() {
    this.determineFade();
  }

  handleLinksSlotChange() {
    const tabs = this.querySelectorAll('kemet-tab');
    let index = 0;

    tabs.forEach((tab) => {
      // give each tab an index to select by if link/panel is not used
      tab.index = index;
      index += 1;

      // store the list of tabs
      this.tabs = this.tabs.concat(tab);

      // add keyboard support
      tab.addEventListener('keydown', event => this.handleTabKeydown(event));
    });

    // default to the first tab/panel selected
    if (this.tabs.length > 0) this.tabs[0].selected = true;

    setTimeout(() => {
      this.selectTab();
    }, 1);
    this.determineOverflow();
  }

  handlePanelsSlotChange() {
    const panels = this.querySelectorAll('kemet-tab-panel');
    const panelElement = this.shadowRoot.getElementById('panels');
    let index = 0;

    panels.forEach((panel) => {
      // give each panel an index to select by if link/panel is not used
      panel.index = index;
      index += 1;

      // store the list of panels
      this.panels = this.panels.concat(panel);
    });

    // default to the first tab/panel selected
    if (this.panels.length > 0) this.panels[0].selected = true;

    // add swipe support
    if (this.swipe) {
      panelElement.addEventListener('touchstart', event => this.handleTouchStart(event), false);
      panelElement.addEventListener('touchmove', event => this.handleTouchMove(event), false);
    }

    this.selectPanel();
  }

  handleLeftArrow() {
    const selectedElement = this.tabs.find(tab => tab.selected) || this.tabs[0];
    const previousElement = selectedElement.previousElementSibling;
    const selectedIndex = this.tabs.findIndex(tab => tab.selected);

    if (this.selected) {
      this.selected = previousElement ? previousElement.link : selectedElement.link;
    } else {
      this.selectedIndex = selectedIndex > 0 ? selectedIndex - 1 : 0;
    }

    if (previousElement) {
      this.links.scrollLeft = previousElement.offsetLeft - 20;
    }

    this.selectTab();
    this.selectPanel();
  }

  handleRightArrow() {
    const selectedElement = this.tabs.find(tab => tab.selected) || this.tabs[this.tabs.length - 1];
    const nextElement = selectedElement.nextElementSibling;
    const selectedIndex = this.tabs.findIndex(tab => tab.selected);

    if (this.selected) {
      this.selected = nextElement ? nextElement.link : selectedElement.link;
    } else {
      this.selectedIndex = selectedIndex < this.tabs.length - 1
        ? selectedIndex + 1
        : this.tabs.length - 1;
    }

    if (nextElement) {
      this.links.scrollLeft = nextElement.offsetLeft - 20;
    }

    this.selectTab();
    this.selectPanel();
  }

  handleTabClose(event) {
    const tab = event.detail;
    const panel = this.panels[tab.index];

    this.selected = this.tabs[0].link;
    this.selectedIndex = 0;

    panel.remove();
    tab.remove();
  }

  makeInk(location) {
    if (this.hideInk) {
      return null;
    }

    if ((this.placement === 'top' || this.placement === 'bottom') && this.ink && location === 'links') {
      return $`<div part="ink" style="width:${this.ink.width}; transform:translateX(${this.ink.positionX})"></div>`;
    }

    if ((this.placement === 'left' || this.placement === 'right') && this.ink && location === 'host') {
      return $`<div part="ink" style="height:${this.ink.height}; transform:translateY(${this.ink.positionY})"></div>`;
    }

    return null;
  }

  makeDivider() {
    if (this.divider) {
      return $`<div part="divider"></div>`;
    }

    return null;
  }

  makeLeftArrow() {
    if (this.overflow) {
      return $`<kemet-icon icon='chevron-left' size="20" @click=${() => this.handleLeftArrow()}></kemet-icon>`;
    }

    return null;
  }

  makeRightArrow() {
    if (this.overflow) {
      return $`<kemet-icon icon='chevron-right' size="20" @click=${() => this.handleRightArrow()}></kemet-icon>`;
    }

    return null;
  }

  selectTab() {
    const marginLeft = this.links ? parseInt(window.getComputedStyle(this.links).marginLeft.replace('px', ''), 10) : 0;
    const overflowOffset = this.overflow ? marginLeft : 0;

    // if the user uses the selected attribute select by it
    if (this.selected) {
      this.tabs.forEach((tab) => {
        const tabName = tab.getAttribute('link');

        if (tabName === this.selected) {
          tab.selected = true;
          this.selected = tabName;

          this.ink = {
            width: `${tab.offsetWidth}px`,
            height: `${tab.offsetHeight}px`,
            positionX: `${tab.offsetLeft - overflowOffset}px`,
            positionY: `${tab.offsetTop}px`,
          };

          this.links.scrollLeft = tab.offsetLeft - overflowOffset;
        } else {
          tab.selected = false;
        }
      });

      // otherwise select by index
    } else {
      this.tabs.forEach((tab) => {
        if (this.selectedIndex === tab.index) {
          tab.selected = true;

          this.ink = {
            width: `${tab.offsetWidth}px`,
            height: `${tab.offsetHeight}px`,
            positionX: `${tab.offsetLeft - overflowOffset}px`,
            positionY: `${tab.offsetTop}px`,
          };

          this.links.scrollLeft = tab.offsetLeft - overflowOffset;
        } else {
          tab.selected = false;
        }
      });
    }
  }

  selectPanel() {
    // if the user uses the selected attribute select by it
    if (this.selected) {
      this.panels.forEach((panel) => {
        const panelName = panel.getAttribute('panel');

        if (this.panelEffect === 'fade' && panel.index !== 0) {
          panel.classList.add('push');
        }

        if (this.placement === 'left' || this.placement === 'right') {
          panel.classList.add('vertical');
        }

        if (panelName === this.selected) {
          panel.selected = true;
          this.animatePanel(panelName, null);
        } else {
          panel.selected = false;
        }
      });

      // otherwise select by index
    } else {
      this.panels.forEach((panel) => {
        if (this.panelEffect === 'fade' && panel.index !== 0) {
          panel.classList.add('push');
        }

        if (this.placement === 'left' || this.placement === 'right') {
          panel.classList.add('vertical');
        }

        if (this.selectedIndex === panel.index) {
          panel.selected = true;
          this.animatePanel(null, panel.index);
        } else {
          panel.selected = false;
        }
      });
    }
  }

  dispatchTabChange() {
    const tabChanged = new CustomEvent('kemet-tab-changed', {
      bubbles: true,
      composed: true,
      detail: this.selected,
    });

    this.dispatchEvent(tabChanged);
  }

  tabSelectedChange(event) {
    if (this.selected) {
      // if selected has been set, use the string attribute
      this.selected = event.detail.getAttribute('link');
    } else {
      // otherwise use the generated index
      this.selectedIndex = event.detail.index;
    }

    this.selectTab();
    this.selectPanel();
    this.dispatchTabChange();
  }

  determineFade() {
    this.panels.forEach((panel) => {
      // add fade class if panel effect is fade
      if (this.panelEffect === 'fade') panel.classList.add('fade');
    });
  }

  determineOverflow() {
    const tabsContainerWidth = this.offsetWidth;
    const tabElements = this.querySelectorAll('kemet-tab');

    let totalTabsWidth = 0;

    tabElements.forEach((tab) => {
      totalTabsWidth += tab.offsetWidth;
    });

    if (totalTabsWidth > tabsContainerWidth && (this.placement === 'top' || this.placement === 'bottom')) {
      this.overflow = true;
    } else {
      this.overflow = false;
    }
  }

  handleResize() {
    if (this.tabs && this.panels) {
      const marginLeft = this.links ? parseInt(window.getComputedStyle(this.links).marginLeft.replace('px', ''), 10) : 0;
      const overflowOffset = this.overflow ? marginLeft : 0;
      const selectedElement = this.tabs.find(tab => tab.selected);

      if (selectedElement) {
        this.ink = {
          width: `${selectedElement.offsetWidth}px`,
          height: `${selectedElement.offsetHeight}px`,
          positionX: `${selectedElement.offsetLeft - overflowOffset}px`,
          positionY: `${selectedElement.offsetTop}px`,
        };
      }

      this.determineOverflow();

      if (this.selected) {
        this.animatePanel(this.selected, null);
      } else {
        this.animatePanel(null, this.selectedIndex);
      }
    }
  }

  animatePanel(panelName, panelIndex) {
    if (panelName) {
      const selectedPanel = this.querySelector(`[panel="${panelName}"]`);
      if (selectedPanel) this.panelPosition = selectedPanel.offsetLeft * -1;
    } else {
      if (this.panels[panelIndex]) this.panelPosition = this.panels[panelIndex].offsetLeft * -1;
    }
  }

  handleTabKeydown(event) {
    if (this.selected) {
      switch (event.key) {
        case 'Home':
          this.selected = this.tabs[0].getAttribute('link');
          break;
        case 'End':
          this.selected = this.tabs[this.tabs.length - 1].getAttribute('link');
          break;
        case 'ArrowRight':
          const nextLinkElement = this.querySelector('kemet-tab[selected]').nextElementSibling;
          const nextLink = nextLinkElement ? nextLinkElement.getAttribute('link') : false;

          if (nextLink) {
            this.selected = nextLink;
          }
          break;
        case 'ArrowLeft':
          const previousLinkElement = this.querySelector('kemet-tab[selected]').previousElementSibling;
          const previousLink = previousLinkElement ? previousLinkElement.getAttribute('link') : false;

          if (previousLink) {
            this.selected = previousLink;
          }
          break;
      }

      this.tabs.find(tab => tab.link === this.selected).focus();
    } else {
      switch (event.key) {
        case 'Home':
          this.selectedIndex = 0;
          break;
        case 'End':
          this.selectedIndex = this.tabs.length - 1;
          break;
        case 'ArrowRight':
          if (this.selectedIndex < this.tabs.length - 1) {
            this.selectedIndex += 1;
          } else {
            this.selectedIndex = this.tabs.length - 1;
          }
          break;
        case 'ArrowLeft':
          if (this.selectedIndex < 1) {
            this.selectedIndex = 0;
          } else {
            this.selectedIndex -= 1;
          }
          break;
      }

      this.tabs[this.selectedIndex].focus();
    }
  }

  handleTouchStart(event) {
    this.xDown = event.touches[0].clientX;
    this.yDown = event.touches[0].clientY;
  }

  handleTouchMove(event) {
    if (!this.xDown || !this.yDown) {
      return;
    }

    const xUp = event.touches[0].clientX;
    const yUp = event.touches[0].clientY;
    const xDiff = this.xDown - xUp;
    const yDiff = this.yDown - yUp;
    const nextElement = this.querySelector('kemet-tab-panel[selected]').nextElementSibling;
    const next = nextElement ? nextElement.getAttribute('panel') : false;
    const previousElement = this.querySelector('kemet-tab-panel[selected]').previousElementSibling;
    const previous = previousElement ? previousElement.getAttribute('panel') : false;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        if (this.selected) {
          if (next) this.selected = next;
        } else {
          if (this.selectedIndex < this.tabs.length) this.selectedIndex += 1;
        }
      } else {
        if (this.selected) {
          if (previous) this.selected = previous;
        } else {
          if (this.selectedIndex > 0) this.selectedIndex -= 1;
        }
      }

      this.selectTab();
      this.selectPanel();
    }

    this.xDown = null;
    this.yDown = null;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-tabs') || customElements.define('kemet-tabs', KemetTabs);

class KemetTextarea extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          position: relative;
          display: block;
        }

        textarea {
          display: block;
          width: 100%;
          padding: var(--kemet-textarea-padding, 1rem);
          border: var(--kemet-textarea-border, 1px solid var(--kemet-color-primary));
          appearance: none;
          box-sizing: border-box;
        }

        :host([status='error']) textarea {
          border: var(--kemet-textarea-border-color-error, 1px solid var(--kemet-color-error));
        }

        :host([status='success']) textarea {
          border: var(--kemet-textarea-border-color-success, 1px solid var(--kemet-color-success));
        }

        :host([status='warning']) textarea {
          border: var(--kemet-textarea-border-color-warning, 1px solid var(--kemet-color-warning));
        }

        :host([disabled]) textarea {
          opacity: 0.5;
        }

        :host([icon-left]) textarea {
          padding-left: var(--kemet-textarea-icon-left-padding, 3rem);
        }

        :host([icon-right]) textarea {
          padding-right: var(--kemet-textarea-icon-right-padding, 3rem);
        }

        :host([rounded]) textarea {
          border-radius: var(--kemet-textarea-border-radius-rounded, var(--kemet-border-radius));
        }

        :host([filled]) textarea {
          border: var(--kemet-textarea-border-filled, none);
          color: var(--kemet-textarea-color-filled, var(--kemet-color-white));
          background-color: var(--kemet-textarea-background-color-filled, var(--kemet-color-primary));
        }

        :host([filled]) textarea::placeholder {
          color: var(--kemet-textarea-color-filled, var(--kemet-color-white));
        }

        :host([status='error'][filled]) textarea {
          background-color: var(--kemet-textarea-background-color-error, var(--kemet-color-error));
        }

        :host([status='success'][filled]) textarea {
          background-color: var(--kemet-textarea-background-color-success, var(--kemet-color-success));
        }

        :host([status='warning'][filled]) textarea {
          background-color: var(--kemet-textarea-background-color-warning, var(--kemet-color-warning));
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * Used for the id of the input
       */
      slug: {
        type: String,
      },
      /**
       * The name of the input
       */
      name: {
        type: String,
      },
      /**
       * The placeholder attribute
       */
      placeholder: {
        type: String,
      },
      /**
       * The minlength attribute
       */
      minlength: {
        type: String,
      },
      /**
       * The maxlength attribute
       */
      maxlength: {
        type: String,
      },
      /**
       * The input mode attribute
       */
      inputmode: {
        type: String,
      },
      /**
       * The autofocus attribute
       */
      autofocus: {
        type: Boolean,
      },
      /**
       * The disable attribute
       */
      disabled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The readonly attribute
       */
      readonly: {
        type: Boolean,
      },
      /**
       * The required attribute
       */
      required: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The input's value
       */
      value: {
        type: String,
      },
      /**
       * States whether or not the input is invalid
       */
      invalid: {
        type: Boolean,
        reflect: true,
      },
      /**
       * The status of the input
       */
      status: {
        type: String,
        reflect: true,
      },
      /**
       * The rows of the textarea
       */
      rows: {
        type: Number,
      },
      /**
       * Activates validation on blur
       */
      validateOnBlur: {
        type: Boolean,
        attribute: 'validate-on-blur',
      },
      /**
       * Displays a filled textarea
       */
      filled: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Displays a rounded corners
       */
      rounded: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor() {
    super();

    // managed properties
    this.slug = 'textarea';
    this.name = 'textarea';
    this.value = '';
    this.status = 'standard';
    this.rows = 4;

    /**
     * Used only for form reactive controller
     */
    this.formSubmitController = new FormSubmitController(this);
  }

  firstUpdated() {
    // elements
    this.form = this.closest('form');
    this.control = this.closest('kemet-field');
    this.textarea = this.shadowRoot.querySelector('textarea');
  }

  render() {
    return $`
      <textarea
        part="textarea"
        id=${this.slug}
        name=${this.name}
        .value=${l(this.value)}
        ?disabled=${this.disabled}
        ?readonly=${this.readonly}
        ?required=${this.required}
        placeholder=${l$1(this.placeholder)}
        rows=${l$1(this.rows)}
        minlength=${l$1(this.minlength)}
        maxlength=${l$1(this.maxlength)}
        autocorrect=${l$1(this.autocorrect)}
        ?autofocus=${this.autofocus}
        spellcheck=${l$1(this.spellcheck)}
        inputmode=${l$1(this.inputmode)}
        @change=${this.handleChange}
        @input=${this.handleInput}
        @focus=${this.handleFocus}
        @blur=${this.handleBlur}
        @invalid=${this.handleInvalid}
      ></textarea>
    `;
  }

  /**
   * Handles when the textarea receives focus
   * @private
   */
  handleFocus() {
    this.hasFocus = true;

    /**
     * Fires when the input receives and loses focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-focused', {
        bubbles: true,
        composed: true,
        detail: true,
      }),
    );
  }

  /**
   * Handles when the textarea loses focus
   * @private
   */
  handleBlur() {
    this.hasFocus = false;

    /**
     * Fires when the input receives and loses focus
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-focused', {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    );

    if (this.validateOnBlur && this.form && !this.form.noValidate) {
      this.textarea.checkValidity();
      this.validity = this.textarea.validity;
    }
  }

  /**
   * Handles when the textarea changes value
   * @private
   */
  handleChange() {
    this.value = this.textarea.value;

    if (this.textarea.checkValidity() && this.checkLimitValidity()) {
      this.invalid = false;
      this.status = 'standard';
      this.validity = this.textarea.validity;

      /**
       * Fires when there's a change in status
       */
      this.dispatchEvent(
        new CustomEvent('kemet-input-status', {
          bubbles: true,
          composed: true,
          detail: {
            status: 'standard',
            validity: this.textarea.validity,
            element: this,
          },
        }),
      );
    }
  }

  /**
   * Handles when the textarea receives input
   * @private
   */
  handleInput() {
    this.value = this.textarea.value;

    /**
     * Fires when the input receives input
     */
    this.dispatchEvent(
      new CustomEvent('kemet-input-input', {
        bubbles: true,
        composed: true,
        detail: this.value,
      }),
    );
  }

  /**
   * Handles when the textarea has an error
   * @private
   */
  handleInvalid() {
    this.validity = this.textarea.validity;

    if (this.validateOnBlur) {
      this.invalid = true;
      this.status = 'error';

      /**
       * Fires when there's a change in status
       */
      this.dispatchEvent(
        new CustomEvent('kemet-input-status', {
          bubbles: true,
          composed: true,
          detail: {
            status: 'error',
            validity: this.textarea.validity,
            element: this,
          },
        }),
      );
    }
  }

  /**
   * Checks the validity of the character limit for the count component
   * @private
   * @returns {boolean}
   */
  checkLimitValidity() {
    if (this.control) {
      const count = this.control.querySelector('kemet-count');
      if (count) {
        return this.value.length < count.limit;
      }
    }

    return true;
  }

  /**
   * Checks the validity of the standard input
   * @public
   * @returns {boolean}
   */
  checkValidity() {
    return this.textarea.checkValidity();
  }

  /**
   * Focuses the standard input
   * @public
   */
  focus() {
    return this.textarea.focus();
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-textarea') || customElements.define('kemet-textarea', KemetTextarea);

class KemetToggle extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          --kemet-toggle-width: 3.5rem;
          --kemet-toggle-height: 2rem;
          --kemet-toggle-handle-diameter: 1.6rem;
          --kemet-toggle-handle-margin: calc((var(--kemet-toggle-height) - var(--kemet-toggle-handle-diameter)) / 2);

          display: flex;
          align-items: center;
        }

        :host([disabled]) {
          opacity: 0.5;
        }

        label {
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 1rem;
          font-size: inherit;
          color: inherit;
        }

        :host([disabled]) label {
          cursor: not-allowed;
        }

        input {
          display: none;
        }

        [part='control'] {
          position: relative;
          display: inline-flex;
          margin: 0;
          width: var(--kemet-toggle-width);
          height: var(--kemet-toggle-height);
        }

        [part='control'] > span {
          transition: 300ms ease-in-out;
        }

        [part='track'] {
          width: var(--kemet-toggle-width);
          height: var(--kemet-toggle-height);
          border: var(--kemet-toggle-track-border, none);
          border-radius: var(--kemet-toggle-height);
          background-color: var(--kemet-toggle-track-color, var(--kemet-color-white));
          box-shadow: var(--kemet-toggle-track-shadow, inset 0 0.4rem 0.7rem 0 rgba(47, 47, 47, 0.35), inset 0 -0.2rem 0.4rem 0 var(--kemet-color-gray1));
        }

        :host([squared]) [part='track'] {
          border-radius: 0;
        }

        [part='handle'] {
          position: absolute;
          top: var(--kemet-toggle-handle-margin);
          left: var(--kemet-toggle-handle-margin);
          width: var(--kemet-toggle-handle-diameter);
          height: var(--kemet-toggle-handle-diameter);
          transform: translateX(0);
          border: var(--kemet-toggle-handle-border, none);
          border-radius: var(--kemet-toggle-handle-diameter);
          background-color: var(--kemet-toggle-handle-color, var(--kemet-color-primary));
          box-shadow: var(--kemet-toggle-handle-shadow, 0 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.1), 0 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.2));
        }

        :host([squared]) [part='handle'] {
          border-radius: 0;
        }

        :host([checked]) [part='handle'] {
          transform: translateX(calc(var(--kemet-toggle-width) - var(--kemet-toggle-handle-diameter) - var(--kemet-toggle-handle-margin) * 2));
        }

        .option {
          font-size: 90%;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The name on the input field
       */
      name: {
        type: String,
      },
      /**
       * Determines whether or not the toggle is checked
       */
      checked: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Determines whether or not the toggle is disabled
       */
      disabled: {
        type: Boolean,
      },
      /**
       * A description of the toggle's purpose
       */
      label: {
        type: String,
      },
      /**
       * Determines whether or not to show text options
       */
      show: {
        type: Boolean,
      },
      /**
       * Displays the toggle as squared instead of rounded
       */
      squared: {
        type: Boolean,
      },
      /**
       * The checked option text
       */
      optionChecked: {
        type: String,
        attribute: 'option-checked',
      },
      /**
       * The unchecked option text
       */
      optionUnchecked: {
        type: String,
        attribute: 'option-unchecked',
      },
    };
  }

  constructor() {
    super();

    this.name = 'toggle-switch';
    this.disabled = false;
    this.checked = false;
    this.show = false;
    this.squared = false;
    this.label = '';
    this.optionChecked = 'on';
    this.optionUnchecked = 'off';
    this.value = this.checked ? this.optionChecked : this.optionUnchecked;

    /**
     * Used only for form reactive controller
     */
    this.formSubmitController = new FormSubmitController(this);
  }

  render() {
    return $`
      <label part="label">
        ${this.makeUncheckedOption()}
        <span part="control">
          <span part="track"></span>
          <span part="handle"></span>
        </span>
        <input
          role="switch"
          type="checkbox"
          name="${this.name}"
          aria-label="${this.label}"
          aria-checked=${this.checked ? 'true' : 'false'}
          ?disabled=${this.disabled}
          ?checked=${this.checked}
          @change=${this.handleChange}
        />
        ${this.makeCheckedOption()}
        <span part="text">${this.label}</span>
      </label>
    `;
  }

  handleChange() {
    this.checked = !this.checked;
    this.value = this.checked ? this.optionChecked : this.optionUnchecked;

    /**
     * Fires when the toggle changes state
     */
    this.dispatchEvent(
      new CustomEvent('kemet-toggle-change', {
        bubbles: true,
        composed: true,
        detail: true,
      }),
    );
  }

  makeUncheckedOption() {
    if (this.show) {
      return $`<span class="option" part="unchecked">${this.optionUnchecked}</span>`;
    }

    return null;
  }

  makeCheckedOption() {
    if (this.show) {
      return $`<span class="option" part="checked">${this.optionChecked}</span>`;
    }

    return null;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-toggle') || customElements.define('kemet-toggle', KemetToggle);

class KemetTrackerStep extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          --kemet-tracker-step-dot-size: 50px;
          --kemet-tracker-step-dot-size-mobile: 25px;
          --kemet-tracker-step-dot-gap: 4px;
          --kemet-tracker-step-standard-line-weight: 1px;
          --kemet-tracker-step-completed-line-weight: 3px;
          --kemet-tracker-step-dot-transition: all 300ms ease-in-out;

          position: relative;
          width: 100%;
          text-align: center;
        }

        .dot {
          font-size: var(--kemet-tracker-step-dot-font-size, 90%);
          color: var(--kemet-tracker-step-dot-color, var(--kemet-color-primary));
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          position: relative;
          z-index: 1;
          width: var(--kemet-tracker-step-dot-size);
          height: var(--kemet-tracker-step-dot-size);
          border-radius: 100%;
          transition: var(--kemet-tracker-step-dot-transition);
          background-color: var(--kemet-tracker-step-dot-background-color, var(--kemet-color-white));
        }

        .dot::after {
          content: "";
          width: unset;
          height: unset;
          position: absolute;
          top: var(--kemet-tracker-step-dot-gap);
          left: var(--kemet-tracker-step-dot-gap);
          right: var(--kemet-tracker-step-dot-gap);
          bottom: var(--kemet-tracker-step-dot-gap);
          z-index: -1;
          border-radius: 100%;
          transition: var(--kemet-tracker-step-dot-transition);
          border: var(--kemet-tracker-step-dot-border, 1px solid var(--kemet-color-primary));
          background-color: var(--kemet-tracker-step-dot-fill-color, transparent);
        }

        :host([completed]) .dot {
          color: var(--kemet-tracker-step-completed-color, var(--kemet-color-white));
        }

        :host([completed]) .dot::after {
          border: 0;
          background-color: var(--kemet-tracker-step-completed-fill-color, var(--kemet-color-success));
        }

        :host([current]) .dot.animate {
          color: var(--kemet-tracker-step-current-color, var(--kemet-color-white));
        }

        :host([current]) .dot.animate::after {
          border: 0;
          background-color: var(--kemet-tracker-step-current-fill-color, var(--kemet-color-primary));
        }

        :host([mobile]) .dot {
          width: var(--kemet-tracker-step-dot-size-mobile);
          height: var(--kemet-tracker-step-dot-size-mobile);
        }

        .line {
          display: block;
          position: absolute;
          left: 50%;
          right: 0;
          bottom: 0;
          width: 100%;

          /* standard */
          top: calc((var(--kemet-tracker-step-dot-size) - var(--kemet-tracker-step-standard-line-weight)) / 2);
          height: var(--kemet-tracker-step-standard-line-weight);
          background-color: var(--kemet-tracker-step-line-color, var(--kemet-color-primary));
        }

        .line.completed {
          width: 100%;
          transform: scaleX(0);
          transform-origin: left center;
          top: calc((var(--kemet-tracker-step-dot-size) - var(--kemet-tracker-step-completed-line-weight)) / 2);
          height: var(--kemet-tracker-step-completed-line-weight);
          background-color: var(--kemet-tracker-step-completed-line-color, var(--kemet-color-primary));
          animation-name: grow;
          animation-delay: 1s;
          animation-duration: 600ms;
          animation-fill-mode: forwards;
        }

        :host([mobile]) .line {
          top: calc((var(--kemet-tracker-step-dot-size-mobile) - var(--kemet-tracker-step-standard-line-weight)) / 2);
        }

        :host([mobile]) .line.completed {
          top: calc((var(--kemet-tracker-step-dot-size-mobile) - var(--kemet-tracker-step-completed-line-weight)) / 2);
        }

        @keyframes grow {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The current step number
       */
      step: {
        type: Number,
      },
      /**
       * Determines whether or not a step renders as complete
       */
      completed: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Determines whether or not a step renders as the current step
       */
      current: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Is automatically added to the last step
       */
      last: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Determines if a step should render as mobile
       */
      mobile: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Hides the label inside of a dot
       */
      hideDotContent: {
        type: Boolean,
        reflect: true,
        attribute: 'hide-dot-content',
      },
      /**
       * The icon size for the completed check mark
       */
      completedSize: {
        type: Number,
      },
    };
  }

  constructor() {
    super();
    this.completedSize = 16;
  }

  firstUpdated() {
    this.tracker = this.closest('kemet-tracker');
  }

  render() {
    return $`
      ${this.makeLine()}
      ${this.makeCompletedLine()}
      <div class="dot" part="dot">${this.makeDotContent()}</div>
      ${this.makeSlotContent()}
    `;
  }

  makeLine() {
    if (!this.last) {
      return $`<div class="line" part="line"></div>`;
    }

    return null;
  }

  makeCompletedLine() {
    if (this.completed && !this.last) {
      return $`<div class="line completed" part="completed-line" @animationend=${() => this.handleCompletedLineEnd()}></div>`;
    }

    return null;
  }

  makeDotContent() {
    if (this.completed && !this.mobile && !this.hideDotContent) {
      return $`
        <kemet-icon icon="check2" size=${this.completedSize}></kemet-icon>
      `;
    }

    if (!this.mobile && !this.hideDotContent) {
      return $`
        <span>${this.step}/${this.tracker?.total}</span>
      `;
    }

    return null;
  }

  makeSlotContent() {
    if (!this.mobile) {
      return $`<slot></slot>`;
    }

    return null;
  }

  handleCompletedLineEnd() {
    const currentDot = this.tracker.querySelector('[current]').shadowRoot.querySelector('.dot');

    if (currentDot) {
      currentDot.classList.add('animate');
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-tracker-step') || customElements.define('kemet-tracker-step', KemetTrackerStep);

class KemetTracker extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          display: flex;
          justify-content: center;
          align-items: flex-start;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * The total number of steps
       */
      total: {
        type: Number,
      },
      /**
       * The point at which the tracker goes from mobile to standard
       */
      breakpoint: {
        type: String,
      },
    };
  }

  constructor() {
    super();
    this.breakpoint = '767px';
  }

  firstUpdated() {
    // elements
    this.steps = this.querySelectorAll('kemet-tracker-step');

    // methods exe
    this.isMobile();

    // events
    window.addEventListener('resize', () => {
      this.isMobile();
    });
  }

  render() {
    return $`<slot @slotchange=${() => this.handleSlotChange()}></slot>`;
  }

  handleSlotChange() {
    this.total = this.steps.length;

    this.steps.forEach((step, index) => {
      step.step = index + 1;
      if (step.step === this.total) {
        step.last = true;
      }
    });
  }

  isMobile() {
    const mediaQuery = window.matchMedia(`(max-width: ${this.breakpoint})`);

    this.steps.forEach((step) => {
      step.mobile = mediaQuery.matches;
    });
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-tracker') || customElements.define('kemet-tracker', KemetTracker);

const stylesLoaders = r$3`
  .lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }

  .lds-ripple div {
    position: absolute;
    border: 4px solid var(--kemet-upload-file-ripple-color);
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }

  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }

  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    4.9% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 0;
    }
    5% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
`;

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

class KemetUploadFile extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          --kemet-upload-file-ripple-color: var(--kemet-color-primary);

          color: var(--kemet-upload-file-color, var(--kemet-color-gray7));
          display: grid;
          gap: 1rem;
          grid-template-columns: auto 1fr auto;
          align-items: center;
          padding: var(--kemet-upload-file-padding, 0.5rem 1rem);
          border: var(--kemet-upload-file-border, 1px solid var(--kemet-color-primary));
        }

        :host([status='error']) {
          border: 1px solid var(--kemet-color-error);
        }

        :host([status='complete']) {
          border: 1px solid var(--kemet-color-success);
        }

        h3 {
          margin: 0;
        }

        .percentage {
          font-size: clamp(2rem, 3vw, 2.5rem);
          align-self: center;
          justify-self: center;
        }

        .indicator {
          transform: scale(0.8);
        }

        :host([status='complete']) .message,
        :host([status='complete']) .indicator {
          color: var(--kemet-color-success);
        }

        :host([status='error']) .message,
        :host([status='error']) .indicator {
          color: var(--kemet-color-error);
        }
      `,
      stylesLoaders,
    ];
  }

  static get properties() {
    return {
      /**
       * The name of the file
       */
      name: {
        type: String,
      },
      /**
       * The number of bytes loaded
       */
      loaded: {
        type: Number,
      },
      /**
       * The file size in bytes
       */
      size: {
        type: Number,
      },
      /**
       * The file type
       */
      type: {
        type: String,
      },
      /**
       * The status of the file. Values are complete | uploading | error.
       */
      status: {
        type: String,
        reflect: true,
      },
      /**
       * A percentage of file completion that's calculated by the loaded property
       */
      percent: {
        type: Number,
      },
      /**
       * An error message to give to users
       */
      message: {
        type: String,
      },
    };
  }

  constructor() {
    super();
    this.loaded = 0;
    this.size = 0;
    this.percent = 0;
  }

  updated() {
    this.percent = this.calculatePercent();
  }

  render() {
    return $`
      <div class="percentage" part="percentage">
        <span>${this.percent}%</span>
      </div>
      <div>
        <h3 part="filename">${this.name}</h3>
        <span part="loaded">${formatBytes(this.loaded)} / ${formatBytes(this.size)}</span>
        ${this.message ? $`<div class="message" part="message">${this.message}</div>` : null}
      </div>
      <div class="indicator" part="indicator">
        ${this.getStatusIcon()}
      </div>
    `;
  }

  calculatePercent() {
    const percent = Math.round((this.loaded * 100.0) / this.size);
    return percent > 100 ? 100 : percent;
  }

  getStatusIcon() {
    if (this.status === 'uploading') {
      return $`<div class="lds-ripple"><div></div><div></div></div>`;
    }

    if (this.status === 'complete') {
      return $`<kemet-icon icon="check-circle" size="48"></kemet-icon>`;
    }

    if (this.status === 'error') {
      return $`<kemet-icon icon="exclamation-circle" size="48"></kemet-icon>`;
    }

    return null;
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-upload-file') || customElements.define('kemet-upload-file', KemetUploadFile);

const preventDefaults = (event) => {
  event.preventDefault();
  event.stopPropagation();
};

class KemetUpload extends s$1 {
  static get styles() {
    return [
      r$3`
        :host {
          color: var(--kemet-upload-color, var(--kemet-color-white));
          display: grid;
          grid-template-columns: 1fr 1fr;
          height: var(--kemet-upload-height, 364px);
          border: var(--kemet-upload-border, 1rem solid var(--kemet-color-white));
          background-color: var(--kemet-upload-background-color, var(--kemet-color-primary));
        }

        :host([mobile]) {
          display: block;
          height: auto;
        }

        input {
          display: none;
        }

        .button {
          cursor: pointer;
          font-size: 1rem;
          display: block;
          color: var(--kemet-color-white);
          padding: 0.5rem 1rem;
          border: 1px solid var(--kemet-color-white);
          background-color: transparent;
        }

        .upload {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 1rem;
          flex-direction: column;
          border: 2px dashed var(--kemet-color-white);
        }

        :host([over]) .upload {
          background-color: green;
        }

        :host([mobile]) .upload {
          height: 280px;
        }

        .files {
          display: flex;
          gap: 1rem;
          flex-direction: column;
          padding: 0 1rem;
          overflow: auto;
          background-color: var(--kemet-color-white);
        }

        :host([mobile]) .files {
          padding: 0;
          max-height: 280px;
        }

        .heading {
          font-size: 1.25rem;
          margin: 0 0 2rem 0;
        }

        :host([no-drag-drop]) .heading {
          display: none;
        }

        ::slotted(:first-child) {
          margin-top: 1rem;
        }
      `,
    ];
  }

  static get properties() {
    return {
      /**
       * A unique identifier for the component
       */
      slug: {
        type: String,
      },
      /**
       * Determines what file types are accepted
       */
      accept: {
        type: String,
      },
      /**
       * Allows for multiple files
       */
      multiple: {
        type: Boolean,
      },
      /**
       * Automatically is true when a file is being dragged over the upload area
       */
      over: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Descriptive text for the upload area
       */
      heading: {
        type: String,
      },
      /**
       * Displays the component in a mobile context
       */
      mobile: {
        type: Boolean,
        reflect: true,
      },
      /**
       * Controls the point at which the component is considered mobile
       */
      breakpoint: {
        type: String,
        reflect: true,
      },
      /**
       * If true if drag and drop support is not detected
       */
      noDragDrop: {
        type: Boolean,
        reflect: true,
        attribute: 'no-drag-drop',
      },
      /**
       * The maximum file size for uploads
       */
      maxSize: {
        type: Number,
        attribute: 'max-size',
      },
      /**
       * The browse files button text
       */
      buttonLabel: {
        type: String,
        attribute: 'button-label',
      },
    };
  }

  constructor() {
    super();
    this.slug = 'upload';
    this.breakpoint = '600px';
    this.buttonLabel = 'Browse Files';
    this.heading = 'Drag & Drop Files';
  }

  firstUpdated() {
    this.fileInputElement = this.shadowRoot.querySelector('[type="file"]');
    this.upload = this.shadowRoot.querySelector('.upload');

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
      this.upload.addEventListener(eventName, event => preventDefaults(event), false);
    });

    ['dragenter', 'dragover'].forEach((eventName) => {
      this.upload.addEventListener(eventName, () => { this.over = true; }, false);
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      this.upload.addEventListener(eventName, () => { this.over = false; }, false);
    });

    this.isMobile();
    this.hasDragDrop();

    window.addEventListener('resize', () => { this.isMobile(); });
    this.upload.addEventListener('drop', event => this.handleDrop(event), false);
  }

  render() {
    return $`
      <div class="upload" part="upload">
        <kemet-icon icon="cloud-arrow-up" size="128"></kemet-icon>
        <input
          type="file"
          id=${this.slug}
          ?multiple=${this.multiple}
          accept=${l$1(this.accept) ? this.accept : null}
          @change=${event => this.handleChange(event)}
        />
        <h3 class="heading" part="heading">${this.heading}</h3>
        <label class="button" part="button" for=${this.slug}>${this.buttonLabel}</label>
      </div>
      <div class="files" part="files">
        <slot></slot>
      </div>
    `;
  }

  handleChange(event) {
    /**
     * Fires when files have been added
     */
    this.dispatchEvent(
      new CustomEvent('kemet-upload-change', {
        bubbles: true,
        composed: true,
        detail: {
          event,
          files: this.fileInputElement.files,
          fileElement: this.fileInputElement,
        },
      }),
    );
  }

  handleDrop(event) {
    /**
     * Fires when files have been added
     */
    this.dispatchEvent(
      new CustomEvent('kemet-upload-change', {
        bubbles: true,
        composed: true,
        detail: {
          event,
          files: event?.dataTransfer.files || [],
          fileElement: this.fileInputElement,
        },
      }),
    );
  }

  isMobile() {
    const mediaQuery = window.matchMedia(`(max-width: ${this.breakpoint})`);
    this.mobile = mediaQuery.matches;
  }

  hasDragDrop() {
    if ('draggable' in document.createElement('span')) {
      this.noDragDrop = false;
    } else {
      this.noDragDrop = true;
    }
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('kemet-upload') || customElements.define('kemet-upload', KemetUpload);

export { KemetCarouselCurrent, KemetCarouselFirst, KemetCarouselLast, KemetCarouselPrev, KemetCarouselTotal, customTooltip, fade, fall, flipHorizontal, flipVertical, scale, sign, slide, stylesKemetTabs, stylesLoaders, superScaled, tooltip };
